// Do not edit directly, this file was auto-generated.

export const tokens = {
  "primitive": {
    "color": {
      "greys": {
        "neutral": {
          "10": {
            "key": "{primitive.color.greys.neutral.10}",
            "value": "#0d0d0d",
            "type": "color",
            "original": {
              "value": "#0d0d0d",
              "type": "color",
              "key": "{primitive.color.greys.neutral.10}"
            },
            "name": "10",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "10"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "10"
            ]
          },
          "00": {
            "key": "{primitive.color.greys.neutral.00}",
            "value": "#fafafa",
            "type": "color",
            "original": {
              "value": "#fafafa",
              "type": "color",
              "key": "{primitive.color.greys.neutral.00}"
            },
            "name": "00",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "00"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "00"
            ]
          },
          "01": {
            "key": "{primitive.color.greys.neutral.01}",
            "value": "#f5f5f5",
            "type": "color",
            "original": {
              "value": "#f5f5f5",
              "type": "color",
              "key": "{primitive.color.greys.neutral.01}"
            },
            "name": "01",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "01"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "01"
            ]
          },
          "02": {
            "key": "{primitive.color.greys.neutral.02}",
            "value": "#eeeeee",
            "type": "color",
            "original": {
              "value": "#eeeeee",
              "type": "color",
              "key": "{primitive.color.greys.neutral.02}"
            },
            "name": "02",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "02"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "02"
            ]
          },
          "03": {
            "key": "{primitive.color.greys.neutral.03}",
            "value": "#e0e0e0",
            "type": "color",
            "original": {
              "value": "#e0e0e0",
              "type": "color",
              "key": "{primitive.color.greys.neutral.03}"
            },
            "name": "03",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "03"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "03"
            ]
          },
          "04": {
            "key": "{primitive.color.greys.neutral.04}",
            "value": "#bdbdbd",
            "type": "color",
            "original": {
              "value": "#bdbdbd",
              "type": "color",
              "key": "{primitive.color.greys.neutral.04}"
            },
            "name": "04",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "04"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "04"
            ]
          },
          "05": {
            "key": "{primitive.color.greys.neutral.05}",
            "value": "#9e9e9e",
            "type": "color",
            "original": {
              "value": "#9e9e9e",
              "type": "color",
              "key": "{primitive.color.greys.neutral.05}"
            },
            "name": "05",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "05"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "05"
            ]
          },
          "06": {
            "key": "{primitive.color.greys.neutral.06}",
            "value": "#757575",
            "type": "color",
            "original": {
              "value": "#757575",
              "type": "color",
              "key": "{primitive.color.greys.neutral.06}"
            },
            "name": "06",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "06"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "06"
            ]
          },
          "07": {
            "key": "{primitive.color.greys.neutral.07}",
            "value": "#616161",
            "type": "color",
            "original": {
              "value": "#616161",
              "type": "color",
              "key": "{primitive.color.greys.neutral.07}"
            },
            "name": "07",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "07"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "07"
            ]
          },
          "08": {
            "key": "{primitive.color.greys.neutral.08}",
            "value": "#383838",
            "type": "color",
            "original": {
              "value": "#383838",
              "type": "color",
              "key": "{primitive.color.greys.neutral.08}"
            },
            "name": "08",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "08"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "08"
            ]
          },
          "09": {
            "key": "{primitive.color.greys.neutral.09}",
            "value": "#212121",
            "type": "color",
            "original": {
              "value": "#212121",
              "type": "color",
              "key": "{primitive.color.greys.neutral.09}"
            },
            "name": "09",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "neutral",
              "state": "09"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "neutral",
              "09"
            ]
          }
        },
        "warm": {
          "10": {
            "key": "{primitive.color.greys.warm.10}",
            "value": "#1c1917",
            "type": "color",
            "original": {
              "value": "#1c1917",
              "type": "color",
              "key": "{primitive.color.greys.warm.10}"
            },
            "name": "10",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "10"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "10"
            ]
          },
          "00": {
            "key": "{primitive.color.greys.warm.00}",
            "value": "#fdfdfc",
            "type": "color",
            "original": {
              "value": "#fdfdfc",
              "type": "color",
              "key": "{primitive.color.greys.warm.00}"
            },
            "name": "00",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "00"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "00"
            ]
          },
          "01": {
            "key": "{primitive.color.greys.warm.01}",
            "value": "#fafaf9",
            "type": "color",
            "original": {
              "value": "#fafaf9",
              "type": "color",
              "key": "{primitive.color.greys.warm.01}"
            },
            "name": "01",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "01"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "01"
            ]
          },
          "02": {
            "key": "{primitive.color.greys.warm.02}",
            "value": "#f5f5f4",
            "type": "color",
            "original": {
              "value": "#f5f5f4",
              "type": "color",
              "key": "{primitive.color.greys.warm.02}"
            },
            "name": "02",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "02"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "02"
            ]
          },
          "03": {
            "key": "{primitive.color.greys.warm.03}",
            "value": "#e7e5e4",
            "type": "color",
            "original": {
              "value": "#e7e5e4",
              "type": "color",
              "key": "{primitive.color.greys.warm.03}"
            },
            "name": "03",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "03"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "03"
            ]
          },
          "04": {
            "key": "{primitive.color.greys.warm.04}",
            "value": "#d7d3d0",
            "type": "color",
            "original": {
              "value": "#d7d3d0",
              "type": "color",
              "key": "{primitive.color.greys.warm.04}"
            },
            "name": "04",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "04"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "04"
            ]
          },
          "05": {
            "key": "{primitive.color.greys.warm.05}",
            "value": "#a9a29d",
            "type": "color",
            "original": {
              "value": "#a9a29d",
              "type": "color",
              "key": "{primitive.color.greys.warm.05}"
            },
            "name": "05",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "05"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "05"
            ]
          },
          "06": {
            "key": "{primitive.color.greys.warm.06}",
            "value": "#79716b",
            "type": "color",
            "original": {
              "value": "#79716b",
              "type": "color",
              "key": "{primitive.color.greys.warm.06}"
            },
            "name": "06",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "06"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "06"
            ]
          },
          "07": {
            "key": "{primitive.color.greys.warm.07}",
            "value": "#57534e",
            "type": "color",
            "original": {
              "value": "#57534e",
              "type": "color",
              "key": "{primitive.color.greys.warm.07}"
            },
            "name": "07",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "07"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "07"
            ]
          },
          "08": {
            "key": "{primitive.color.greys.warm.08}",
            "value": "#44403c",
            "type": "color",
            "original": {
              "value": "#44403c",
              "type": "color",
              "key": "{primitive.color.greys.warm.08}"
            },
            "name": "08",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "08"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "08"
            ]
          },
          "09": {
            "key": "{primitive.color.greys.warm.09}",
            "value": "#292524",
            "type": "color",
            "original": {
              "value": "#292524",
              "type": "color",
              "key": "{primitive.color.greys.warm.09}"
            },
            "name": "09",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "warm",
              "state": "09"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "warm",
              "09"
            ]
          }
        },
        "cool": {
          "10": {
            "key": "{primitive.color.greys.cool.10}",
            "value": "#111322",
            "type": "color",
            "original": {
              "value": "#111322",
              "type": "color",
              "key": "{primitive.color.greys.cool.10}"
            },
            "name": "10",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "10"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "10"
            ]
          },
          "00": {
            "key": "{primitive.color.greys.cool.00}",
            "value": "#fcfcfd",
            "type": "color",
            "original": {
              "value": "#fcfcfd",
              "type": "color",
              "key": "{primitive.color.greys.cool.00}"
            },
            "name": "00",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "00"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "00"
            ]
          },
          "01": {
            "key": "{primitive.color.greys.cool.01}",
            "value": "#f9f9fb",
            "type": "color",
            "original": {
              "value": "#f9f9fb",
              "type": "color",
              "key": "{primitive.color.greys.cool.01}"
            },
            "name": "01",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "01"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "01"
            ]
          },
          "02": {
            "key": "{primitive.color.greys.cool.02}",
            "value": "#eff1f5",
            "type": "color",
            "original": {
              "value": "#eff1f5",
              "type": "color",
              "key": "{primitive.color.greys.cool.02}"
            },
            "name": "02",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "02"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "02"
            ]
          },
          "03": {
            "key": "{primitive.color.greys.cool.03}",
            "value": "#dcdfea",
            "type": "color",
            "original": {
              "value": "#dcdfea",
              "type": "color",
              "key": "{primitive.color.greys.cool.03}"
            },
            "name": "03",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "03"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "03"
            ]
          },
          "04": {
            "key": "{primitive.color.greys.cool.04}",
            "value": "#b9c0d4",
            "type": "color",
            "original": {
              "value": "#b9c0d4",
              "type": "color",
              "key": "{primitive.color.greys.cool.04}"
            },
            "name": "04",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "04"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "04"
            ]
          },
          "05": {
            "key": "{primitive.color.greys.cool.05}",
            "value": "#7d89b0",
            "type": "color",
            "original": {
              "value": "#7d89b0",
              "type": "color",
              "key": "{primitive.color.greys.cool.05}"
            },
            "name": "05",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "05"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "05"
            ]
          },
          "06": {
            "key": "{primitive.color.greys.cool.06}",
            "value": "#5d6b98",
            "type": "color",
            "original": {
              "value": "#5d6b98",
              "type": "color",
              "key": "{primitive.color.greys.cool.06}"
            },
            "name": "06",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "06"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "06"
            ]
          },
          "07": {
            "key": "{primitive.color.greys.cool.07}",
            "value": "#4a5578",
            "type": "color",
            "original": {
              "value": "#4a5578",
              "type": "color",
              "key": "{primitive.color.greys.cool.07}"
            },
            "name": "07",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "07"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "07"
            ]
          },
          "08": {
            "key": "{primitive.color.greys.cool.08}",
            "value": "#404968",
            "type": "color",
            "original": {
              "value": "#404968",
              "type": "color",
              "key": "{primitive.color.greys.cool.08}"
            },
            "name": "08",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "08"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "08"
            ]
          },
          "09": {
            "key": "{primitive.color.greys.cool.09}",
            "value": "#30374f",
            "type": "color",
            "original": {
              "value": "#30374f",
              "type": "color",
              "key": "{primitive.color.greys.cool.09}"
            },
            "name": "09",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "greys",
              "subitem": "cool",
              "state": "09"
            },
            "path": [
              "primitive",
              "color",
              "greys",
              "cool",
              "09"
            ]
          }
        }
      },
      "solids": {
        "moss": {
          "25": {
            "key": "{primitive.color.solids.moss.25}",
            "value": "#fafdf7",
            "type": "color",
            "original": {
              "value": "#fafdf7",
              "type": "color",
              "key": "{primitive.color.solids.moss.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.moss.50}",
            "value": "#f5fbee",
            "type": "color",
            "original": {
              "value": "#f5fbee",
              "type": "color",
              "key": "{primitive.color.solids.moss.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.moss.100}",
            "value": "#e6f4d7",
            "type": "color",
            "original": {
              "value": "#e6f4d7",
              "type": "color",
              "key": "{primitive.color.solids.moss.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.moss.200}",
            "value": "#ceeab0",
            "type": "color",
            "original": {
              "value": "#ceeab0",
              "type": "color",
              "key": "{primitive.color.solids.moss.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.moss.300}",
            "value": "#acdc79",
            "type": "color",
            "original": {
              "value": "#acdc79",
              "type": "color",
              "key": "{primitive.color.solids.moss.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.moss.400}",
            "value": "#86cb3c",
            "type": "color",
            "original": {
              "value": "#86cb3c",
              "type": "color",
              "key": "{primitive.color.solids.moss.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.moss.500}",
            "value": "#669f2a",
            "type": "color",
            "original": {
              "value": "#669f2a",
              "type": "color",
              "key": "{primitive.color.solids.moss.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.moss.600}",
            "value": "#4f7a21",
            "type": "color",
            "original": {
              "value": "#4f7a21",
              "type": "color",
              "key": "{primitive.color.solids.moss.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.moss.700}",
            "value": "#3f621a",
            "type": "color",
            "original": {
              "value": "#3f621a",
              "type": "color",
              "key": "{primitive.color.solids.moss.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.moss.800}",
            "value": "#3f621a",
            "type": "color",
            "original": {
              "value": "#3f621a",
              "type": "color",
              "key": "{primitive.color.solids.moss.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.moss.900}",
            "value": "#2b4212",
            "type": "color",
            "original": {
              "value": "#2b4212",
              "type": "color",
              "key": "{primitive.color.solids.moss.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.moss.1000}",
            "value": "#031a00",
            "type": "color",
            "original": {
              "value": "#031a00",
              "type": "color",
              "key": "{primitive.color.solids.moss.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "moss",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "moss",
              "1000"
            ]
          }
        },
        "light-green": {
          "25": {
            "key": "{primitive.color.solids.light-green.25}",
            "value": "#fafef5",
            "type": "color",
            "original": {
              "value": "#fafef5",
              "type": "color",
              "key": "{primitive.color.solids.light-green.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.light-green.50}",
            "value": "#f3fee7",
            "type": "color",
            "original": {
              "value": "#f3fee7",
              "type": "color",
              "key": "{primitive.color.solids.light-green.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.light-green.100}",
            "value": "#e3fbcc",
            "type": "color",
            "original": {
              "value": "#e3fbcc",
              "type": "color",
              "key": "{primitive.color.solids.light-green.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.light-green.200}",
            "value": "#d0f8ab",
            "type": "color",
            "original": {
              "value": "#d0f8ab",
              "type": "color",
              "key": "{primitive.color.solids.light-green.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.light-green.300}",
            "value": "#a6ef67",
            "type": "color",
            "original": {
              "value": "#a6ef67",
              "type": "color",
              "key": "{primitive.color.solids.light-green.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.light-green.400}",
            "value": "#85e13a",
            "type": "color",
            "original": {
              "value": "#85e13a",
              "type": "color",
              "key": "{primitive.color.solids.light-green.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.light-green.500}",
            "value": "#66c61c",
            "type": "color",
            "original": {
              "value": "#66c61c",
              "type": "color",
              "key": "{primitive.color.solids.light-green.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.light-green.600}",
            "value": "#4ca30d",
            "type": "color",
            "original": {
              "value": "#4ca30d",
              "type": "color",
              "key": "{primitive.color.solids.light-green.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.light-green.700}",
            "value": "#3b7c0f",
            "type": "color",
            "original": {
              "value": "#3b7c0f",
              "type": "color",
              "key": "{primitive.color.solids.light-green.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.light-green.800}",
            "value": "#326212",
            "type": "color",
            "original": {
              "value": "#326212",
              "type": "color",
              "key": "{primitive.color.solids.light-green.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.light-green.900}",
            "value": "#2b5314",
            "type": "color",
            "original": {
              "value": "#2b5314",
              "type": "color",
              "key": "{primitive.color.solids.light-green.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.light-green.1000}",
            "value": "#032b00",
            "type": "color",
            "original": {
              "value": "#032b00",
              "type": "color",
              "key": "{primitive.color.solids.light-green.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-green",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-green",
              "1000"
            ]
          }
        },
        "green": {
          "25": {
            "key": "{primitive.color.solids.green.25}",
            "value": "#f6fef9",
            "type": "color",
            "original": {
              "value": "#f6fef9",
              "type": "color",
              "key": "{primitive.color.solids.green.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.green.50}",
            "value": "#ecfdf3",
            "type": "color",
            "original": {
              "value": "#ecfdf3",
              "type": "color",
              "key": "{primitive.color.solids.green.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.green.100}",
            "value": "#d1fadf",
            "type": "color",
            "original": {
              "value": "#d1fadf",
              "type": "color",
              "key": "{primitive.color.solids.green.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.green.200}",
            "value": "#a6f4c5",
            "type": "color",
            "original": {
              "value": "#a6f4c5",
              "type": "color",
              "key": "{primitive.color.solids.green.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.green.300}",
            "value": "#6ce9a6",
            "type": "color",
            "original": {
              "value": "#6ce9a6",
              "type": "color",
              "key": "{primitive.color.solids.green.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.green.400}",
            "value": "#32d583",
            "type": "color",
            "original": {
              "value": "#32d583",
              "type": "color",
              "key": "{primitive.color.solids.green.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.green.500}",
            "value": "#12b76a",
            "type": "color",
            "original": {
              "value": "#12b76a",
              "type": "color",
              "key": "{primitive.color.solids.green.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.green.600}",
            "value": "#099250",
            "type": "color",
            "original": {
              "value": "#099250",
              "type": "color",
              "key": "{primitive.color.solids.green.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.green.700}",
            "value": "#027a48",
            "type": "color",
            "original": {
              "value": "#027a48",
              "type": "color",
              "key": "{primitive.color.solids.green.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.green.800}",
            "value": "#05603a",
            "type": "color",
            "original": {
              "value": "#05603a",
              "type": "color",
              "key": "{primitive.color.solids.green.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.green.900}",
            "value": "#054f31",
            "type": "color",
            "original": {
              "value": "#054f31",
              "type": "color",
              "key": "{primitive.color.solids.green.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.green.1000}",
            "value": "#002709",
            "type": "color",
            "original": {
              "value": "#002709",
              "type": "color",
              "key": "{primitive.color.solids.green.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "green",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "green",
              "1000"
            ]
          }
        },
        "teal": {
          "25": {
            "key": "{primitive.color.solids.teal.25}",
            "value": "#f6fefc",
            "type": "color",
            "original": {
              "value": "#f6fefc",
              "type": "color",
              "key": "{primitive.color.solids.teal.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.teal.50}",
            "value": "#f0fdf9",
            "type": "color",
            "original": {
              "value": "#f0fdf9",
              "type": "color",
              "key": "{primitive.color.solids.teal.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.teal.100}",
            "value": "#ccfbef",
            "type": "color",
            "original": {
              "value": "#ccfbef",
              "type": "color",
              "key": "{primitive.color.solids.teal.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.teal.200}",
            "value": "#99f6e0",
            "type": "color",
            "original": {
              "value": "#99f6e0",
              "type": "color",
              "key": "{primitive.color.solids.teal.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.teal.300}",
            "value": "#5fe9d0",
            "type": "color",
            "original": {
              "value": "#5fe9d0",
              "type": "color",
              "key": "{primitive.color.solids.teal.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.teal.400}",
            "value": "#2ed3b7",
            "type": "color",
            "original": {
              "value": "#2ed3b7",
              "type": "color",
              "key": "{primitive.color.solids.teal.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.teal.500}",
            "value": "#15b79e",
            "type": "color",
            "original": {
              "value": "#15b79e",
              "type": "color",
              "key": "{primitive.color.solids.teal.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.teal.600}",
            "value": "#0e9384",
            "type": "color",
            "original": {
              "value": "#0e9384",
              "type": "color",
              "key": "{primitive.color.solids.teal.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.teal.700}",
            "value": "#107569",
            "type": "color",
            "original": {
              "value": "#107569",
              "type": "color",
              "key": "{primitive.color.solids.teal.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.teal.800}",
            "value": "#125d56",
            "type": "color",
            "original": {
              "value": "#125d56",
              "type": "color",
              "key": "{primitive.color.solids.teal.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.teal.900}",
            "value": "#134e48",
            "type": "color",
            "original": {
              "value": "#134e48",
              "type": "color",
              "key": "{primitive.color.solids.teal.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.teal.1000}",
            "value": "#002620",
            "type": "color",
            "original": {
              "value": "#002620",
              "type": "color",
              "key": "{primitive.color.solids.teal.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "teal",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "teal",
              "1000"
            ]
          }
        },
        "cyan": {
          "25": {
            "key": "{primitive.color.solids.cyan.25}",
            "value": "#f5feff",
            "type": "color",
            "original": {
              "value": "#f5feff",
              "type": "color",
              "key": "{primitive.color.solids.cyan.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.cyan.50}",
            "value": "#ecfdff",
            "type": "color",
            "original": {
              "value": "#ecfdff",
              "type": "color",
              "key": "{primitive.color.solids.cyan.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.cyan.100}",
            "value": "#cff9fe",
            "type": "color",
            "original": {
              "value": "#cff9fe",
              "type": "color",
              "key": "{primitive.color.solids.cyan.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.cyan.200}",
            "value": "#a5f0fc",
            "type": "color",
            "original": {
              "value": "#a5f0fc",
              "type": "color",
              "key": "{primitive.color.solids.cyan.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.cyan.300}",
            "value": "#67e3f9",
            "type": "color",
            "original": {
              "value": "#67e3f9",
              "type": "color",
              "key": "{primitive.color.solids.cyan.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.cyan.400}",
            "value": "#22ccee",
            "type": "color",
            "original": {
              "value": "#22ccee",
              "type": "color",
              "key": "{primitive.color.solids.cyan.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.cyan.500}",
            "value": "#06aed4",
            "type": "color",
            "original": {
              "value": "#06aed4",
              "type": "color",
              "key": "{primitive.color.solids.cyan.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.cyan.600}",
            "value": "#088ab2",
            "type": "color",
            "original": {
              "value": "#088ab2",
              "type": "color",
              "key": "{primitive.color.solids.cyan.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.cyan.700}",
            "value": "#0e7090",
            "type": "color",
            "original": {
              "value": "#0e7090",
              "type": "color",
              "key": "{primitive.color.solids.cyan.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.cyan.800}",
            "value": "#155b75",
            "type": "color",
            "original": {
              "value": "#155b75",
              "type": "color",
              "key": "{primitive.color.solids.cyan.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.cyan.900}",
            "value": "#164c63",
            "type": "color",
            "original": {
              "value": "#164c63",
              "type": "color",
              "key": "{primitive.color.solids.cyan.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.cyan.1000}",
            "value": "#00243b",
            "type": "color",
            "original": {
              "value": "#00243b",
              "type": "color",
              "key": "{primitive.color.solids.cyan.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "cyan",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "cyan",
              "1000"
            ]
          }
        },
        "light-blue": {
          "25": {
            "key": "{primitive.color.solids.light-blue.25}",
            "value": "#f5fbff",
            "type": "color",
            "original": {
              "value": "#f5fbff",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.light-blue.50}",
            "value": "#f0f9ff",
            "type": "color",
            "original": {
              "value": "#f0f9ff",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.light-blue.100}",
            "value": "#e0f2fe",
            "type": "color",
            "original": {
              "value": "#e0f2fe",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.light-blue.200}",
            "value": "#b9e6fe",
            "type": "color",
            "original": {
              "value": "#b9e6fe",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.light-blue.300}",
            "value": "#7cd4fd",
            "type": "color",
            "original": {
              "value": "#7cd4fd",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.light-blue.400}",
            "value": "#36bffa",
            "type": "color",
            "original": {
              "value": "#36bffa",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.light-blue.500}",
            "value": "#0ba5ec",
            "type": "color",
            "original": {
              "value": "#0ba5ec",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.light-blue.600}",
            "value": "#0086c9",
            "type": "color",
            "original": {
              "value": "#0086c9",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.light-blue.700}",
            "value": "#026aa2",
            "type": "color",
            "original": {
              "value": "#026aa2",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.light-blue.800}",
            "value": "#065986",
            "type": "color",
            "original": {
              "value": "#065986",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.light-blue.900}",
            "value": "#0b4a6f",
            "type": "color",
            "original": {
              "value": "#0b4a6f",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.light-blue.1000}",
            "value": "#002247",
            "type": "color",
            "original": {
              "value": "#002247",
              "type": "color",
              "key": "{primitive.color.solids.light-blue.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "light-blue",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "light-blue",
              "1000"
            ]
          }
        },
        "blue": {
          "25": {
            "key": "{primitive.color.solids.blue.25}",
            "value": "#f5faff",
            "type": "color",
            "original": {
              "value": "#f5faff",
              "type": "color",
              "key": "{primitive.color.solids.blue.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.blue.50}",
            "value": "#eff8ff",
            "type": "color",
            "original": {
              "value": "#eff8ff",
              "type": "color",
              "key": "{primitive.color.solids.blue.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.blue.100}",
            "value": "#d1e9ff",
            "type": "color",
            "original": {
              "value": "#d1e9ff",
              "type": "color",
              "key": "{primitive.color.solids.blue.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.blue.200}",
            "value": "#8ed4ff",
            "type": "color",
            "original": {
              "value": "#8ed4ff",
              "type": "color",
              "key": "{primitive.color.solids.blue.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.blue.300}",
            "value": "#84caff",
            "type": "color",
            "original": {
              "value": "#84caff",
              "type": "color",
              "key": "{primitive.color.solids.blue.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.blue.400}",
            "value": "#53b1fd",
            "type": "color",
            "original": {
              "value": "#53b1fd",
              "type": "color",
              "key": "{primitive.color.solids.blue.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.blue.500}",
            "value": "#2e90fa",
            "type": "color",
            "original": {
              "value": "#2e90fa",
              "type": "color",
              "key": "{primitive.color.solids.blue.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.blue.600}",
            "value": "#1570ef",
            "type": "color",
            "original": {
              "value": "#1570ef",
              "type": "color",
              "key": "{primitive.color.solids.blue.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.blue.700}",
            "value": "#175cd3",
            "type": "color",
            "original": {
              "value": "#175cd3",
              "type": "color",
              "key": "{primitive.color.solids.blue.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.blue.800}",
            "value": "#1849a9",
            "type": "color",
            "original": {
              "value": "#1849a9",
              "type": "color",
              "key": "{primitive.color.solids.blue.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.blue.900}",
            "value": "#00359e",
            "type": "color",
            "original": {
              "value": "#00359e",
              "type": "color",
              "key": "{primitive.color.solids.blue.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.blue.1000}",
            "value": "#000d76",
            "type": "color",
            "original": {
              "value": "#000d76",
              "type": "color",
              "key": "{primitive.color.solids.blue.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "blue",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "blue",
              "1000"
            ]
          }
        },
        "dark-blue": {
          "25": {
            "key": "{primitive.color.solids.dark-blue.25}",
            "value": "#f5f8ff",
            "type": "color",
            "original": {
              "value": "#f5f8ff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.dark-blue.50}",
            "value": "#eff4ff",
            "type": "color",
            "original": {
              "value": "#eff4ff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.dark-blue.100}",
            "value": "#d1e0ff",
            "type": "color",
            "original": {
              "value": "#d1e0ff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.dark-blue.200}",
            "value": "#b2ccff",
            "type": "color",
            "original": {
              "value": "#b2ccff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.dark-blue.300}",
            "value": "#84adff",
            "type": "color",
            "original": {
              "value": "#84adff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.dark-blue.400}",
            "value": "#528bff",
            "type": "color",
            "original": {
              "value": "#528bff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.dark-blue.500}",
            "value": "#2970ff",
            "type": "color",
            "original": {
              "value": "#2970ff",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.dark-blue.600}",
            "value": "#155eef",
            "type": "color",
            "original": {
              "value": "#155eef",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.dark-blue.700}",
            "value": "#004eeb",
            "type": "color",
            "original": {
              "value": "#004eeb",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.dark-blue.800}",
            "value": "#0040c1",
            "type": "color",
            "original": {
              "value": "#0040c1",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.dark-blue.900}",
            "value": "#00359e",
            "type": "color",
            "original": {
              "value": "#00359e",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.dark-blue.1000}",
            "value": "#000d76",
            "type": "color",
            "original": {
              "value": "#000d76",
              "type": "color",
              "key": "{primitive.color.solids.dark-blue.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-blue",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-blue",
              "1000"
            ]
          }
        },
        "indigo": {
          "25": {
            "key": "{primitive.color.solids.indigo.25}",
            "value": "#f5f8ff",
            "type": "color",
            "original": {
              "value": "#f5f8ff",
              "type": "color",
              "key": "{primitive.color.solids.indigo.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.indigo.50}",
            "value": "#eef4ff",
            "type": "color",
            "original": {
              "value": "#eef4ff",
              "type": "color",
              "key": "{primitive.color.solids.indigo.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.indigo.100}",
            "value": "#e0eaff",
            "type": "color",
            "original": {
              "value": "#e0eaff",
              "type": "color",
              "key": "{primitive.color.solids.indigo.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.indigo.200}",
            "value": "#c7d7fe",
            "type": "color",
            "original": {
              "value": "#c7d7fe",
              "type": "color",
              "key": "{primitive.color.solids.indigo.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.indigo.300}",
            "value": "#a4bcfd",
            "type": "color",
            "original": {
              "value": "#a4bcfd",
              "type": "color",
              "key": "{primitive.color.solids.indigo.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.indigo.400}",
            "value": "#8098f9",
            "type": "color",
            "original": {
              "value": "#8098f9",
              "type": "color",
              "key": "{primitive.color.solids.indigo.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.indigo.500}",
            "value": "#6172f3",
            "type": "color",
            "original": {
              "value": "#6172f3",
              "type": "color",
              "key": "{primitive.color.solids.indigo.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.indigo.600}",
            "value": "#444ce7",
            "type": "color",
            "original": {
              "value": "#444ce7",
              "type": "color",
              "key": "{primitive.color.solids.indigo.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.indigo.700}",
            "value": "#3538cd",
            "type": "color",
            "original": {
              "value": "#3538cd",
              "type": "color",
              "key": "{primitive.color.solids.indigo.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.indigo.800}",
            "value": "#2d31a6",
            "type": "color",
            "original": {
              "value": "#2d31a6",
              "type": "color",
              "key": "{primitive.color.solids.indigo.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.indigo.900}",
            "value": "#2d3282",
            "type": "color",
            "original": {
              "value": "#2d3282",
              "type": "color",
              "key": "{primitive.color.solids.indigo.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.indigo.1000}",
            "value": "#050a5a",
            "type": "color",
            "original": {
              "value": "#050a5a",
              "type": "color",
              "key": "{primitive.color.solids.indigo.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "indigo",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "indigo",
              "1000"
            ]
          }
        },
        "violet": {
          "25": {
            "key": "{primitive.color.solids.violet.25}",
            "value": "#fbfaff",
            "type": "color",
            "original": {
              "value": "#fbfaff",
              "type": "color",
              "key": "{primitive.color.solids.violet.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.violet.50}",
            "value": "#f5f3ff",
            "type": "color",
            "original": {
              "value": "#f5f3ff",
              "type": "color",
              "key": "{primitive.color.solids.violet.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.violet.100}",
            "value": "#ece9fe",
            "type": "color",
            "original": {
              "value": "#ece9fe",
              "type": "color",
              "key": "{primitive.color.solids.violet.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.violet.200}",
            "value": "#ddd6fe",
            "type": "color",
            "original": {
              "value": "#ddd6fe",
              "type": "color",
              "key": "{primitive.color.solids.violet.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.violet.300}",
            "value": "#c3b5fd",
            "type": "color",
            "original": {
              "value": "#c3b5fd",
              "type": "color",
              "key": "{primitive.color.solids.violet.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.violet.400}",
            "value": "#a48afb",
            "type": "color",
            "original": {
              "value": "#a48afb",
              "type": "color",
              "key": "{primitive.color.solids.violet.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.violet.500}",
            "value": "#875bf7",
            "type": "color",
            "original": {
              "value": "#875bf7",
              "type": "color",
              "key": "{primitive.color.solids.violet.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.violet.600}",
            "value": "#7839ee",
            "type": "color",
            "original": {
              "value": "#7839ee",
              "type": "color",
              "key": "{primitive.color.solids.violet.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.violet.700}",
            "value": "#6927da",
            "type": "color",
            "original": {
              "value": "#6927da",
              "type": "color",
              "key": "{primitive.color.solids.violet.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.violet.800}",
            "value": "#5720b7",
            "type": "color",
            "original": {
              "value": "#5720b7",
              "type": "color",
              "key": "{primitive.color.solids.violet.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.violet.900}",
            "value": "#491c96",
            "type": "color",
            "original": {
              "value": "#491c96",
              "type": "color",
              "key": "{primitive.color.solids.violet.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.violet.1000}",
            "value": "#21006e",
            "type": "color",
            "original": {
              "value": "#21006e",
              "type": "color",
              "key": "{primitive.color.solids.violet.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "violet",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "violet",
              "1000"
            ]
          }
        },
        "purple": {
          "25": {
            "key": "{primitive.color.solids.purple.25}",
            "value": "#fafaff",
            "type": "color",
            "original": {
              "value": "#fafaff",
              "type": "color",
              "key": "{primitive.color.solids.purple.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.purple.50}",
            "value": "#f4f3ff",
            "type": "color",
            "original": {
              "value": "#f4f3ff",
              "type": "color",
              "key": "{primitive.color.solids.purple.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.purple.100}",
            "value": "#ebe9fe",
            "type": "color",
            "original": {
              "value": "#ebe9fe",
              "type": "color",
              "key": "{primitive.color.solids.purple.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.purple.200}",
            "value": "#d9d6fe",
            "type": "color",
            "original": {
              "value": "#d9d6fe",
              "type": "color",
              "key": "{primitive.color.solids.purple.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.purple.300}",
            "value": "#bdb4fe",
            "type": "color",
            "original": {
              "value": "#bdb4fe",
              "type": "color",
              "key": "{primitive.color.solids.purple.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.purple.400}",
            "value": "#9b8afb",
            "type": "color",
            "original": {
              "value": "#9b8afb",
              "type": "color",
              "key": "{primitive.color.solids.purple.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.purple.500}",
            "value": "#7a5af8",
            "type": "color",
            "original": {
              "value": "#7a5af8",
              "type": "color",
              "key": "{primitive.color.solids.purple.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.purple.600}",
            "value": "#6938ef",
            "type": "color",
            "original": {
              "value": "#6938ef",
              "type": "color",
              "key": "{primitive.color.solids.purple.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.purple.700}",
            "value": "#5925dc",
            "type": "color",
            "original": {
              "value": "#5925dc",
              "type": "color",
              "key": "{primitive.color.solids.purple.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.purple.800}",
            "value": "#4a1fb8",
            "type": "color",
            "original": {
              "value": "#4a1fb8",
              "type": "color",
              "key": "{primitive.color.solids.purple.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.purple.900}",
            "value": "#3e1c96",
            "type": "color",
            "original": {
              "value": "#3e1c96",
              "type": "color",
              "key": "{primitive.color.solids.purple.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.purple.1000}",
            "value": "#16006e",
            "type": "color",
            "original": {
              "value": "#16006e",
              "type": "color",
              "key": "{primitive.color.solids.purple.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "purple",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "purple",
              "1000"
            ]
          }
        },
        "fuchsia": {
          "25": {
            "key": "{primitive.color.solids.fuchsia.25}",
            "value": "#fefaff",
            "type": "color",
            "original": {
              "value": "#fefaff",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.fuchsia.50}",
            "value": "#fdf4ff",
            "type": "color",
            "original": {
              "value": "#fdf4ff",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.fuchsia.100}",
            "value": "#fbe8ff",
            "type": "color",
            "original": {
              "value": "#fbe8ff",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.fuchsia.200}",
            "value": "#f6d0fe",
            "type": "color",
            "original": {
              "value": "#f6d0fe",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.fuchsia.300}",
            "value": "#eeaafd",
            "type": "color",
            "original": {
              "value": "#eeaafd",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.fuchsia.400}",
            "value": "#e478fa",
            "type": "color",
            "original": {
              "value": "#e478fa",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.fuchsia.500}",
            "value": "#d444f1",
            "type": "color",
            "original": {
              "value": "#d444f1",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.fuchsia.600}",
            "value": "#ba24d5",
            "type": "color",
            "original": {
              "value": "#ba24d5",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.fuchsia.700}",
            "value": "#9f1ab1",
            "type": "color",
            "original": {
              "value": "#9f1ab1",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.fuchsia.800}",
            "value": "#821890",
            "type": "color",
            "original": {
              "value": "#821890",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.fuchsia.900}",
            "value": "#6f1877",
            "type": "color",
            "original": {
              "value": "#6f1877",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.fuchsia.1000}",
            "value": "#47004f",
            "type": "color",
            "original": {
              "value": "#47004f",
              "type": "color",
              "key": "{primitive.color.solids.fuchsia.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "fuchsia",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "fuchsia",
              "1000"
            ]
          }
        },
        "pink": {
          "25": {
            "key": "{primitive.color.solids.pink.25}",
            "value": "#fef6fb",
            "type": "color",
            "original": {
              "value": "#fef6fb",
              "type": "color",
              "key": "{primitive.color.solids.pink.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.pink.50}",
            "value": "#fdf2fa",
            "type": "color",
            "original": {
              "value": "#fdf2fa",
              "type": "color",
              "key": "{primitive.color.solids.pink.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.pink.100}",
            "value": "#fce7f6",
            "type": "color",
            "original": {
              "value": "#fce7f6",
              "type": "color",
              "key": "{primitive.color.solids.pink.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.pink.200}",
            "value": "#fcceee",
            "type": "color",
            "original": {
              "value": "#fcceee",
              "type": "color",
              "key": "{primitive.color.solids.pink.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.pink.300}",
            "value": "#faa7e0",
            "type": "color",
            "original": {
              "value": "#faa7e0",
              "type": "color",
              "key": "{primitive.color.solids.pink.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.pink.400}",
            "value": "#f670c7",
            "type": "color",
            "original": {
              "value": "#f670c7",
              "type": "color",
              "key": "{primitive.color.solids.pink.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.pink.500}",
            "value": "#ee46bc",
            "type": "color",
            "original": {
              "value": "#ee46bc",
              "type": "color",
              "key": "{primitive.color.solids.pink.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.pink.600}",
            "value": "#dd2590",
            "type": "color",
            "original": {
              "value": "#dd2590",
              "type": "color",
              "key": "{primitive.color.solids.pink.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.pink.700}",
            "value": "#c11574",
            "type": "color",
            "original": {
              "value": "#c11574",
              "type": "color",
              "key": "{primitive.color.solids.pink.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.pink.800}",
            "value": "#9e165f",
            "type": "color",
            "original": {
              "value": "#9e165f",
              "type": "color",
              "key": "{primitive.color.solids.pink.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.pink.900}",
            "value": "#851651",
            "type": "color",
            "original": {
              "value": "#851651",
              "type": "color",
              "key": "{primitive.color.solids.pink.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.pink.1000}",
            "value": "#670033",
            "type": "color",
            "original": {
              "value": "#670033",
              "type": "color",
              "key": "{primitive.color.solids.pink.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "pink",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "pink",
              "1000"
            ]
          }
        },
        "ros": {
          "25": {
            "key": "{primitive.color.solids.ros.25}",
            "value": "#fff5f6",
            "type": "color",
            "original": {
              "value": "#fff5f6",
              "type": "color",
              "key": "{primitive.color.solids.ros.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.ros.50}",
            "value": "#fff1f3",
            "type": "color",
            "original": {
              "value": "#fff1f3",
              "type": "color",
              "key": "{primitive.color.solids.ros.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.ros.100}",
            "value": "#ffe4e8",
            "type": "color",
            "original": {
              "value": "#ffe4e8",
              "type": "color",
              "key": "{primitive.color.solids.ros.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.ros.200}",
            "value": "#fecdd6",
            "type": "color",
            "original": {
              "value": "#fecdd6",
              "type": "color",
              "key": "{primitive.color.solids.ros.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.ros.300}",
            "value": "#fea3b4",
            "type": "color",
            "original": {
              "value": "#fea3b4",
              "type": "color",
              "key": "{primitive.color.solids.ros.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.ros.400}",
            "value": "#fd6f8e",
            "type": "color",
            "original": {
              "value": "#fd6f8e",
              "type": "color",
              "key": "{primitive.color.solids.ros.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.ros.500}",
            "value": "#f63d68",
            "type": "color",
            "original": {
              "value": "#f63d68",
              "type": "color",
              "key": "{primitive.color.solids.ros.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.ros.600}",
            "value": "#e31b54",
            "type": "color",
            "original": {
              "value": "#e31b54",
              "type": "color",
              "key": "{primitive.color.solids.ros.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.ros.700}",
            "value": "#c01048",
            "type": "color",
            "original": {
              "value": "#c01048",
              "type": "color",
              "key": "{primitive.color.solids.ros.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.ros.800}",
            "value": "#a11043",
            "type": "color",
            "original": {
              "value": "#a11043",
              "type": "color",
              "key": "{primitive.color.solids.ros.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.ros.900}",
            "value": "#89123e",
            "type": "color",
            "original": {
              "value": "#89123e",
              "type": "color",
              "key": "{primitive.color.solids.ros.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.ros.1000}",
            "value": "#610016",
            "type": "color",
            "original": {
              "value": "#610016",
              "type": "color",
              "key": "{primitive.color.solids.ros.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "ros",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "ros",
              "1000"
            ]
          }
        },
        "red": {
          "25": {
            "key": "{primitive.color.solids.red.25}",
            "value": "#fffbfa",
            "type": "color",
            "original": {
              "value": "#fffbfa",
              "type": "color",
              "key": "{primitive.color.solids.red.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.red.50}",
            "value": "#fef3f2",
            "type": "color",
            "original": {
              "value": "#fef3f2",
              "type": "color",
              "key": "{primitive.color.solids.red.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.red.100}",
            "value": "#fee4e2",
            "type": "color",
            "original": {
              "value": "#fee4e2",
              "type": "color",
              "key": "{primitive.color.solids.red.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.red.200}",
            "value": "#fecdca",
            "type": "color",
            "original": {
              "value": "#fecdca",
              "type": "color",
              "key": "{primitive.color.solids.red.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.red.300}",
            "value": "#fda29b",
            "type": "color",
            "original": {
              "value": "#fda29b",
              "type": "color",
              "key": "{primitive.color.solids.red.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.red.400}",
            "value": "#f97066",
            "type": "color",
            "original": {
              "value": "#f97066",
              "type": "color",
              "key": "{primitive.color.solids.red.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.red.500}",
            "value": "#f04438",
            "type": "color",
            "original": {
              "value": "#f04438",
              "type": "color",
              "key": "{primitive.color.solids.red.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.red.600}",
            "value": "#d92d20",
            "type": "color",
            "original": {
              "value": "#d92d20",
              "type": "color",
              "key": "{primitive.color.solids.red.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.red.700}",
            "value": "#b42318",
            "type": "color",
            "original": {
              "value": "#b42318",
              "type": "color",
              "key": "{primitive.color.solids.red.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.red.800}",
            "value": "#912018",
            "type": "color",
            "original": {
              "value": "#912018",
              "type": "color",
              "key": "{primitive.color.solids.red.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.red.900}",
            "value": "#7a271a",
            "type": "color",
            "original": {
              "value": "#7a271a",
              "type": "color",
              "key": "{primitive.color.solids.red.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.red.1000}",
            "value": "#520000",
            "type": "color",
            "original": {
              "value": "#520000",
              "type": "color",
              "key": "{primitive.color.solids.red.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "red",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "red",
              "1000"
            ]
          }
        },
        "dark-orange": {
          "25": {
            "key": "{primitive.color.solids.dark-orange.25}",
            "value": "#fff9f5",
            "type": "color",
            "original": {
              "value": "#fff9f5",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.dark-orange.50}",
            "value": "#fff4ed",
            "type": "color",
            "original": {
              "value": "#fff4ed",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.dark-orange.100}",
            "value": "#ffe6d5",
            "type": "color",
            "original": {
              "value": "#ffe6d5",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.dark-orange.200}",
            "value": "#ffd6ae",
            "type": "color",
            "original": {
              "value": "#ffd6ae",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.dark-orange.300}",
            "value": "#ff9c66",
            "type": "color",
            "original": {
              "value": "#ff9c66",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.dark-orange.400}",
            "value": "#ff692e",
            "type": "color",
            "original": {
              "value": "#ff692e",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.dark-orange.500}",
            "value": "#ff4405",
            "type": "color",
            "original": {
              "value": "#ff4405",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.dark-orange.600}",
            "value": "#e62e05",
            "type": "color",
            "original": {
              "value": "#e62e05",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.dark-orange.700}",
            "value": "#bc1b06",
            "type": "color",
            "original": {
              "value": "#bc1b06",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.dark-orange.800}",
            "value": "#932f19",
            "type": "color",
            "original": {
              "value": "#932f19",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.dark-orange.900}",
            "value": "#771a0d",
            "type": "color",
            "original": {
              "value": "#771a0d",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.dark-orange.1000}",
            "value": "#4f0000",
            "type": "color",
            "original": {
              "value": "#4f0000",
              "type": "color",
              "key": "{primitive.color.solids.dark-orange.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "dark-orange",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "dark-orange",
              "1000"
            ]
          }
        },
        "orange": {
          "25": {
            "key": "{primitive.color.solids.orange.25}",
            "value": "#fefaf5",
            "type": "color",
            "original": {
              "value": "#fefaf5",
              "type": "color",
              "key": "{primitive.color.solids.orange.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.orange.50}",
            "value": "#fef6ee",
            "type": "color",
            "original": {
              "value": "#fef6ee",
              "type": "color",
              "key": "{primitive.color.solids.orange.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.orange.100}",
            "value": "#fdead7",
            "type": "color",
            "original": {
              "value": "#fdead7",
              "type": "color",
              "key": "{primitive.color.solids.orange.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.orange.200}",
            "value": "#f9dbaf",
            "type": "color",
            "original": {
              "value": "#f9dbaf",
              "type": "color",
              "key": "{primitive.color.solids.orange.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.orange.300}",
            "value": "#f7b27a",
            "type": "color",
            "original": {
              "value": "#f7b27a",
              "type": "color",
              "key": "{primitive.color.solids.orange.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.orange.400}",
            "value": "#f38744",
            "type": "color",
            "original": {
              "value": "#f38744",
              "type": "color",
              "key": "{primitive.color.solids.orange.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.orange.500}",
            "value": "#ef6820",
            "type": "color",
            "original": {
              "value": "#ef6820",
              "type": "color",
              "key": "{primitive.color.solids.orange.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.orange.600}",
            "value": "#e04f16",
            "type": "color",
            "original": {
              "value": "#e04f16",
              "type": "color",
              "key": "{primitive.color.solids.orange.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.orange.700}",
            "value": "#b93815",
            "type": "color",
            "original": {
              "value": "#b93815",
              "type": "color",
              "key": "{primitive.color.solids.orange.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.orange.800}",
            "value": "#932f19",
            "type": "color",
            "original": {
              "value": "#932f19",
              "type": "color",
              "key": "{primitive.color.solids.orange.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.orange.900}",
            "value": "#771a0d",
            "type": "color",
            "original": {
              "value": "#771a0d",
              "type": "color",
              "key": "{primitive.color.solids.orange.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.orange.1000}",
            "value": "#4f0000",
            "type": "color",
            "original": {
              "value": "#4f0000",
              "type": "color",
              "key": "{primitive.color.solids.orange.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "orange",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "orange",
              "1000"
            ]
          }
        },
        "yellow": {
          "25": {
            "key": "{primitive.color.solids.yellow.25}",
            "value": "#fefdf0",
            "type": "color",
            "original": {
              "value": "#fefdf0",
              "type": "color",
              "key": "{primitive.color.solids.yellow.25}"
            },
            "name": "25",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "25"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "25"
            ]
          },
          "50": {
            "key": "{primitive.color.solids.yellow.50}",
            "value": "#fefbe8",
            "type": "color",
            "original": {
              "value": "#fefbe8",
              "type": "color",
              "key": "{primitive.color.solids.yellow.50}"
            },
            "name": "50",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "50"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "50"
            ]
          },
          "100": {
            "key": "{primitive.color.solids.yellow.100}",
            "value": "#fef7c3",
            "type": "color",
            "original": {
              "value": "#fef7c3",
              "type": "color",
              "key": "{primitive.color.solids.yellow.100}"
            },
            "name": "100",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "100"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "100"
            ]
          },
          "200": {
            "key": "{primitive.color.solids.yellow.200}",
            "value": "#feee95",
            "type": "color",
            "original": {
              "value": "#feee95",
              "type": "color",
              "key": "{primitive.color.solids.yellow.200}"
            },
            "name": "200",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "200"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "200"
            ]
          },
          "300": {
            "key": "{primitive.color.solids.yellow.300}",
            "value": "#fde272",
            "type": "color",
            "original": {
              "value": "#fde272",
              "type": "color",
              "key": "{primitive.color.solids.yellow.300}"
            },
            "name": "300",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "300"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "300"
            ]
          },
          "400": {
            "key": "{primitive.color.solids.yellow.400}",
            "value": "#fac515",
            "type": "color",
            "original": {
              "value": "#fac515",
              "type": "color",
              "key": "{primitive.color.solids.yellow.400}"
            },
            "name": "400",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "400"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "400"
            ]
          },
          "500": {
            "key": "{primitive.color.solids.yellow.500}",
            "value": "#eaaa08",
            "type": "color",
            "original": {
              "value": "#eaaa08",
              "type": "color",
              "key": "{primitive.color.solids.yellow.500}"
            },
            "name": "500",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "500"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "500"
            ]
          },
          "600": {
            "key": "{primitive.color.solids.yellow.600}",
            "value": "#ca8504",
            "type": "color",
            "original": {
              "value": "#ca8504",
              "type": "color",
              "key": "{primitive.color.solids.yellow.600}"
            },
            "name": "600",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "600"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "600"
            ]
          },
          "700": {
            "key": "{primitive.color.solids.yellow.700}",
            "value": "#a15c07",
            "type": "color",
            "original": {
              "value": "#a15c07",
              "type": "color",
              "key": "{primitive.color.solids.yellow.700}"
            },
            "name": "700",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "700"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "700"
            ]
          },
          "800": {
            "key": "{primitive.color.solids.yellow.800}",
            "value": "#854a0e",
            "type": "color",
            "original": {
              "value": "#854a0e",
              "type": "color",
              "key": "{primitive.color.solids.yellow.800}"
            },
            "name": "800",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "800"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "800"
            ]
          },
          "900": {
            "key": "{primitive.color.solids.yellow.900}",
            "value": "#713b12",
            "type": "color",
            "original": {
              "value": "#713b12",
              "type": "color",
              "key": "{primitive.color.solids.yellow.900}"
            },
            "name": "900",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "900"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "900"
            ]
          },
          "1000": {
            "key": "{primitive.color.solids.yellow.1000}",
            "value": "#491300",
            "type": "color",
            "original": {
              "value": "#491300",
              "type": "color",
              "key": "{primitive.color.solids.yellow.1000}"
            },
            "name": "1000",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "solids",
              "subitem": "yellow",
              "state": "1000"
            },
            "path": [
              "primitive",
              "color",
              "solids",
              "yellow",
              "1000"
            ]
          }
        }
      },
      "transparencies": {
        "black": {
          "5-percent": {
            "key": "{primitive.color.transparencies.black.5-percent}",
            "value": "rgba(0, 0, 0, 0.05)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.05)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.5-percent}"
            },
            "name": "5-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "5-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "5-percent"
            ]
          },
          "10-percent": {
            "key": "{primitive.color.transparencies.black.10-percent}",
            "value": "rgba(0, 0, 0, 0.1)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.1)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.10-percent}"
            },
            "name": "10-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "10-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "10-percent"
            ]
          },
          "20-percent": {
            "key": "{primitive.color.transparencies.black.20-percent}",
            "value": "rgba(0, 0, 0, 0.2)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.2)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.20-percent}"
            },
            "name": "20-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "20-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "20-percent"
            ]
          },
          "30-percent": {
            "key": "{primitive.color.transparencies.black.30-percent}",
            "value": "rgba(0, 0, 0, 0.3)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.3)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.30-percent}"
            },
            "name": "30-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "30-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "30-percent"
            ]
          },
          "40-percent": {
            "key": "{primitive.color.transparencies.black.40-percent}",
            "value": "rgba(0, 0, 0, 0.4)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.4)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.40-percent}"
            },
            "name": "40-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "40-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "40-percent"
            ]
          },
          "50-percent": {
            "key": "{primitive.color.transparencies.black.50-percent}",
            "value": "rgba(0, 0, 0, 0.5)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.5)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.50-percent}"
            },
            "name": "50-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "50-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "50-percent"
            ]
          },
          "60-percent": {
            "key": "{primitive.color.transparencies.black.60-percent}",
            "value": "rgba(0, 0, 0, 0.6)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.6)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.60-percent}"
            },
            "name": "60-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "60-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "60-percent"
            ]
          },
          "70-percent": {
            "key": "{primitive.color.transparencies.black.70-percent}",
            "value": "rgba(0, 0, 0, 0.7)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.7)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.70-percent}"
            },
            "name": "70-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "70-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "70-percent"
            ]
          },
          "80-percent": {
            "key": "{primitive.color.transparencies.black.80-percent}",
            "value": "rgba(0, 0, 0, 0.8)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.8)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.80-percent}"
            },
            "name": "80-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "80-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "80-percent"
            ]
          },
          "90-percent": {
            "key": "{primitive.color.transparencies.black.90-percent}",
            "value": "rgba(0, 0, 0, 0.9)",
            "type": "color",
            "original": {
              "value": "rgba(0, 0, 0, 0.9)",
              "type": "color",
              "key": "{primitive.color.transparencies.black.90-percent}"
            },
            "name": "90-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "black",
              "state": "90-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "black",
              "90-percent"
            ]
          }
        },
        "white": {
          "10-percent": {
            "key": "{primitive.color.transparencies.white.10-percent}",
            "value": "rgba(255, 255, 255, 0.1)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.1)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.10-percent}"
            },
            "name": "10-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "10-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "10-percent"
            ]
          },
          "20-percent": {
            "key": "{primitive.color.transparencies.white.20-percent}",
            "value": "rgba(255, 255, 255, 0.2)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.2)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.20-percent}"
            },
            "name": "20-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "20-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "20-percent"
            ]
          },
          "30-percent": {
            "key": "{primitive.color.transparencies.white.30-percent}",
            "value": "rgba(255, 255, 255, 0.3)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.3)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.30-percent}"
            },
            "name": "30-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "30-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "30-percent"
            ]
          },
          "40-percent": {
            "key": "{primitive.color.transparencies.white.40-percent}",
            "value": "rgba(255, 255, 255, 0.4)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.4)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.40-percent}"
            },
            "name": "40-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "40-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "40-percent"
            ]
          },
          "50-percent": {
            "key": "{primitive.color.transparencies.white.50-percent}",
            "value": "rgba(255, 255, 255, 0.5)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.5)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.50-percent}"
            },
            "name": "50-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "50-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "50-percent"
            ]
          },
          "60-percent": {
            "key": "{primitive.color.transparencies.white.60-percent}",
            "value": "rgba(255, 255, 255, 0.6)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.6)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.60-percent}"
            },
            "name": "60-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "60-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "60-percent"
            ]
          },
          "70-percent": {
            "key": "{primitive.color.transparencies.white.70-percent}",
            "value": "rgba(255, 255, 255, 0.7)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.7)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.70-percent}"
            },
            "name": "70-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "70-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "70-percent"
            ]
          },
          "80-percent": {
            "key": "{primitive.color.transparencies.white.80-percent}",
            "value": "rgba(255, 255, 255, 0.8)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.8)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.80-percent}"
            },
            "name": "80-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "80-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "80-percent"
            ]
          },
          "90-percent": {
            "key": "{primitive.color.transparencies.white.90-percent}",
            "value": "rgba(255, 255, 255, 0.9)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.9)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.90-percent}"
            },
            "name": "90-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "90-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "90-percent"
            ]
          },
          "5-percent": {
            "key": "{primitive.color.transparencies.white.5-percent}",
            "value": "rgba(255, 255, 255, 0.05)",
            "type": "color",
            "original": {
              "value": "rgba(255, 255, 255, 0.05)",
              "type": "color",
              "key": "{primitive.color.transparencies.white.5-percent}"
            },
            "name": "5-percent",
            "attributes": {
              "category": "primitive",
              "type": "color",
              "item": "transparencies",
              "subitem": "white",
              "state": "5-percent"
            },
            "path": [
              "primitive",
              "color",
              "transparencies",
              "white",
              "5-percent"
            ]
          }
        }
      }
    },
    "float": {
      "dimensions": {
        "2ppi": {
          "key": "{primitive.float.dimensions.2ppi}",
          "value": -2,
          "type": "number",
          "original": {
            "value": -2,
            "type": "number",
            "key": "{primitive.float.dimensions.2ppi}"
          },
          "name": "2ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "2ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "2ppi"
          ]
        },
        "4dppi": {
          "key": "{primitive.float.dimensions.4dppi}",
          "value": 4,
          "type": "number",
          "original": {
            "value": 4,
            "type": "number",
            "key": "{primitive.float.dimensions.4dppi}"
          },
          "name": "4dppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "4dppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "4dppi"
          ]
        },
        "8dppi": {
          "key": "{primitive.float.dimensions.8dppi}",
          "value": 8,
          "type": "number",
          "original": {
            "value": 8,
            "type": "number",
            "key": "{primitive.float.dimensions.8dppi}"
          },
          "name": "8dppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "8dppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "8dppi"
          ]
        },
        "12ppi": {
          "key": "{primitive.float.dimensions.12ppi}",
          "value": -12,
          "type": "number",
          "original": {
            "value": -12,
            "type": "number",
            "key": "{primitive.float.dimensions.12ppi}"
          },
          "name": "12ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "12ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "12ppi"
          ]
        },
        "16ppi": {
          "key": "{primitive.float.dimensions.16ppi}",
          "value": -16,
          "type": "number",
          "original": {
            "value": -16,
            "type": "number",
            "key": "{primitive.float.dimensions.16ppi}"
          },
          "name": "16ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "16ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "16ppi"
          ]
        },
        "24ppi": {
          "key": "{primitive.float.dimensions.24ppi}",
          "value": 24,
          "type": "number",
          "original": {
            "value": 24,
            "type": "number",
            "key": "{primitive.float.dimensions.24ppi}"
          },
          "name": "24ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "24ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "24ppi"
          ]
        },
        "32ppi": {
          "key": "{primitive.float.dimensions.32ppi}",
          "value": 32,
          "type": "number",
          "original": {
            "value": 32,
            "type": "number",
            "key": "{primitive.float.dimensions.32ppi}"
          },
          "name": "32ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "32ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "32ppi"
          ]
        },
        "48ppi": {
          "key": "{primitive.float.dimensions.48ppi}",
          "value": 48,
          "type": "number",
          "original": {
            "value": 48,
            "type": "number",
            "key": "{primitive.float.dimensions.48ppi}"
          },
          "name": "48ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "48ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "48ppi"
          ]
        },
        "40ppi": {
          "key": "{primitive.float.dimensions.40ppi}",
          "value": 40,
          "type": "number",
          "original": {
            "value": 40,
            "type": "number",
            "key": "{primitive.float.dimensions.40ppi}"
          },
          "name": "40ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "40ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "40ppi"
          ]
        },
        "56ppi": {
          "key": "{primitive.float.dimensions.56ppi}",
          "value": 56,
          "type": "number",
          "original": {
            "value": 56,
            "type": "number",
            "key": "{primitive.float.dimensions.56ppi}"
          },
          "name": "56ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "56ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "56ppi"
          ]
        },
        "64ppi": {
          "key": "{primitive.float.dimensions.64ppi}",
          "value": 64,
          "type": "number",
          "original": {
            "value": 64,
            "type": "number",
            "key": "{primitive.float.dimensions.64ppi}"
          },
          "name": "64ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "64ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "64ppi"
          ]
        },
        "72ppi": {
          "key": "{primitive.float.dimensions.72ppi}",
          "value": 72,
          "type": "number",
          "original": {
            "value": 72,
            "type": "number",
            "key": "{primitive.float.dimensions.72ppi}"
          },
          "name": "72ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "72ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "72ppi"
          ]
        },
        "80ppi": {
          "key": "{primitive.float.dimensions.80ppi}",
          "value": 80,
          "type": "number",
          "original": {
            "value": 80,
            "type": "number",
            "key": "{primitive.float.dimensions.80ppi}"
          },
          "name": "80ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "80ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "80ppi"
          ]
        },
        "88ppi": {
          "key": "{primitive.float.dimensions.88ppi}",
          "value": 88,
          "type": "number",
          "original": {
            "value": 88,
            "type": "number",
            "key": "{primitive.float.dimensions.88ppi}"
          },
          "name": "88ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "88ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "88ppi"
          ]
        },
        "96ppi": {
          "key": "{primitive.float.dimensions.96ppi}",
          "value": 96,
          "type": "number",
          "original": {
            "value": 96,
            "type": "number",
            "key": "{primitive.float.dimensions.96ppi}"
          },
          "name": "96ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "96ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "96ppi"
          ]
        },
        "104ppi": {
          "key": "{primitive.float.dimensions.104ppi}",
          "value": 104,
          "type": "number",
          "original": {
            "value": 104,
            "type": "number",
            "key": "{primitive.float.dimensions.104ppi}"
          },
          "name": "104ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "104ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "104ppi"
          ]
        },
        "112ppi": {
          "key": "{primitive.float.dimensions.112ppi}",
          "value": 112,
          "type": "number",
          "original": {
            "value": 112,
            "type": "number",
            "key": "{primitive.float.dimensions.112ppi}"
          },
          "name": "112ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "112ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "112ppi"
          ]
        },
        "120ppi": {
          "key": "{primitive.float.dimensions.120ppi}",
          "value": 120,
          "type": "number",
          "original": {
            "value": 120,
            "type": "number",
            "key": "{primitive.float.dimensions.120ppi}"
          },
          "name": "120ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "120ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "120ppi"
          ]
        },
        "128ppi": {
          "key": "{primitive.float.dimensions.128ppi}",
          "value": 128,
          "type": "number",
          "original": {
            "value": 128,
            "type": "number",
            "key": "{primitive.float.dimensions.128ppi}"
          },
          "name": "128ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "128ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "128ppi"
          ]
        },
        "14ppi": {
          "key": "{primitive.float.dimensions.14ppi}",
          "value": 14,
          "type": "number",
          "original": {
            "value": 14,
            "type": "number",
            "key": "{primitive.float.dimensions.14ppi}"
          },
          "name": "14ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "14ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "14ppi"
          ]
        },
        "10ppi": {
          "key": "{primitive.float.dimensions.10ppi}",
          "value": -10,
          "type": "number",
          "original": {
            "value": -10,
            "type": "number",
            "key": "{primitive.float.dimensions.10ppi}"
          },
          "name": "10ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "10ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "10ppi"
          ]
        },
        "0ppi": {
          "key": "{primitive.float.dimensions.0ppi}",
          "value": 0,
          "type": "number",
          "original": {
            "value": 0,
            "type": "number",
            "key": "{primitive.float.dimensions.0ppi}"
          },
          "name": "0ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "0ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "0ppi"
          ]
        },
        "20ppi": {
          "key": "{primitive.float.dimensions.20ppi}",
          "value": 20,
          "type": "number",
          "original": {
            "value": 20,
            "type": "number",
            "key": "{primitive.float.dimensions.20ppi}"
          },
          "name": "20ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "20ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "20ppi"
          ]
        },
        "1ppi": {
          "key": "{primitive.float.dimensions.1ppi}",
          "value": -1,
          "type": "number",
          "original": {
            "value": -1,
            "type": "number",
            "key": "{primitive.float.dimensions.1ppi}"
          },
          "name": "1ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "1ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "1ppi"
          ]
        },
        "18ppi": {
          "key": "{primitive.float.dimensions.18ppi}",
          "value": 18,
          "type": "number",
          "original": {
            "value": 18,
            "type": "number",
            "key": "{primitive.float.dimensions.18ppi}"
          },
          "name": "18ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "18ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "18ppi"
          ]
        },
        "4ppi": {
          "key": "{primitive.float.dimensions.4ppi}",
          "value": -4,
          "type": "number",
          "original": {
            "value": -4,
            "type": "number",
            "key": "{primitive.float.dimensions.4ppi}"
          },
          "name": "4ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "4ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "4ppi"
          ]
        },
        "8ppi": {
          "key": "{primitive.float.dimensions.8ppi}",
          "value": -8,
          "type": "number",
          "original": {
            "value": -8,
            "type": "number",
            "key": "{primitive.float.dimensions.8ppi}"
          },
          "name": "8ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "8ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "8ppi"
          ]
        },
        "14ppi-2": {
          "key": "{primitive.float.dimensions.14ppi-2}",
          "value": -14,
          "type": "number",
          "original": {
            "value": -14,
            "type": "number",
            "key": "{primitive.float.dimensions.14ppi-2}"
          },
          "name": "14ppi-2",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "14ppi-2"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "14ppi-2"
          ]
        },
        "52pp": {
          "key": "{primitive.float.dimensions.52pp}",
          "value": 52,
          "type": "number",
          "original": {
            "value": 52,
            "type": "number",
            "key": "{primitive.float.dimensions.52pp}"
          },
          "name": "52pp",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "52pp"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "52pp"
          ]
        },
        "6dppi": {
          "key": "{primitive.float.dimensions.6dppi}",
          "value": 6,
          "type": "number",
          "original": {
            "value": 6,
            "type": "number",
            "key": "{primitive.float.dimensions.6dppi}"
          },
          "name": "6dppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "6dppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "6dppi"
          ]
        },
        "36ppi": {
          "key": "{primitive.float.dimensions.36ppi}",
          "value": 36,
          "type": "number",
          "original": {
            "value": 36,
            "type": "number",
            "key": "{primitive.float.dimensions.36ppi}"
          },
          "name": "36ppi",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "dimensions",
            "subitem": "36ppi"
          },
          "path": [
            "primitive",
            "float",
            "dimensions",
            "36ppi"
          ]
        }
      },
      "opacity": {
        "5-percent": {
          "key": "{primitive.float.opacity.5-percent}",
          "value": 5,
          "type": "number",
          "original": {
            "value": 5,
            "type": "number",
            "key": "{primitive.float.opacity.5-percent}"
          },
          "name": "5-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "5-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "5-percent"
          ]
        },
        "10-percent": {
          "key": "{primitive.float.opacity.10-percent}",
          "value": 10,
          "type": "number",
          "original": {
            "value": 10,
            "type": "number",
            "key": "{primitive.float.opacity.10-percent}"
          },
          "name": "10-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "10-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "10-percent"
          ]
        },
        "15-percent": {
          "key": "{primitive.float.opacity.15-percent}",
          "value": 15,
          "type": "number",
          "original": {
            "value": 15,
            "type": "number",
            "key": "{primitive.float.opacity.15-percent}"
          },
          "name": "15-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "15-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "15-percent"
          ]
        },
        "20-percent": {
          "key": "{primitive.float.opacity.20-percent}",
          "value": 20,
          "type": "number",
          "original": {
            "value": 20,
            "type": "number",
            "key": "{primitive.float.opacity.20-percent}"
          },
          "name": "20-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "20-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "20-percent"
          ]
        },
        "25-percent": {
          "key": "{primitive.float.opacity.25-percent}",
          "value": 25,
          "type": "number",
          "original": {
            "value": 25,
            "type": "number",
            "key": "{primitive.float.opacity.25-percent}"
          },
          "name": "25-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "25-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "25-percent"
          ]
        },
        "30-percent": {
          "key": "{primitive.float.opacity.30-percent}",
          "value": 30,
          "type": "number",
          "original": {
            "value": 30,
            "type": "number",
            "key": "{primitive.float.opacity.30-percent}"
          },
          "name": "30-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "30-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "30-percent"
          ]
        },
        "35-percent": {
          "key": "{primitive.float.opacity.35-percent}",
          "value": 35,
          "type": "number",
          "original": {
            "value": 35,
            "type": "number",
            "key": "{primitive.float.opacity.35-percent}"
          },
          "name": "35-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "35-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "35-percent"
          ]
        },
        "40-percent": {
          "key": "{primitive.float.opacity.40-percent}",
          "value": 40,
          "type": "number",
          "original": {
            "value": 40,
            "type": "number",
            "key": "{primitive.float.opacity.40-percent}"
          },
          "name": "40-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "40-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "40-percent"
          ]
        },
        "45-percent": {
          "key": "{primitive.float.opacity.45-percent}",
          "value": 45,
          "type": "number",
          "original": {
            "value": 45,
            "type": "number",
            "key": "{primitive.float.opacity.45-percent}"
          },
          "name": "45-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "45-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "45-percent"
          ]
        },
        "50-percent": {
          "key": "{primitive.float.opacity.50-percent}",
          "value": 50,
          "type": "number",
          "original": {
            "value": 50,
            "type": "number",
            "key": "{primitive.float.opacity.50-percent}"
          },
          "name": "50-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "50-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "50-percent"
          ]
        },
        "55-percent": {
          "key": "{primitive.float.opacity.55-percent}",
          "value": 55,
          "type": "number",
          "original": {
            "value": 55,
            "type": "number",
            "key": "{primitive.float.opacity.55-percent}"
          },
          "name": "55-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "55-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "55-percent"
          ]
        },
        "60-percent": {
          "key": "{primitive.float.opacity.60-percent}",
          "value": 60,
          "type": "number",
          "original": {
            "value": 60,
            "type": "number",
            "key": "{primitive.float.opacity.60-percent}"
          },
          "name": "60-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "60-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "60-percent"
          ]
        },
        "65-percent": {
          "key": "{primitive.float.opacity.65-percent}",
          "value": 65,
          "type": "number",
          "original": {
            "value": 65,
            "type": "number",
            "key": "{primitive.float.opacity.65-percent}"
          },
          "name": "65-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "65-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "65-percent"
          ]
        },
        "75-percent": {
          "key": "{primitive.float.opacity.75-percent}",
          "value": 75,
          "type": "number",
          "original": {
            "value": 75,
            "type": "number",
            "key": "{primitive.float.opacity.75-percent}"
          },
          "name": "75-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "75-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "75-percent"
          ]
        },
        "80-percent": {
          "key": "{primitive.float.opacity.80-percent}",
          "value": 80,
          "type": "number",
          "original": {
            "value": 80,
            "type": "number",
            "key": "{primitive.float.opacity.80-percent}"
          },
          "name": "80-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "80-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "80-percent"
          ]
        },
        "85-percent": {
          "key": "{primitive.float.opacity.85-percent}",
          "value": 85,
          "type": "number",
          "original": {
            "value": 85,
            "type": "number",
            "key": "{primitive.float.opacity.85-percent}"
          },
          "name": "85-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "85-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "85-percent"
          ]
        },
        "90-percent": {
          "key": "{primitive.float.opacity.90-percent}",
          "value": 90,
          "type": "number",
          "original": {
            "value": 90,
            "type": "number",
            "key": "{primitive.float.opacity.90-percent}"
          },
          "name": "90-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "90-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "90-percent"
          ]
        },
        "95-percent": {
          "key": "{primitive.float.opacity.95-percent}",
          "value": 95,
          "type": "number",
          "original": {
            "value": 95,
            "type": "number",
            "key": "{primitive.float.opacity.95-percent}"
          },
          "name": "95-percent",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "opacity",
            "subitem": "95-percent"
          },
          "path": [
            "primitive",
            "float",
            "opacity",
            "95-percent"
          ]
        }
      },
      "typography": {
        "weight": {
          "bold": {
            "key": "{primitive.float.typography.weight.bold}",
            "value": 700,
            "type": "number",
            "original": {
              "value": 700,
              "type": "number",
              "key": "{primitive.float.typography.weight.bold}"
            },
            "name": "bold",
            "attributes": {
              "category": "primitive",
              "type": "float",
              "item": "typography",
              "subitem": "weight",
              "state": "bold"
            },
            "path": [
              "primitive",
              "float",
              "typography",
              "weight",
              "bold"
            ]
          },
          "semi-bold": {
            "key": "{primitive.float.typography.weight.semi-bold}",
            "value": 600,
            "type": "number",
            "original": {
              "value": 600,
              "type": "number",
              "key": "{primitive.float.typography.weight.semi-bold}"
            },
            "name": "semi-bold",
            "attributes": {
              "category": "primitive",
              "type": "float",
              "item": "typography",
              "subitem": "weight",
              "state": "semi-bold"
            },
            "path": [
              "primitive",
              "float",
              "typography",
              "weight",
              "semi-bold"
            ]
          },
          "medium": {
            "key": "{primitive.float.typography.weight.medium}",
            "value": 500,
            "type": "number",
            "original": {
              "value": 500,
              "type": "number",
              "key": "{primitive.float.typography.weight.medium}"
            },
            "name": "medium",
            "attributes": {
              "category": "primitive",
              "type": "float",
              "item": "typography",
              "subitem": "weight",
              "state": "medium"
            },
            "path": [
              "primitive",
              "float",
              "typography",
              "weight",
              "medium"
            ]
          },
          "regular": {
            "key": "{primitive.float.typography.weight.regular}",
            "value": 400,
            "type": "number",
            "original": {
              "value": 400,
              "type": "number",
              "key": "{primitive.float.typography.weight.regular}"
            },
            "name": "regular",
            "attributes": {
              "category": "primitive",
              "type": "float",
              "item": "typography",
              "subitem": "weight",
              "state": "regular"
            },
            "path": [
              "primitive",
              "float",
              "typography",
              "weight",
              "regular"
            ]
          },
          "light": {
            "key": "{primitive.float.typography.weight.light}",
            "value": 300,
            "type": "number",
            "original": {
              "value": 300,
              "type": "number",
              "key": "{primitive.float.typography.weight.light}"
            },
            "name": "light",
            "attributes": {
              "category": "primitive",
              "type": "float",
              "item": "typography",
              "subitem": "weight",
              "state": "light"
            },
            "path": [
              "primitive",
              "float",
              "typography",
              "weight",
              "light"
            ]
          }
        }
      },
      "breakpoint": {
        "min-width": {
          "key": "{primitive.float.breakpoint.min-width}",
          "value": 375,
          "type": "number",
          "original": {
            "value": 375,
            "type": "number",
            "key": "{primitive.float.breakpoint.min-width}"
          },
          "name": "min-width",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "breakpoint",
            "subitem": "min-width"
          },
          "path": [
            "primitive",
            "float",
            "breakpoint",
            "min-width"
          ]
        },
        "max-width": {
          "key": "{primitive.float.breakpoint.max-width}",
          "value": 671,
          "type": "number",
          "original": {
            "value": 671,
            "type": "number",
            "key": "{primitive.float.breakpoint.max-width}"
          },
          "name": "max-width",
          "attributes": {
            "category": "primitive",
            "type": "float",
            "item": "breakpoint",
            "subitem": "max-width"
          },
          "path": [
            "primitive",
            "float",
            "breakpoint",
            "max-width"
          ]
        }
      }
    },
    "string": {
      "typography": {
        "font-family": {
          "dm-serif-display": {
            "key": "{primitive.string.typography.font-family.dm-serif-display}",
            "value": "Helvetica Neue",
            "type": "string",
            "original": {
              "value": "Helvetica Neue",
              "type": "string",
              "key": "{primitive.string.typography.font-family.dm-serif-display}"
            },
            "name": "dm-serif-display",
            "attributes": {
              "category": "primitive",
              "type": "string",
              "item": "typography",
              "subitem": "font-family",
              "state": "dm-serif-display"
            },
            "path": [
              "primitive",
              "string",
              "typography",
              "font-family",
              "dm-serif-display"
            ]
          },
          "montserrat": {
            "key": "{primitive.string.typography.font-family.montserrat}",
            "value": "Helvetica Neue",
            "type": "string",
            "original": {
              "value": "Helvetica Neue",
              "type": "string",
              "key": "{primitive.string.typography.font-family.montserrat}"
            },
            "name": "montserrat",
            "attributes": {
              "category": "primitive",
              "type": "string",
              "item": "typography",
              "subitem": "font-family",
              "state": "montserrat"
            },
            "path": [
              "primitive",
              "string",
              "typography",
              "font-family",
              "montserrat"
            ]
          }
        }
      }
    }
  },
  "theme": {
    "theme-1": {
      "color": {
        "action": {
          "button": {
            "fill": {
              "primary": {
                "enabled": {
                  "key": "{theme.theme-1.color.action.button.fill.primary.enabled}",
                  "value": "#fdfdfc",
                  "type": "color",
                  "original": {
                    "value": "#fdfdfc",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.fill.primary.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "primary",
                    "enabled"
                  ]
                },
                "hover": {
                  "key": "{theme.theme-1.color.action.button.fill.primary.hover}",
                  "value": "#f5f5f4",
                  "type": "color",
                  "original": {
                    "value": "#f5f5f4",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.fill.primary.hover}"
                  },
                  "name": "hover",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "primary",
                    "hover"
                  ]
                },
                "pressed": {
                  "key": "{theme.theme-1.color.action.button.fill.primary.pressed}",
                  "value": "#d7d3d0",
                  "type": "color",
                  "original": {
                    "value": "#d7d3d0",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.fill.primary.pressed}"
                  },
                  "name": "pressed",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "primary",
                    "pressed"
                  ]
                }
              },
              "critical": {
                "enabled": {
                  "key": "{theme.theme-1.color.action.button.fill.critical.enabled}",
                  "value": "#f97066",
                  "type": "color",
                  "original": {
                    "value": "#f97066",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.fill.critical.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "critical",
                    "enabled"
                  ]
                },
                "hover": {
                  "key": "{theme.theme-1.color.action.button.fill.critical.hover}",
                  "value": "#fda29b",
                  "type": "color",
                  "original": {
                    "value": "#fda29b",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.fill.critical.hover}"
                  },
                  "name": "hover",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "critical",
                    "hover"
                  ]
                },
                "pressed": {
                  "key": "{theme.theme-1.color.action.button.fill.critical.pressed}",
                  "value": "#f04438",
                  "type": "color",
                  "original": {
                    "value": "#f04438",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.fill.critical.pressed}"
                  },
                  "name": "pressed",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "critical",
                    "pressed"
                  ]
                }
              }
            },
            "border": {
              "primary": {
                "enabled": {
                  "key": "{theme.theme-1.color.action.button.border.primary.enabled}",
                  "value": "#fdfdfc",
                  "type": "color",
                  "original": {
                    "value": "#fdfdfc",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.border.primary.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "border",
                    "primary",
                    "enabled"
                  ]
                }
              },
              "error": {
                "enabled": {
                  "key": "{theme.theme-1.color.action.button.border.error.enabled}",
                  "value": "#f97066",
                  "type": "color",
                  "original": {
                    "value": "#f97066",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.border.error.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "border",
                    "error",
                    "enabled"
                  ]
                }
              }
            },
            "text-icon": {
              "primary": {
                "enabled": {
                  "key": "{theme.theme-1.color.action.button.text-icon.primary.enabled}",
                  "value": "#fdfdfc",
                  "type": "color",
                  "original": {
                    "value": "#fdfdfc",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.text-icon.primary.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "text-icon",
                    "primary",
                    "enabled"
                  ]
                },
                "hover": {
                  "key": "{theme.theme-1.color.action.button.text-icon.primary.hover}",
                  "value": "#f5f5f4",
                  "type": "color",
                  "original": {
                    "value": "#f5f5f4",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.text-icon.primary.hover}"
                  },
                  "name": "hover",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "text-icon",
                    "primary",
                    "hover"
                  ]
                },
                "pressed": {
                  "key": "{theme.theme-1.color.action.button.text-icon.primary.pressed}",
                  "value": "#d7d3d0",
                  "type": "color",
                  "original": {
                    "value": "#d7d3d0",
                    "type": "color",
                    "key": "{theme.theme-1.color.action.button.text-icon.primary.pressed}"
                  },
                  "name": "pressed",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "action",
                    "button",
                    "text-icon",
                    "primary",
                    "pressed"
                  ]
                }
              }
            }
          }
        },
        "communication": {
          "notifications": {
            "fill": {
              "success": {
                "key": "{theme.theme-1.color.communication.notifications.fill.success}",
                "value": "#002709",
                "type": "color",
                "original": {
                  "value": "#002709",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.fill.success}"
                },
                "name": "success",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "success"
                ]
              },
              "info": {
                "key": "{theme.theme-1.color.communication.notifications.fill.info}",
                "value": "#000d76",
                "type": "color",
                "original": {
                  "value": "#000d76",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.fill.info}"
                },
                "name": "info",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "info"
                ]
              },
              "error": {
                "key": "{theme.theme-1.color.communication.notifications.fill.error}",
                "value": "#520000",
                "type": "color",
                "original": {
                  "value": "#520000",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.fill.error}"
                },
                "name": "error",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "error"
                ]
              },
              "alert": {
                "key": "{theme.theme-1.color.communication.notifications.fill.alert}",
                "value": "#491300",
                "type": "color",
                "original": {
                  "value": "#491300",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.fill.alert}"
                },
                "name": "alert",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "alert"
                ]
              }
            },
            "border": {
              "success": {
                "key": "{theme.theme-1.color.communication.notifications.border.success}",
                "value": "#6ce9a6",
                "type": "color",
                "original": {
                  "value": "#6ce9a6",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.border.success}"
                },
                "name": "success",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "success"
                ]
              },
              "info": {
                "key": "{theme.theme-1.color.communication.notifications.border.info}",
                "value": "#84caff",
                "type": "color",
                "original": {
                  "value": "#84caff",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.border.info}"
                },
                "name": "info",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "info"
                ]
              },
              "error": {
                "key": "{theme.theme-1.color.communication.notifications.border.error}",
                "value": "#f97066",
                "type": "color",
                "original": {
                  "value": "#f97066",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.border.error}"
                },
                "name": "error",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "error"
                ]
              },
              "alert": {
                "key": "{theme.theme-1.color.communication.notifications.border.alert}",
                "value": "#fde272",
                "type": "color",
                "original": {
                  "value": "#fde272",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.border.alert}"
                },
                "name": "alert",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "alert"
                ]
              }
            },
            "text-icon": {
              "success": {
                "key": "{theme.theme-1.color.communication.notifications.text-icon.success}",
                "value": "#6ce9a6",
                "type": "color",
                "original": {
                  "value": "#6ce9a6",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.text-icon.success}"
                },
                "name": "success",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "success"
                ]
              },
              "info": {
                "key": "{theme.theme-1.color.communication.notifications.text-icon.info}",
                "value": "#84caff",
                "type": "color",
                "original": {
                  "value": "#84caff",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.text-icon.info}"
                },
                "name": "info",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "info"
                ]
              },
              "error": {
                "key": "{theme.theme-1.color.communication.notifications.text-icon.error}",
                "value": "#f97066",
                "type": "color",
                "original": {
                  "value": "#f97066",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.text-icon.error}"
                },
                "name": "error",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "error"
                ]
              },
              "alert": {
                "key": "{theme.theme-1.color.communication.notifications.text-icon.alert}",
                "value": "#fde272",
                "type": "color",
                "original": {
                  "value": "#fde272",
                  "type": "color",
                  "key": "{theme.theme-1.color.communication.notifications.text-icon.alert}"
                },
                "name": "alert",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "alert"
                ]
              }
            }
          },
          "badge": {
            "fill": {
              "key": "{theme.theme-1.color.communication.badge.fill}",
              "value": "#fde272",
              "type": "color",
              "original": {
                "value": "#fde272",
                "type": "color",
                "key": "{theme.theme-1.color.communication.badge.fill}"
              },
              "name": "fill",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "communication",
                "state": "badge"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "communication",
                "badge",
                "fill"
              ]
            }
          }
        },
        "containment": {
          "surface": {
            "fill": {
              "default": {
                "key": "{theme.theme-1.color.containment.surface.fill.default}",
                "value": "#212121",
                "type": "color",
                "original": {
                  "value": "#212121",
                  "type": "color",
                  "key": "{theme.theme-1.color.containment.surface.fill.default}"
                },
                "name": "default",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "default"
                ]
              },
              "overlay": {
                "key": "{theme.theme-1.color.containment.surface.fill.overlay}",
                "value": "rgba(0, 0, 0, 0.7)",
                "type": "color",
                "original": {
                  "value": "rgba(0, 0, 0, 0.7)",
                  "type": "color",
                  "key": "{theme.theme-1.color.containment.surface.fill.overlay}"
                },
                "name": "overlay",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "overlay"
                ]
              },
              "sunken": {
                "key": "{theme.theme-1.color.containment.surface.fill.sunken}",
                "value": "#0d0d0d",
                "type": "color",
                "original": {
                  "value": "#0d0d0d",
                  "type": "color",
                  "key": "{theme.theme-1.color.containment.surface.fill.sunken}"
                },
                "name": "sunken",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "sunken"
                ]
              },
              "raised-1": {
                "key": "{theme.theme-1.color.containment.surface.fill.raised-1}",
                "value": "#383838",
                "type": "color",
                "original": {
                  "value": "#383838",
                  "type": "color",
                  "key": "{theme.theme-1.color.containment.surface.fill.raised-1}"
                },
                "name": "raised-1",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "raised-1"
                ]
              },
              "raised-2": {
                "key": "{theme.theme-1.color.containment.surface.fill.raised-2}",
                "value": "#616161",
                "type": "color",
                "original": {
                  "value": "#616161",
                  "type": "color",
                  "key": "{theme.theme-1.color.containment.surface.fill.raised-2}"
                },
                "name": "raised-2",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "raised-2"
                ]
              }
            },
            "border": {
              "divider": {
                "key": "{theme.theme-1.color.containment.surface.border.divider}",
                "value": "#616161",
                "type": "color",
                "original": {
                  "value": "#616161",
                  "type": "color",
                  "key": "{theme.theme-1.color.containment.surface.border.divider}"
                },
                "name": "divider",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "containment",
                  "surface",
                  "border",
                  "divider"
                ]
              }
            }
          }
        },
        "generic": {
          "focused": {
            "key": "{theme.theme-1.color.generic.focused}",
            "value": "#444ce7",
            "type": "color",
            "original": {
              "value": "#444ce7",
              "type": "color",
              "key": "{theme.theme-1.color.generic.focused}"
            },
            "name": "focused",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "color",
              "subitem": "generic",
              "state": "focused"
            },
            "path": [
              "theme",
              "theme-1",
              "color",
              "generic",
              "focused"
            ]
          },
          "disabled": {
            "text-icon": {
              "key": "{theme.theme-1.color.generic.disabled.text-icon}",
              "value": "rgba(255, 255, 255, 0.3)",
              "type": "color",
              "original": {
                "value": "rgba(255, 255, 255, 0.3)",
                "type": "color",
                "key": "{theme.theme-1.color.generic.disabled.text-icon}"
              },
              "name": "text-icon",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "generic",
                "disabled",
                "text-icon"
              ]
            },
            "text-icon-inverse": {
              "key": "{theme.theme-1.color.generic.disabled.text-icon-inverse}",
              "value": "rgba(0, 0, 0, 0.3)",
              "type": "color",
              "original": {
                "value": "rgba(0, 0, 0, 0.3)",
                "type": "color",
                "key": "{theme.theme-1.color.generic.disabled.text-icon-inverse}"
              },
              "name": "text-icon-inverse",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "generic",
                "disabled",
                "text-icon-inverse"
              ]
            },
            "fill": {
              "key": "{theme.theme-1.color.generic.disabled.fill}",
              "value": "#383838",
              "type": "color",
              "original": {
                "value": "#383838",
                "type": "color",
                "key": "{theme.theme-1.color.generic.disabled.fill}"
              },
              "name": "fill",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "generic",
                "disabled",
                "fill"
              ]
            },
            "border": {
              "key": "{theme.theme-1.color.generic.disabled.border}",
              "value": "#383838",
              "type": "color",
              "original": {
                "value": "#383838",
                "type": "color",
                "key": "{theme.theme-1.color.generic.disabled.border}"
              },
              "name": "border",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "generic",
                "disabled",
                "border"
              ]
            }
          },
          "brand": {
            "primary": {
              "enabled": {
                "key": "{theme.theme-1.color.generic.brand.primary.enabled}",
                "value": "#fdfdfc",
                "type": "color",
                "original": {
                  "value": "#fdfdfc",
                  "type": "color",
                  "key": "{theme.theme-1.color.generic.brand.primary.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "generic",
                  "state": "brand"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "generic",
                  "brand",
                  "primary",
                  "enabled"
                ]
              },
              "hover": {
                "key": "{theme.theme-1.color.generic.brand.primary.hover}",
                "value": "#f5f5f4",
                "type": "color",
                "original": {
                  "value": "#f5f5f4",
                  "type": "color",
                  "key": "{theme.theme-1.color.generic.brand.primary.hover}"
                },
                "name": "hover",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "generic",
                  "state": "brand"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "generic",
                  "brand",
                  "primary",
                  "hover"
                ]
              },
              "pressed": {
                "key": "{theme.theme-1.color.generic.brand.primary.pressed}",
                "value": "#d7d3d0",
                "type": "color",
                "original": {
                  "value": "#d7d3d0",
                  "type": "color",
                  "key": "{theme.theme-1.color.generic.brand.primary.pressed}"
                },
                "name": "pressed",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "generic",
                  "state": "brand"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "generic",
                  "brand",
                  "primary",
                  "pressed"
                ]
              }
            }
          }
        },
        "text-inputs": {
          "border": {
            "enabled": {
              "key": "{theme.theme-1.color.text-inputs.border.enabled}",
              "value": "#eeeeee",
              "type": "color",
              "original": {
                "value": "#eeeeee",
                "type": "color",
                "key": "{theme.theme-1.color.text-inputs.border.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "text-inputs",
                "state": "border"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "text-inputs",
                "border",
                "enabled"
              ]
            },
            "active": {
              "key": "{theme.theme-1.color.text-inputs.border.active}",
              "value": "#fdfdfc",
              "type": "color",
              "original": {
                "value": "#fdfdfc",
                "type": "color",
                "key": "{theme.theme-1.color.text-inputs.border.active}"
              },
              "name": "active",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "text-inputs",
                "state": "border"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "text-inputs",
                "border",
                "active"
              ]
            }
          }
        },
        "text-icon": {
          "common": {
            "high-emphesis": {
              "key": "{theme.theme-1.color.text-icon.common.high-emphesis}",
              "value": "rgba(255, 255, 255, 0.9)",
              "type": "color",
              "original": {
                "value": "rgba(255, 255, 255, 0.9)",
                "type": "color",
                "key": "{theme.theme-1.color.text-icon.common.high-emphesis}"
              },
              "name": "high-emphesis",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "text-icon",
                "state": "common"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "text-icon",
                "common",
                "high-emphesis"
              ]
            },
            "medium-emphasis": {
              "key": "{theme.theme-1.color.text-icon.common.medium-emphasis}",
              "value": "rgba(255, 255, 255, 0.7)",
              "type": "color",
              "original": {
                "value": "rgba(255, 255, 255, 0.7)",
                "type": "color",
                "key": "{theme.theme-1.color.text-icon.common.medium-emphasis}"
              },
              "name": "medium-emphasis",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "text-icon",
                "state": "common"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "text-icon",
                "common",
                "medium-emphasis"
              ]
            }
          },
          "common-inverse": {
            "high-emphasis": {
              "key": "{theme.theme-1.color.text-icon.common-inverse.high-emphasis}",
              "value": "rgba(0, 0, 0, 0.9)",
              "type": "color",
              "original": {
                "value": "rgba(0, 0, 0, 0.9)",
                "type": "color",
                "key": "{theme.theme-1.color.text-icon.common-inverse.high-emphasis}"
              },
              "name": "high-emphasis",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "text-icon",
                "state": "common-inverse"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "text-icon",
                "common-inverse",
                "high-emphasis"
              ]
            },
            "medium-emphasis": {
              "key": "{theme.theme-1.color.text-icon.common-inverse.medium-emphasis}",
              "value": "rgba(0, 0, 0, 0.7)",
              "type": "color",
              "original": {
                "value": "rgba(0, 0, 0, 0.7)",
                "type": "color",
                "key": "{theme.theme-1.color.text-icon.common-inverse.medium-emphasis}"
              },
              "name": "medium-emphasis",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "color",
                "subitem": "text-icon",
                "state": "common-inverse"
              },
              "path": [
                "theme",
                "theme-1",
                "color",
                "text-icon",
                "common-inverse",
                "medium-emphasis"
              ]
            }
          }
        },
        "selection": {
          "checkbox-radio": {
            "fill": {
              "selected": {
                "key": "{theme.theme-1.color.selection.checkbox-radio.fill.selected}",
                "value": "#eeeeee",
                "type": "color",
                "original": {
                  "value": "#eeeeee",
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.checkbox-radio.fill.selected}"
                },
                "name": "selected",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "fill",
                  "selected"
                ]
              },
              "selected-critical": {
                "key": "{theme.theme-1.color.selection.checkbox-radio.fill.selected-critical}",
                "value": "#fda29b",
                "type": "color",
                "original": {
                  "value": "#fda29b",
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.checkbox-radio.fill.selected-critical}"
                },
                "name": "selected-critical",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "fill",
                  "selected-critical"
                ]
              }
            },
            "border": {
              "enabled": {
                "key": "{theme.theme-1.color.selection.checkbox-radio.border.enabled}",
                "value": null,
                "type": "color",
                "original": {
                  "value": null,
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.checkbox-radio.border.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "border",
                  "enabled"
                ]
              },
              "enabled-critical": {
                "key": "{theme.theme-1.color.selection.checkbox-radio.border.enabled-critical}",
                "value": "#fda29b",
                "type": "color",
                "original": {
                  "value": "#fda29b",
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.checkbox-radio.border.enabled-critical}"
                },
                "name": "enabled-critical",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "border",
                  "enabled-critical"
                ]
              }
            }
          },
          "dropdown": {
            "border": {
              "enabled": {
                "key": "{theme.theme-1.color.selection.dropdown.border.enabled}",
                "value": "#eeeeee",
                "type": "color",
                "original": {
                  "value": "#eeeeee",
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.dropdown.border.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "dropdown"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "dropdown",
                  "border",
                  "enabled"
                ]
              }
            }
          },
          "chips": {
            "border": {
              "primary": {
                "selected": {
                  "key": "{theme.theme-1.color.selection.chips.border.primary.selected}",
                  "value": "#fdfdfc",
                  "type": "color",
                  "original": {
                    "value": "#fdfdfc",
                    "type": "color",
                    "key": "{theme.theme-1.color.selection.chips.border.primary.selected}"
                  },
                  "name": "selected",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "color",
                    "subitem": "selection",
                    "state": "chips"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "color",
                    "selection",
                    "chips",
                    "border",
                    "primary",
                    "selected"
                  ]
                }
              }
            }
          },
          "switch-knob": {
            "fill": {
              "enabled": {
                "key": "{theme.theme-1.color.selection.switch-knob.fill.enabled}",
                "value": "#eeeeee",
                "type": "color",
                "original": {
                  "value": "#eeeeee",
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.switch-knob.fill.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "switch-knob"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "switch-knob",
                  "fill",
                  "enabled"
                ]
              },
              "selected": {
                "key": "{theme.theme-1.color.selection.switch-knob.fill.selected}",
                "value": "#0d0d0d",
                "type": "color",
                "original": {
                  "value": "#0d0d0d",
                  "type": "color",
                  "key": "{theme.theme-1.color.selection.switch-knob.fill.selected}"
                },
                "name": "selected",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "color",
                  "subitem": "selection",
                  "state": "switch-knob"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "color",
                  "selection",
                  "switch-knob",
                  "fill",
                  "selected"
                ]
              }
            }
          }
        }
      },
      "float": {
        "type-scale": {
          "size": {
            "xs": {
              "key": "{theme.theme-1.float.type-scale.size.xs}",
              "value": 12,
              "type": "number",
              "original": {
                "value": 12,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.xs}"
              },
              "name": "xs",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "xs"
              ]
            },
            "sm": {
              "key": "{theme.theme-1.float.type-scale.size.sm}",
              "value": 14,
              "type": "number",
              "original": {
                "value": 14,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "sm"
              ]
            },
            "md": {
              "key": "{theme.theme-1.float.type-scale.size.md}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.md}"
              },
              "name": "md",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "md"
              ]
            },
            "lg": {
              "key": "{theme.theme-1.float.type-scale.size.lg}",
              "value": 20,
              "type": "number",
              "original": {
                "value": 20,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.lg}"
              },
              "name": "lg",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "lg"
              ]
            },
            "xl": {
              "key": "{theme.theme-1.float.type-scale.size.xl}",
              "value": 24,
              "type": "number",
              "original": {
                "value": 24,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.xl}"
              },
              "name": "xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "xl"
              ]
            },
            "2xl": {
              "key": "{theme.theme-1.float.type-scale.size.2xl}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.2xl}"
              },
              "name": "2xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "2xl"
              ]
            },
            "3xl": {
              "key": "{theme.theme-1.float.type-scale.size.3xl}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.3xl}"
              },
              "name": "3xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "3xl"
              ]
            },
            "4xl": {
              "key": "{theme.theme-1.float.type-scale.size.4xl}",
              "value": 48,
              "type": "number",
              "original": {
                "value": 48,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.4xl}"
              },
              "name": "4xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "4xl"
              ]
            },
            "2xs": {
              "key": "{theme.theme-1.float.type-scale.size.2xs}",
              "value": 10,
              "type": "number",
              "original": {
                "value": 10,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.size.2xs}"
              },
              "name": "2xs",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "size",
                "2xs"
              ]
            }
          },
          "line-height": {
            "2xs": {
              "key": "{theme.theme-1.float.type-scale.line-height.2xs}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.2xs}"
              },
              "name": "2xs",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "2xs"
              ]
            },
            "sm": {
              "key": "{theme.theme-1.float.type-scale.line-height.sm}",
              "value": 24,
              "type": "number",
              "original": {
                "value": 24,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "sm"
              ]
            },
            "md": {
              "key": "{theme.theme-1.float.type-scale.line-height.md}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.md}"
              },
              "name": "md",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "md"
              ]
            },
            "lg": {
              "key": "{theme.theme-1.float.type-scale.line-height.lg}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.lg}"
              },
              "name": "lg",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "lg"
              ]
            },
            "xl": {
              "key": "{theme.theme-1.float.type-scale.line-height.xl}",
              "value": 48,
              "type": "number",
              "original": {
                "value": 48,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.xl}"
              },
              "name": "xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "xl"
              ]
            },
            "2xl": {
              "key": "{theme.theme-1.float.type-scale.line-height.2xl}",
              "value": 56,
              "type": "number",
              "original": {
                "value": 56,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.2xl}"
              },
              "name": "2xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "2xl"
              ]
            },
            "xs": {
              "key": "{theme.theme-1.float.type-scale.line-height.xs}",
              "value": 20,
              "type": "number",
              "original": {
                "value": 20,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.line-height.xs}"
              },
              "name": "xs",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "line-height",
                "xs"
              ]
            }
          },
          "paragraph-spacing": {
            "xs": {
              "key": "{theme.theme-1.float.type-scale.paragraph-spacing.xs}",
              "value": 8,
              "type": "number",
              "original": {
                "value": 8,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.paragraph-spacing.xs}"
              },
              "name": "xs",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "paragraph-spacing",
                "xs"
              ]
            },
            "sm": {
              "key": "{theme.theme-1.float.type-scale.paragraph-spacing.sm}",
              "value": 20,
              "type": "number",
              "original": {
                "value": 20,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.paragraph-spacing.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "paragraph-spacing",
                "sm"
              ]
            },
            "md": {
              "key": "{theme.theme-1.float.type-scale.paragraph-spacing.md}",
              "value": 24,
              "type": "number",
              "original": {
                "value": 24,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.paragraph-spacing.md}"
              },
              "name": "md",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "paragraph-spacing",
                "md"
              ]
            },
            "lg": {
              "key": "{theme.theme-1.float.type-scale.paragraph-spacing.lg}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.paragraph-spacing.lg}"
              },
              "name": "lg",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "paragraph-spacing",
                "lg"
              ]
            },
            "xl": {
              "key": "{theme.theme-1.float.type-scale.paragraph-spacing.xl}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.paragraph-spacing.xl}"
              },
              "name": "xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "paragraph-spacing",
                "xl"
              ]
            },
            "2xl": {
              "key": "{theme.theme-1.float.type-scale.paragraph-spacing.2xl}",
              "value": 48,
              "type": "number",
              "original": {
                "value": 48,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.paragraph-spacing.2xl}"
              },
              "name": "2xl",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "paragraph-spacing",
                "2xl"
              ]
            }
          },
          "letter-spacing": {
            "sm": {
              "key": "{theme.theme-1.float.type-scale.letter-spacing.sm}",
              "value": 0,
              "type": "number",
              "original": {
                "value": 0,
                "type": "number",
                "key": "{theme.theme-1.float.type-scale.letter-spacing.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "type-scale",
                "state": "letter-spacing"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "type-scale",
                "letter-spacing",
                "sm"
              ]
            }
          }
        },
        "radii": {
          "action": {
            "button": {
              "key": "{theme.theme-1.float.radii.action.button}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-1.float.radii.action.button}"
              },
              "name": "button",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "action"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "action",
                "button"
              ]
            },
            "fab": {
              "key": "{theme.theme-1.float.radii.action.fab}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-1.float.radii.action.fab}"
              },
              "name": "fab",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "action"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "action",
                "fab"
              ]
            }
          },
          "selection": {
            "chips": {
              "key": "{theme.theme-1.float.radii.selection.chips}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-1.float.radii.selection.chips}"
              },
              "name": "chips",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "selection",
                "chips"
              ]
            },
            "switch": {
              "key": "{theme.theme-1.float.radii.selection.switch}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-1.float.radii.selection.switch}"
              },
              "name": "switch",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "selection",
                "switch"
              ]
            },
            "radio-selector": {
              "key": "{theme.theme-1.float.radii.selection.radio-selector}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-1.float.radii.selection.radio-selector}"
              },
              "name": "radio-selector",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "selection",
                "radio-selector"
              ]
            },
            "checkbox": {
              "key": "{theme.theme-1.float.radii.selection.checkbox}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-1.float.radii.selection.checkbox}"
              },
              "name": "checkbox",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "selection",
                "checkbox"
              ]
            }
          },
          "communication": {
            "banner": {
              "key": "{theme.theme-1.float.radii.communication.banner}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-1.float.radii.communication.banner}"
              },
              "name": "banner",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "communication",
                "banner"
              ]
            },
            "toast": {
              "key": "{theme.theme-1.float.radii.communication.toast}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-1.float.radii.communication.toast}"
              },
              "name": "toast",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "communication",
                "toast"
              ]
            },
            "tag": {
              "key": "{theme.theme-1.float.radii.communication.tag}",
              "value": 2,
              "type": "number",
              "original": {
                "value": 2,
                "type": "number",
                "key": "{theme.theme-1.float.radii.communication.tag}"
              },
              "name": "tag",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "communication",
                "tag"
              ]
            },
            "tool-tip": {
              "key": "{theme.theme-1.float.radii.communication.tool-tip}",
              "value": null,
              "type": "number",
              "original": {
                "value": null,
                "type": "number",
                "key": "{theme.theme-1.float.radii.communication.tool-tip}"
              },
              "name": "tool-tip",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "communication",
                "tool-tip"
              ]
            },
            "badge": {
              "key": "{theme.theme-1.float.radii.communication.badge}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-1.float.radii.communication.badge}"
              },
              "name": "badge",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "communication",
                "badge"
              ]
            },
            "dialog": {
              "key": "{theme.theme-1.float.radii.communication.dialog}",
              "value": 8,
              "type": "number",
              "original": {
                "value": 8,
                "type": "number",
                "key": "{theme.theme-1.float.radii.communication.dialog}"
              },
              "name": "dialog",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "communication",
                "dialog"
              ]
            }
          },
          "containment": {
            "card": {
              "key": "{theme.theme-1.float.radii.containment.card}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-1.float.radii.containment.card}"
              },
              "name": "card",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "containment"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "containment",
                "card"
              ]
            },
            "menu": {
              "key": "{theme.theme-1.float.radii.containment.menu}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-1.float.radii.containment.menu}"
              },
              "name": "menu",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "containment"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "containment",
                "menu"
              ]
            }
          },
          "text-input": {
            "field": {
              "key": "{theme.theme-1.float.radii.text-input.field}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-1.float.radii.text-input.field}"
              },
              "name": "field",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "radii",
                "state": "text-input"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "radii",
                "text-input",
                "field"
              ]
            }
          }
        },
        "stroke-width": {
          "action": {
            "button": {
              "outline": {
                "key": "{theme.theme-1.float.stroke-width.action.button.outline}",
                "value": 1,
                "type": "number",
                "original": {
                  "value": 1,
                  "type": "number",
                  "key": "{theme.theme-1.float.stroke-width.action.button.outline}"
                },
                "name": "outline",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "stroke-width",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "stroke-width",
                  "action",
                  "button",
                  "outline"
                ]
              }
            }
          },
          "selection": {
            "checkbox": {
              "key": "{theme.theme-1.float.stroke-width.selection.checkbox}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.checkbox}"
              },
              "name": "checkbox",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "checkbox"
              ]
            },
            "radio-selector": {
              "key": "{theme.theme-1.float.stroke-width.selection.radio-selector}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.radio-selector}"
              },
              "name": "radio-selector",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "radio-selector"
              ]
            },
            "focused": {
              "key": "{theme.theme-1.float.stroke-width.selection.focused}",
              "value": 2,
              "type": "number",
              "original": {
                "value": 2,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.focused}"
              },
              "name": "focused",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "focused"
              ]
            },
            "dropdown": {
              "key": "{theme.theme-1.float.stroke-width.selection.dropdown}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.dropdown}"
              },
              "name": "dropdown",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "dropdown"
              ]
            },
            "date-picker": {
              "key": "{theme.theme-1.float.stroke-width.selection.date-picker}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.date-picker}"
              },
              "name": "date-picker",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "date-picker"
              ]
            },
            "chips": {
              "key": "{theme.theme-1.float.stroke-width.selection.chips}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.chips}"
              },
              "name": "chips",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "chips"
              ]
            },
            "switch": {
              "key": "{theme.theme-1.float.stroke-width.selection.switch}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.selection.switch}"
              },
              "name": "switch",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "selection",
                "switch"
              ]
            }
          },
          "communication": {
            "tag": {
              "key": "{theme.theme-1.float.stroke-width.communication.tag}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.communication.tag}"
              },
              "name": "tag",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "communication",
                "tag"
              ]
            },
            "notifications": {
              "key": "{theme.theme-1.float.stroke-width.communication.notifications}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.communication.notifications}"
              },
              "name": "notifications",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "communication",
                "notifications"
              ]
            }
          },
          "text-inputs": {
            "field": {
              "key": "{theme.theme-1.float.stroke-width.text-inputs.field}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-1.float.stroke-width.text-inputs.field}"
              },
              "name": "field",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "stroke-width",
                "state": "text-inputs"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "stroke-width",
                "text-inputs",
                "field"
              ]
            }
          }
        },
        "elevation": {
          "action": {
            "fab": {
              "potision-x": {
                "key": "{theme.theme-1.float.elevation.action.fab.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.action.fab.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "potision-x"
                ]
              },
              "blur": {
                "key": "{theme.theme-1.float.elevation.action.fab.blur}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.action.fab.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-1.float.elevation.action.fab.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.action.fab.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "spread"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-1.float.elevation.action.fab.potision-y}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.action.fab.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "potision-y"
                ]
              }
            }
          },
          "containment": {
            "menu": {
              "potision-x": {
                "key": "{theme.theme-1.float.elevation.containment.menu.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.menu.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-1.float.elevation.containment.menu.potision-y}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.menu.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-1.float.elevation.containment.menu.blur}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.menu.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-1.float.elevation.containment.menu.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.menu.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "spread"
                ]
              }
            },
            "card": {
              "enabled": {
                "potision-x": {
                  "key": "{theme.theme-1.float.elevation.containment.card.enabled.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.enabled.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-1.float.elevation.containment.card.enabled.potision-y}",
                  "value": 2,
                  "type": "number",
                  "original": {
                    "value": 2,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.enabled.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-1.float.elevation.containment.card.enabled.blur}",
                  "value": 2,
                  "type": "number",
                  "original": {
                    "value": 2,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.enabled.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-1.float.elevation.containment.card.enabled.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.enabled.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "spread"
                  ]
                }
              },
              "hover": {
                "potision-x": {
                  "key": "{theme.theme-1.float.elevation.containment.card.hover.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.hover.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-1.float.elevation.containment.card.hover.potision-y}",
                  "value": 4,
                  "type": "number",
                  "original": {
                    "value": 4,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.hover.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-1.float.elevation.containment.card.hover.blur}",
                  "value": 4,
                  "type": "number",
                  "original": {
                    "value": 4,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.hover.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-1.float.elevation.containment.card.hover.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.hover.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "spread"
                  ]
                }
              },
              "selected": {
                "potision-x": {
                  "key": "{theme.theme-1.float.elevation.containment.card.selected.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.selected.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-1.float.elevation.containment.card.selected.potision-y}",
                  "value": 12,
                  "type": "number",
                  "original": {
                    "value": 12,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.selected.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-1.float.elevation.containment.card.selected.blur}",
                  "value": 16,
                  "type": "number",
                  "original": {
                    "value": 16,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.selected.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-1.float.elevation.containment.card.selected.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.selected.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "spread"
                  ]
                }
              },
              "dragged": {
                "potision-x": {
                  "key": "{theme.theme-1.float.elevation.containment.card.dragged.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.dragged.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-1.float.elevation.containment.card.dragged.potision-y}",
                  "value": 12,
                  "type": "number",
                  "original": {
                    "value": 12,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.dragged.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-1.float.elevation.containment.card.dragged.blur}",
                  "value": 16,
                  "type": "number",
                  "original": {
                    "value": 16,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.dragged.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-1.float.elevation.containment.card.dragged.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-1.float.elevation.containment.card.dragged.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-1",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-1",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "spread"
                  ]
                }
              }
            },
            "dialog": {
              "potision-x": {
                "key": "{theme.theme-1.float.elevation.containment.dialog.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.dialog.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-1.float.elevation.containment.dialog.potision-y}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.dialog.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-1.float.elevation.containment.dialog.blur}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.dialog.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-1.float.elevation.containment.dialog.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.containment.dialog.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "spread"
                ]
              }
            }
          },
          "communication": {
            "toast": {
              "potision-x": {
                "key": "{theme.theme-1.float.elevation.communication.toast.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.toast.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-1.float.elevation.communication.toast.potision-y}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.toast.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-1.float.elevation.communication.toast.blur}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.toast.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-1.float.elevation.communication.toast.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.toast.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "spread"
                ]
              }
            },
            "snack-bar": {
              "potision-x": {
                "key": "{theme.theme-1.float.elevation.communication.snack-bar.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.snack-bar.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-1.float.elevation.communication.snack-bar.potision-y}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.snack-bar.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-1.float.elevation.communication.snack-bar.blur}",
                "value": 2,
                "type": "number",
                "original": {
                  "value": 2,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.snack-bar.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-1.float.elevation.communication.snack-bar.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-1.float.elevation.communication.snack-bar.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-1",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-1",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "spread"
                ]
              }
            }
          }
        },
        "proportion": {
          "2": {
            "key": "{theme.theme-1.float.proportion.2}",
            "value": 16,
            "type": "number",
            "original": {
              "value": 16,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.2}"
            },
            "name": "2",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "2"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "2"
            ]
          },
          "3": {
            "key": "{theme.theme-1.float.proportion.3}",
            "value": 24,
            "type": "number",
            "original": {
              "value": 24,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.3}"
            },
            "name": "3",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "3"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "3"
            ]
          },
          "4": {
            "key": "{theme.theme-1.float.proportion.4}",
            "value": 32,
            "type": "number",
            "original": {
              "value": 32,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.4}"
            },
            "name": "4",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "4"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "4"
            ]
          },
          "5": {
            "key": "{theme.theme-1.float.proportion.5}",
            "value": 40,
            "type": "number",
            "original": {
              "value": 40,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.5}"
            },
            "name": "5",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "5"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "5"
            ]
          },
          "6": {
            "key": "{theme.theme-1.float.proportion.6}",
            "value": 48,
            "type": "number",
            "original": {
              "value": 48,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.6}"
            },
            "name": "6",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "6"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "6"
            ]
          },
          "25": {
            "key": "{theme.theme-1.float.proportion.25}",
            "value": 2,
            "type": "number",
            "original": {
              "value": 2,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.25}"
            },
            "name": "25",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "25"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "25"
            ]
          },
          "50": {
            "key": "{theme.theme-1.float.proportion.50}",
            "value": 4,
            "type": "number",
            "original": {
              "value": 4,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.50}"
            },
            "name": "50",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "50"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "50"
            ]
          },
          "75": {
            "key": "{theme.theme-1.float.proportion.75}",
            "value": 6,
            "type": "number",
            "original": {
              "value": 6,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.75}"
            },
            "name": "75",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "75"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "75"
            ]
          },
          "125": {
            "key": "{theme.theme-1.float.proportion.125}",
            "value": 1,
            "type": "number",
            "original": {
              "value": 1,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.125}"
            },
            "name": "125",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "125"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "125"
            ]
          },
          "1-default-unit": {
            "key": "{theme.theme-1.float.proportion.1-default-unit}",
            "value": 8,
            "type": "number",
            "original": {
              "value": 8,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.1-default-unit}"
            },
            "name": "1-default-unit",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "1-default-unit"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "1-default-unit"
            ]
          },
          "1-50": {
            "key": "{theme.theme-1.float.proportion.1-50}",
            "value": 12,
            "type": "number",
            "original": {
              "value": 12,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.1-50}"
            },
            "name": "1-50",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "1-50"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "1-50"
            ]
          },
          "2-50": {
            "key": "{theme.theme-1.float.proportion.2-50}",
            "value": 20,
            "type": "number",
            "original": {
              "value": 20,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.2-50}"
            },
            "name": "2-50",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "2-50"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "2-50"
            ]
          },
          "zero": {
            "key": "{theme.theme-1.float.proportion.zero}",
            "value": 0,
            "type": "number",
            "original": {
              "value": 0,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.zero}"
            },
            "name": "zero",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "zero"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "zero"
            ]
          },
          "6-50": {
            "key": "{theme.theme-1.float.proportion.6-50}",
            "value": 52,
            "type": "number",
            "original": {
              "value": 52,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.6-50}"
            },
            "name": "6-50",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "6-50"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "6-50"
            ]
          },
          "4-50": {
            "key": "{theme.theme-1.float.proportion.4-50}",
            "value": 36,
            "type": "number",
            "original": {
              "value": 36,
              "type": "number",
              "key": "{theme.theme-1.float.proportion.4-50}"
            },
            "name": "4-50",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "float",
              "subitem": "proportion",
              "state": "4-50"
            },
            "path": [
              "theme",
              "theme-1",
              "float",
              "proportion",
              "4-50"
            ]
          }
        },
        "opacity": {
          "background": {
            "enabled": {
              "key": "{theme.theme-1.float.opacity.background.enabled}",
              "value": 0,
              "type": "number",
              "original": {
                "value": 0,
                "type": "number",
                "key": "{theme.theme-1.float.opacity.background.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "opacity",
                "background",
                "enabled"
              ]
            },
            "hover": {
              "key": "{theme.theme-1.float.opacity.background.hover}",
              "value": 8,
              "type": "number",
              "original": {
                "value": 8,
                "type": "number",
                "key": "{theme.theme-1.float.opacity.background.hover}"
              },
              "name": "hover",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "opacity",
                "background",
                "hover"
              ]
            },
            "pressed": {
              "key": "{theme.theme-1.float.opacity.background.pressed}",
              "value": 12,
              "type": "number",
              "original": {
                "value": 12,
                "type": "number",
                "key": "{theme.theme-1.float.opacity.background.pressed}"
              },
              "name": "pressed",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "opacity",
                "background",
                "pressed"
              ]
            },
            "selected": {
              "key": "{theme.theme-1.float.opacity.background.selected}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-1.float.opacity.background.selected}"
              },
              "name": "selected",
              "attributes": {
                "category": "theme",
                "type": "theme-1",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-1",
                "float",
                "opacity",
                "background",
                "selected"
              ]
            }
          }
        }
      },
      "string": {
        "typography": {
          "expressive": {
            "key": "{theme.theme-1.string.typography.expressive}",
            "value": "Helvetica Neue",
            "type": "string",
            "original": {
              "value": "Helvetica Neue",
              "type": "string",
              "key": "{theme.theme-1.string.typography.expressive}"
            },
            "name": "expressive",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "string",
              "subitem": "typography",
              "state": "expressive"
            },
            "path": [
              "theme",
              "theme-1",
              "string",
              "typography",
              "expressive"
            ]
          },
          "productive": {
            "key": "{theme.theme-1.string.typography.productive}",
            "value": "Helvetica Neue",
            "type": "string",
            "original": {
              "value": "Helvetica Neue",
              "type": "string",
              "key": "{theme.theme-1.string.typography.productive}"
            },
            "name": "productive",
            "attributes": {
              "category": "theme",
              "type": "theme-1",
              "item": "string",
              "subitem": "typography",
              "state": "productive"
            },
            "path": [
              "theme",
              "theme-1",
              "string",
              "typography",
              "productive"
            ]
          }
        }
      }
    },
    "theme-2": {
      "color": {
        "action": {
          "button": {
            "fill": {
              "primary": {
                "enabled": {
                  "key": "{theme.theme-2.color.action.button.fill.primary.enabled}",
                  "value": "#1c1917",
                  "type": "color",
                  "original": {
                    "value": "#1c1917",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.fill.primary.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "primary",
                    "enabled"
                  ]
                },
                "hover": {
                  "key": "{theme.theme-2.color.action.button.fill.primary.hover}",
                  "value": "#44403c",
                  "type": "color",
                  "original": {
                    "value": "#44403c",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.fill.primary.hover}"
                  },
                  "name": "hover",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "primary",
                    "hover"
                  ]
                },
                "pressed": {
                  "key": "{theme.theme-2.color.action.button.fill.primary.pressed}",
                  "value": "#57534e",
                  "type": "color",
                  "original": {
                    "value": "#57534e",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.fill.primary.pressed}"
                  },
                  "name": "pressed",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "primary",
                    "pressed"
                  ]
                }
              },
              "critical": {
                "enabled": {
                  "key": "{theme.theme-2.color.action.button.fill.critical.enabled}",
                  "value": "#d92d20",
                  "type": "color",
                  "original": {
                    "value": "#d92d20",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.fill.critical.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "critical",
                    "enabled"
                  ]
                },
                "hover": {
                  "key": "{theme.theme-2.color.action.button.fill.critical.hover}",
                  "value": "#f04438",
                  "type": "color",
                  "original": {
                    "value": "#f04438",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.fill.critical.hover}"
                  },
                  "name": "hover",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "critical",
                    "hover"
                  ]
                },
                "pressed": {
                  "key": "{theme.theme-2.color.action.button.fill.critical.pressed}",
                  "value": "#b42318",
                  "type": "color",
                  "original": {
                    "value": "#b42318",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.fill.critical.pressed}"
                  },
                  "name": "pressed",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "fill",
                    "critical",
                    "pressed"
                  ]
                }
              }
            },
            "border": {
              "primary": {
                "enabled": {
                  "key": "{theme.theme-2.color.action.button.border.primary.enabled}",
                  "value": "#1c1917",
                  "type": "color",
                  "original": {
                    "value": "#1c1917",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.border.primary.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "border",
                    "primary",
                    "enabled"
                  ]
                }
              },
              "error": {
                "enabled": {
                  "key": "{theme.theme-2.color.action.button.border.error.enabled}",
                  "value": "#d92d20",
                  "type": "color",
                  "original": {
                    "value": "#d92d20",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.border.error.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "border",
                    "error",
                    "enabled"
                  ]
                }
              }
            },
            "text-icon": {
              "primary": {
                "enabled": {
                  "key": "{theme.theme-2.color.action.button.text-icon.primary.enabled}",
                  "value": "#1c1917",
                  "type": "color",
                  "original": {
                    "value": "#1c1917",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.text-icon.primary.enabled}"
                  },
                  "name": "enabled",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "text-icon",
                    "primary",
                    "enabled"
                  ]
                },
                "hover": {
                  "key": "{theme.theme-2.color.action.button.text-icon.primary.hover}",
                  "value": "#44403c",
                  "type": "color",
                  "original": {
                    "value": "#44403c",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.text-icon.primary.hover}"
                  },
                  "name": "hover",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "text-icon",
                    "primary",
                    "hover"
                  ]
                },
                "pressed": {
                  "key": "{theme.theme-2.color.action.button.text-icon.primary.pressed}",
                  "value": "#57534e",
                  "type": "color",
                  "original": {
                    "value": "#57534e",
                    "type": "color",
                    "key": "{theme.theme-2.color.action.button.text-icon.primary.pressed}"
                  },
                  "name": "pressed",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "action",
                    "state": "button"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "action",
                    "button",
                    "text-icon",
                    "primary",
                    "pressed"
                  ]
                }
              }
            }
          }
        },
        "communication": {
          "notifications": {
            "fill": {
              "success": {
                "key": "{theme.theme-2.color.communication.notifications.fill.success}",
                "value": "#f6fef9",
                "type": "color",
                "original": {
                  "value": "#f6fef9",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.fill.success}"
                },
                "name": "success",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "success"
                ]
              },
              "info": {
                "key": "{theme.theme-2.color.communication.notifications.fill.info}",
                "value": "#f5faff",
                "type": "color",
                "original": {
                  "value": "#f5faff",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.fill.info}"
                },
                "name": "info",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "info"
                ]
              },
              "error": {
                "key": "{theme.theme-2.color.communication.notifications.fill.error}",
                "value": "#fffbfa",
                "type": "color",
                "original": {
                  "value": "#fffbfa",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.fill.error}"
                },
                "name": "error",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "error"
                ]
              },
              "alert": {
                "key": "{theme.theme-2.color.communication.notifications.fill.alert}",
                "value": "#fefdf0",
                "type": "color",
                "original": {
                  "value": "#fefdf0",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.fill.alert}"
                },
                "name": "alert",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "fill",
                  "alert"
                ]
              }
            },
            "border": {
              "success": {
                "key": "{theme.theme-2.color.communication.notifications.border.success}",
                "value": "#027a48",
                "type": "color",
                "original": {
                  "value": "#027a48",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.border.success}"
                },
                "name": "success",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "success"
                ]
              },
              "info": {
                "key": "{theme.theme-2.color.communication.notifications.border.info}",
                "value": "#175cd3",
                "type": "color",
                "original": {
                  "value": "#175cd3",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.border.info}"
                },
                "name": "info",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "info"
                ]
              },
              "error": {
                "key": "{theme.theme-2.color.communication.notifications.border.error}",
                "value": "#b42318",
                "type": "color",
                "original": {
                  "value": "#b42318",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.border.error}"
                },
                "name": "error",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "error"
                ]
              },
              "alert": {
                "key": "{theme.theme-2.color.communication.notifications.border.alert}",
                "value": "#a15c07",
                "type": "color",
                "original": {
                  "value": "#a15c07",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.border.alert}"
                },
                "name": "alert",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "border",
                  "alert"
                ]
              }
            },
            "text-icon": {
              "success": {
                "key": "{theme.theme-2.color.communication.notifications.text-icon.success}",
                "value": "#027a48",
                "type": "color",
                "original": {
                  "value": "#027a48",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.text-icon.success}"
                },
                "name": "success",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "success"
                ]
              },
              "info": {
                "key": "{theme.theme-2.color.communication.notifications.text-icon.info}",
                "value": "#175cd3",
                "type": "color",
                "original": {
                  "value": "#175cd3",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.text-icon.info}"
                },
                "name": "info",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "info"
                ]
              },
              "error": {
                "key": "{theme.theme-2.color.communication.notifications.text-icon.error}",
                "value": "#b42318",
                "type": "color",
                "original": {
                  "value": "#b42318",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.text-icon.error}"
                },
                "name": "error",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "error"
                ]
              },
              "alert": {
                "key": "{theme.theme-2.color.communication.notifications.text-icon.alert}",
                "value": "#a15c07",
                "type": "color",
                "original": {
                  "value": "#a15c07",
                  "type": "color",
                  "key": "{theme.theme-2.color.communication.notifications.text-icon.alert}"
                },
                "name": "alert",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "communication",
                  "state": "notifications"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "communication",
                  "notifications",
                  "text-icon",
                  "alert"
                ]
              }
            }
          },
          "badge": {
            "fill": {
              "key": "{theme.theme-2.color.communication.badge.fill}",
              "value": "#eaaa08",
              "type": "color",
              "original": {
                "value": "#eaaa08",
                "type": "color",
                "key": "{theme.theme-2.color.communication.badge.fill}"
              },
              "name": "fill",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "communication",
                "state": "badge"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "communication",
                "badge",
                "fill"
              ]
            }
          }
        },
        "containment": {
          "surface": {
            "fill": {
              "default": {
                "key": "{theme.theme-2.color.containment.surface.fill.default}",
                "value": "#eeeeee",
                "type": "color",
                "original": {
                  "value": "#eeeeee",
                  "type": "color",
                  "key": "{theme.theme-2.color.containment.surface.fill.default}"
                },
                "name": "default",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "default"
                ]
              },
              "overlay": {
                "key": "{theme.theme-2.color.containment.surface.fill.overlay}",
                "value": "rgba(0, 0, 0, 0.5)",
                "type": "color",
                "original": {
                  "value": "rgba(0, 0, 0, 0.5)",
                  "type": "color",
                  "key": "{theme.theme-2.color.containment.surface.fill.overlay}"
                },
                "name": "overlay",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "overlay"
                ]
              },
              "sunken": {
                "key": "{theme.theme-2.color.containment.surface.fill.sunken}",
                "value": "#e0e0e0",
                "type": "color",
                "original": {
                  "value": "#e0e0e0",
                  "type": "color",
                  "key": "{theme.theme-2.color.containment.surface.fill.sunken}"
                },
                "name": "sunken",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "sunken"
                ]
              },
              "raised-1": {
                "key": "{theme.theme-2.color.containment.surface.fill.raised-1}",
                "value": "#f5f5f5",
                "type": "color",
                "original": {
                  "value": "#f5f5f5",
                  "type": "color",
                  "key": "{theme.theme-2.color.containment.surface.fill.raised-1}"
                },
                "name": "raised-1",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "raised-1"
                ]
              },
              "raised-2": {
                "key": "{theme.theme-2.color.containment.surface.fill.raised-2}",
                "value": "#fafafa",
                "type": "color",
                "original": {
                  "value": "#fafafa",
                  "type": "color",
                  "key": "{theme.theme-2.color.containment.surface.fill.raised-2}"
                },
                "name": "raised-2",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "containment",
                  "surface",
                  "fill",
                  "raised-2"
                ]
              }
            },
            "border": {
              "divider": {
                "key": "{theme.theme-2.color.containment.surface.border.divider}",
                "value": "#bdbdbd",
                "type": "color",
                "original": {
                  "value": "#bdbdbd",
                  "type": "color",
                  "key": "{theme.theme-2.color.containment.surface.border.divider}"
                },
                "name": "divider",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "containment",
                  "state": "surface"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "containment",
                  "surface",
                  "border",
                  "divider"
                ]
              }
            }
          }
        },
        "generic": {
          "focused": {
            "key": "{theme.theme-2.color.generic.focused}",
            "value": "#a4bcfd",
            "type": "color",
            "original": {
              "value": "#a4bcfd",
              "type": "color",
              "key": "{theme.theme-2.color.generic.focused}"
            },
            "name": "focused",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "color",
              "subitem": "generic",
              "state": "focused"
            },
            "path": [
              "theme",
              "theme-2",
              "color",
              "generic",
              "focused"
            ]
          },
          "disabled": {
            "text-icon": {
              "key": "{theme.theme-2.color.generic.disabled.text-icon}",
              "value": "rgba(0, 0, 0, 0.3)",
              "type": "color",
              "original": {
                "value": "rgba(0, 0, 0, 0.3)",
                "type": "color",
                "key": "{theme.theme-2.color.generic.disabled.text-icon}"
              },
              "name": "text-icon",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "generic",
                "disabled",
                "text-icon"
              ]
            },
            "text-icon-inverse": {
              "key": "{theme.theme-2.color.generic.disabled.text-icon-inverse}",
              "value": "rgba(255, 255, 255, 0.3)",
              "type": "color",
              "original": {
                "value": "rgba(255, 255, 255, 0.3)",
                "type": "color",
                "key": "{theme.theme-2.color.generic.disabled.text-icon-inverse}"
              },
              "name": "text-icon-inverse",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "generic",
                "disabled",
                "text-icon-inverse"
              ]
            },
            "fill": {
              "key": "{theme.theme-2.color.generic.disabled.fill}",
              "value": "#bdbdbd",
              "type": "color",
              "original": {
                "value": "#bdbdbd",
                "type": "color",
                "key": "{theme.theme-2.color.generic.disabled.fill}"
              },
              "name": "fill",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "generic",
                "disabled",
                "fill"
              ]
            },
            "border": {
              "key": "{theme.theme-2.color.generic.disabled.border}",
              "value": "#bdbdbd",
              "type": "color",
              "original": {
                "value": "#bdbdbd",
                "type": "color",
                "key": "{theme.theme-2.color.generic.disabled.border}"
              },
              "name": "border",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "generic",
                "state": "disabled"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "generic",
                "disabled",
                "border"
              ]
            }
          },
          "brand": {
            "primary": {
              "enabled": {
                "key": "{theme.theme-2.color.generic.brand.primary.enabled}",
                "value": "#1c1917",
                "type": "color",
                "original": {
                  "value": "#1c1917",
                  "type": "color",
                  "key": "{theme.theme-2.color.generic.brand.primary.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "generic",
                  "state": "brand"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "generic",
                  "brand",
                  "primary",
                  "enabled"
                ]
              },
              "hover": {
                "key": "{theme.theme-2.color.generic.brand.primary.hover}",
                "value": "#44403c",
                "type": "color",
                "original": {
                  "value": "#44403c",
                  "type": "color",
                  "key": "{theme.theme-2.color.generic.brand.primary.hover}"
                },
                "name": "hover",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "generic",
                  "state": "brand"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "generic",
                  "brand",
                  "primary",
                  "hover"
                ]
              },
              "pressed": {
                "key": "{theme.theme-2.color.generic.brand.primary.pressed}",
                "value": "#57534e",
                "type": "color",
                "original": {
                  "value": "#57534e",
                  "type": "color",
                  "key": "{theme.theme-2.color.generic.brand.primary.pressed}"
                },
                "name": "pressed",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "generic",
                  "state": "brand"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "generic",
                  "brand",
                  "primary",
                  "pressed"
                ]
              }
            }
          }
        },
        "text-inputs": {
          "border": {
            "enabled": {
              "key": "{theme.theme-2.color.text-inputs.border.enabled}",
              "value": "#383838",
              "type": "color",
              "original": {
                "value": "#383838",
                "type": "color",
                "key": "{theme.theme-2.color.text-inputs.border.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "text-inputs",
                "state": "border"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "text-inputs",
                "border",
                "enabled"
              ]
            },
            "active": {
              "key": "{theme.theme-2.color.text-inputs.border.active}",
              "value": "#1c1917",
              "type": "color",
              "original": {
                "value": "#1c1917",
                "type": "color",
                "key": "{theme.theme-2.color.text-inputs.border.active}"
              },
              "name": "active",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "text-inputs",
                "state": "border"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "text-inputs",
                "border",
                "active"
              ]
            }
          }
        },
        "text-icon": {
          "common": {
            "high-emphesis": {
              "key": "{theme.theme-2.color.text-icon.common.high-emphesis}",
              "value": "rgba(0, 0, 0, 0.9)",
              "type": "color",
              "original": {
                "value": "rgba(0, 0, 0, 0.9)",
                "type": "color",
                "key": "{theme.theme-2.color.text-icon.common.high-emphesis}"
              },
              "name": "high-emphesis",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "text-icon",
                "state": "common"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "text-icon",
                "common",
                "high-emphesis"
              ]
            },
            "medium-emphasis": {
              "key": "{theme.theme-2.color.text-icon.common.medium-emphasis}",
              "value": "rgba(0, 0, 0, 0.7)",
              "type": "color",
              "original": {
                "value": "rgba(0, 0, 0, 0.7)",
                "type": "color",
                "key": "{theme.theme-2.color.text-icon.common.medium-emphasis}"
              },
              "name": "medium-emphasis",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "text-icon",
                "state": "common"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "text-icon",
                "common",
                "medium-emphasis"
              ]
            }
          },
          "common-inverse": {
            "high-emphasis": {
              "key": "{theme.theme-2.color.text-icon.common-inverse.high-emphasis}",
              "value": "rgba(255, 255, 255, 0.9)",
              "type": "color",
              "original": {
                "value": "rgba(255, 255, 255, 0.9)",
                "type": "color",
                "key": "{theme.theme-2.color.text-icon.common-inverse.high-emphasis}"
              },
              "name": "high-emphasis",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "text-icon",
                "state": "common-inverse"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "text-icon",
                "common-inverse",
                "high-emphasis"
              ]
            },
            "medium-emphasis": {
              "key": "{theme.theme-2.color.text-icon.common-inverse.medium-emphasis}",
              "value": "rgba(255, 255, 255, 0.7)",
              "type": "color",
              "original": {
                "value": "rgba(255, 255, 255, 0.7)",
                "type": "color",
                "key": "{theme.theme-2.color.text-icon.common-inverse.medium-emphasis}"
              },
              "name": "medium-emphasis",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "color",
                "subitem": "text-icon",
                "state": "common-inverse"
              },
              "path": [
                "theme",
                "theme-2",
                "color",
                "text-icon",
                "common-inverse",
                "medium-emphasis"
              ]
            }
          }
        },
        "selection": {
          "checkbox-radio": {
            "fill": {
              "selected": {
                "key": "{theme.theme-2.color.selection.checkbox-radio.fill.selected}",
                "value": "#212121",
                "type": "color",
                "original": {
                  "value": "#212121",
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.checkbox-radio.fill.selected}"
                },
                "name": "selected",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "fill",
                  "selected"
                ]
              },
              "selected-critical": {
                "key": "{theme.theme-2.color.selection.checkbox-radio.fill.selected-critical}",
                "value": "#b42318",
                "type": "color",
                "original": {
                  "value": "#b42318",
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.checkbox-radio.fill.selected-critical}"
                },
                "name": "selected-critical",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "fill",
                  "selected-critical"
                ]
              }
            },
            "border": {
              "enabled": {
                "key": "{theme.theme-2.color.selection.checkbox-radio.border.enabled}",
                "value": null,
                "type": "color",
                "original": {
                  "value": null,
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.checkbox-radio.border.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "border",
                  "enabled"
                ]
              },
              "enabled-critical": {
                "key": "{theme.theme-2.color.selection.checkbox-radio.border.enabled-critical}",
                "value": "#b42318",
                "type": "color",
                "original": {
                  "value": "#b42318",
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.checkbox-radio.border.enabled-critical}"
                },
                "name": "enabled-critical",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "checkbox-radio"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "checkbox-radio",
                  "border",
                  "enabled-critical"
                ]
              }
            }
          },
          "dropdown": {
            "border": {
              "enabled": {
                "key": "{theme.theme-2.color.selection.dropdown.border.enabled}",
                "value": "#383838",
                "type": "color",
                "original": {
                  "value": "#383838",
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.dropdown.border.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "dropdown"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "dropdown",
                  "border",
                  "enabled"
                ]
              }
            }
          },
          "chips": {
            "border": {
              "primary": {
                "selected": {
                  "key": "{theme.theme-2.color.selection.chips.border.primary.selected}",
                  "value": "#1c1917",
                  "type": "color",
                  "original": {
                    "value": "#1c1917",
                    "type": "color",
                    "key": "{theme.theme-2.color.selection.chips.border.primary.selected}"
                  },
                  "name": "selected",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "color",
                    "subitem": "selection",
                    "state": "chips"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "color",
                    "selection",
                    "chips",
                    "border",
                    "primary",
                    "selected"
                  ]
                }
              }
            }
          },
          "switch-knob": {
            "fill": {
              "enabled": {
                "key": "{theme.theme-2.color.selection.switch-knob.fill.enabled}",
                "value": "#757575",
                "type": "color",
                "original": {
                  "value": "#757575",
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.switch-knob.fill.enabled}"
                },
                "name": "enabled",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "switch-knob"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "switch-knob",
                  "fill",
                  "enabled"
                ]
              },
              "selected": {
                "key": "{theme.theme-2.color.selection.switch-knob.fill.selected}",
                "value": "#fafafa",
                "type": "color",
                "original": {
                  "value": "#fafafa",
                  "type": "color",
                  "key": "{theme.theme-2.color.selection.switch-knob.fill.selected}"
                },
                "name": "selected",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "color",
                  "subitem": "selection",
                  "state": "switch-knob"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "color",
                  "selection",
                  "switch-knob",
                  "fill",
                  "selected"
                ]
              }
            }
          }
        }
      },
      "float": {
        "type-scale": {
          "size": {
            "xs": {
              "key": "{theme.theme-2.float.type-scale.size.xs}",
              "value": 14,
              "type": "number",
              "original": {
                "value": 14,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.xs}"
              },
              "name": "xs",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "xs"
              ]
            },
            "sm": {
              "key": "{theme.theme-2.float.type-scale.size.sm}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "sm"
              ]
            },
            "md": {
              "key": "{theme.theme-2.float.type-scale.size.md}",
              "value": 20,
              "type": "number",
              "original": {
                "value": 20,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.md}"
              },
              "name": "md",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "md"
              ]
            },
            "lg": {
              "key": "{theme.theme-2.float.type-scale.size.lg}",
              "value": 24,
              "type": "number",
              "original": {
                "value": 24,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.lg}"
              },
              "name": "lg",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "lg"
              ]
            },
            "xl": {
              "key": "{theme.theme-2.float.type-scale.size.xl}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.xl}"
              },
              "name": "xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "xl"
              ]
            },
            "2xl": {
              "key": "{theme.theme-2.float.type-scale.size.2xl}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.2xl}"
              },
              "name": "2xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "2xl"
              ]
            },
            "3xl": {
              "key": "{theme.theme-2.float.type-scale.size.3xl}",
              "value": 48,
              "type": "number",
              "original": {
                "value": 48,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.3xl}"
              },
              "name": "3xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "3xl"
              ]
            },
            "4xl": {
              "key": "{theme.theme-2.float.type-scale.size.4xl}",
              "value": 56,
              "type": "number",
              "original": {
                "value": 56,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.4xl}"
              },
              "name": "4xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "4xl"
              ]
            },
            "2xs": {
              "key": "{theme.theme-2.float.type-scale.size.2xs}",
              "value": 12,
              "type": "number",
              "original": {
                "value": 12,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.size.2xs}"
              },
              "name": "2xs",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "size"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "size",
                "2xs"
              ]
            }
          },
          "line-height": {
            "2xs": {
              "key": "{theme.theme-2.float.type-scale.line-height.2xs}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.2xs}"
              },
              "name": "2xs",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "2xs"
              ]
            },
            "sm": {
              "key": "{theme.theme-2.float.type-scale.line-height.sm}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "sm"
              ]
            },
            "md": {
              "key": "{theme.theme-2.float.type-scale.line-height.md}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.md}"
              },
              "name": "md",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "md"
              ]
            },
            "lg": {
              "key": "{theme.theme-2.float.type-scale.line-height.lg}",
              "value": 48,
              "type": "number",
              "original": {
                "value": 48,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.lg}"
              },
              "name": "lg",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "lg"
              ]
            },
            "xl": {
              "key": "{theme.theme-2.float.type-scale.line-height.xl}",
              "value": 56,
              "type": "number",
              "original": {
                "value": 56,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.xl}"
              },
              "name": "xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "xl"
              ]
            },
            "2xl": {
              "key": "{theme.theme-2.float.type-scale.line-height.2xl}",
              "value": 64,
              "type": "number",
              "original": {
                "value": 64,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.2xl}"
              },
              "name": "2xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "2xl"
              ]
            },
            "xs": {
              "key": "{theme.theme-2.float.type-scale.line-height.xs}",
              "value": 24,
              "type": "number",
              "original": {
                "value": 24,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.line-height.xs}"
              },
              "name": "xs",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "line-height"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "line-height",
                "xs"
              ]
            }
          },
          "paragraph-spacing": {
            "xs": {
              "key": "{theme.theme-2.float.type-scale.paragraph-spacing.xs}",
              "value": 14,
              "type": "number",
              "original": {
                "value": 14,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.paragraph-spacing.xs}"
              },
              "name": "xs",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "paragraph-spacing",
                "xs"
              ]
            },
            "sm": {
              "key": "{theme.theme-2.float.type-scale.paragraph-spacing.sm}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.paragraph-spacing.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "paragraph-spacing",
                "sm"
              ]
            },
            "md": {
              "key": "{theme.theme-2.float.type-scale.paragraph-spacing.md}",
              "value": 20,
              "type": "number",
              "original": {
                "value": 20,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.paragraph-spacing.md}"
              },
              "name": "md",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "paragraph-spacing",
                "md"
              ]
            },
            "lg": {
              "key": "{theme.theme-2.float.type-scale.paragraph-spacing.lg}",
              "value": 24,
              "type": "number",
              "original": {
                "value": 24,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.paragraph-spacing.lg}"
              },
              "name": "lg",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "paragraph-spacing",
                "lg"
              ]
            },
            "xl": {
              "key": "{theme.theme-2.float.type-scale.paragraph-spacing.xl}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.paragraph-spacing.xl}"
              },
              "name": "xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "paragraph-spacing",
                "xl"
              ]
            },
            "2xl": {
              "key": "{theme.theme-2.float.type-scale.paragraph-spacing.2xl}",
              "value": 56,
              "type": "number",
              "original": {
                "value": 56,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.paragraph-spacing.2xl}"
              },
              "name": "2xl",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "paragraph-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "paragraph-spacing",
                "2xl"
              ]
            }
          },
          "letter-spacing": {
            "sm": {
              "key": "{theme.theme-2.float.type-scale.letter-spacing.sm}",
              "value": 0,
              "type": "number",
              "original": {
                "value": 0,
                "type": "number",
                "key": "{theme.theme-2.float.type-scale.letter-spacing.sm}"
              },
              "name": "sm",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "type-scale",
                "state": "letter-spacing"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "type-scale",
                "letter-spacing",
                "sm"
              ]
            }
          }
        },
        "radii": {
          "action": {
            "button": {
              "key": "{theme.theme-2.float.radii.action.button}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-2.float.radii.action.button}"
              },
              "name": "button",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "action"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "action",
                "button"
              ]
            },
            "fab": {
              "key": "{theme.theme-2.float.radii.action.fab}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-2.float.radii.action.fab}"
              },
              "name": "fab",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "action"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "action",
                "fab"
              ]
            }
          },
          "selection": {
            "chips": {
              "key": "{theme.theme-2.float.radii.selection.chips}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-2.float.radii.selection.chips}"
              },
              "name": "chips",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "selection",
                "chips"
              ]
            },
            "switch": {
              "key": "{theme.theme-2.float.radii.selection.switch}",
              "value": 32,
              "type": "number",
              "original": {
                "value": 32,
                "type": "number",
                "key": "{theme.theme-2.float.radii.selection.switch}"
              },
              "name": "switch",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "selection",
                "switch"
              ]
            },
            "radio-selector": {
              "key": "{theme.theme-2.float.radii.selection.radio-selector}",
              "value": 40,
              "type": "number",
              "original": {
                "value": 40,
                "type": "number",
                "key": "{theme.theme-2.float.radii.selection.radio-selector}"
              },
              "name": "radio-selector",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "selection",
                "radio-selector"
              ]
            },
            "checkbox": {
              "key": "{theme.theme-2.float.radii.selection.checkbox}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-2.float.radii.selection.checkbox}"
              },
              "name": "checkbox",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "selection",
                "checkbox"
              ]
            }
          },
          "communication": {
            "banner": {
              "key": "{theme.theme-2.float.radii.communication.banner}",
              "value": 12,
              "type": "number",
              "original": {
                "value": 12,
                "type": "number",
                "key": "{theme.theme-2.float.radii.communication.banner}"
              },
              "name": "banner",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "communication",
                "banner"
              ]
            },
            "toast": {
              "key": "{theme.theme-2.float.radii.communication.toast}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-2.float.radii.communication.toast}"
              },
              "name": "toast",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "communication",
                "toast"
              ]
            },
            "tag": {
              "key": "{theme.theme-2.float.radii.communication.tag}",
              "value": 2,
              "type": "number",
              "original": {
                "value": 2,
                "type": "number",
                "key": "{theme.theme-2.float.radii.communication.tag}"
              },
              "name": "tag",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "communication",
                "tag"
              ]
            },
            "tool-tip": {
              "key": "{theme.theme-2.float.radii.communication.tool-tip}",
              "value": null,
              "type": "number",
              "original": {
                "value": null,
                "type": "number",
                "key": "{theme.theme-2.float.radii.communication.tool-tip}"
              },
              "name": "tool-tip",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "communication",
                "tool-tip"
              ]
            },
            "badge": {
              "key": "{theme.theme-2.float.radii.communication.badge}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-2.float.radii.communication.badge}"
              },
              "name": "badge",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "communication",
                "badge"
              ]
            },
            "dialog": {
              "key": "{theme.theme-2.float.radii.communication.dialog}",
              "value": 8,
              "type": "number",
              "original": {
                "value": 8,
                "type": "number",
                "key": "{theme.theme-2.float.radii.communication.dialog}"
              },
              "name": "dialog",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "communication",
                "dialog"
              ]
            }
          },
          "containment": {
            "card": {
              "key": "{theme.theme-2.float.radii.containment.card}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-2.float.radii.containment.card}"
              },
              "name": "card",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "containment"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "containment",
                "card"
              ]
            },
            "menu": {
              "key": "{theme.theme-2.float.radii.containment.menu}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-2.float.radii.containment.menu}"
              },
              "name": "menu",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "containment"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "containment",
                "menu"
              ]
            }
          },
          "text-input": {
            "field": {
              "key": "{theme.theme-2.float.radii.text-input.field}",
              "value": 4,
              "type": "number",
              "original": {
                "value": 4,
                "type": "number",
                "key": "{theme.theme-2.float.radii.text-input.field}"
              },
              "name": "field",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "radii",
                "state": "text-input"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "radii",
                "text-input",
                "field"
              ]
            }
          }
        },
        "stroke-width": {
          "action": {
            "button": {
              "outline": {
                "key": "{theme.theme-2.float.stroke-width.action.button.outline}",
                "value": 1,
                "type": "number",
                "original": {
                  "value": 1,
                  "type": "number",
                  "key": "{theme.theme-2.float.stroke-width.action.button.outline}"
                },
                "name": "outline",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "stroke-width",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "stroke-width",
                  "action",
                  "button",
                  "outline"
                ]
              }
            }
          },
          "selection": {
            "checkbox": {
              "key": "{theme.theme-2.float.stroke-width.selection.checkbox}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.checkbox}"
              },
              "name": "checkbox",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "checkbox"
              ]
            },
            "radio-selector": {
              "key": "{theme.theme-2.float.stroke-width.selection.radio-selector}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.radio-selector}"
              },
              "name": "radio-selector",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "radio-selector"
              ]
            },
            "focused": {
              "key": "{theme.theme-2.float.stroke-width.selection.focused}",
              "value": 2,
              "type": "number",
              "original": {
                "value": 2,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.focused}"
              },
              "name": "focused",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "focused"
              ]
            },
            "dropdown": {
              "key": "{theme.theme-2.float.stroke-width.selection.dropdown}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.dropdown}"
              },
              "name": "dropdown",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "dropdown"
              ]
            },
            "date-picker": {
              "key": "{theme.theme-2.float.stroke-width.selection.date-picker}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.date-picker}"
              },
              "name": "date-picker",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "date-picker"
              ]
            },
            "chips": {
              "key": "{theme.theme-2.float.stroke-width.selection.chips}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.chips}"
              },
              "name": "chips",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "chips"
              ]
            },
            "switch": {
              "key": "{theme.theme-2.float.stroke-width.selection.switch}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.selection.switch}"
              },
              "name": "switch",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "selection"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "selection",
                "switch"
              ]
            }
          },
          "communication": {
            "tag": {
              "key": "{theme.theme-2.float.stroke-width.communication.tag}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.communication.tag}"
              },
              "name": "tag",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "communication",
                "tag"
              ]
            },
            "notifications": {
              "key": "{theme.theme-2.float.stroke-width.communication.notifications}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.communication.notifications}"
              },
              "name": "notifications",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "communication"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "communication",
                "notifications"
              ]
            }
          },
          "text-inputs": {
            "field": {
              "key": "{theme.theme-2.float.stroke-width.text-inputs.field}",
              "value": 1,
              "type": "number",
              "original": {
                "value": 1,
                "type": "number",
                "key": "{theme.theme-2.float.stroke-width.text-inputs.field}"
              },
              "name": "field",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "stroke-width",
                "state": "text-inputs"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "stroke-width",
                "text-inputs",
                "field"
              ]
            }
          }
        },
        "elevation": {
          "action": {
            "fab": {
              "potision-x": {
                "key": "{theme.theme-2.float.elevation.action.fab.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.action.fab.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "potision-x"
                ]
              },
              "blur": {
                "key": "{theme.theme-2.float.elevation.action.fab.blur}",
                "value": 16,
                "type": "number",
                "original": {
                  "value": 16,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.action.fab.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-2.float.elevation.action.fab.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.action.fab.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "spread"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-2.float.elevation.action.fab.potision-y}",
                "value": 12,
                "type": "number",
                "original": {
                  "value": 12,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.action.fab.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "action"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "action",
                  "fab",
                  "potision-y"
                ]
              }
            }
          },
          "containment": {
            "menu": {
              "potision-x": {
                "key": "{theme.theme-2.float.elevation.containment.menu.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.menu.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-2.float.elevation.containment.menu.potision-y}",
                "value": 12,
                "type": "number",
                "original": {
                  "value": 12,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.menu.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-2.float.elevation.containment.menu.blur}",
                "value": 16,
                "type": "number",
                "original": {
                  "value": 16,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.menu.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-2.float.elevation.containment.menu.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.menu.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "menu",
                  "spread"
                ]
              }
            },
            "card": {
              "enabled": {
                "potision-x": {
                  "key": "{theme.theme-2.float.elevation.containment.card.enabled.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.enabled.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-2.float.elevation.containment.card.enabled.potision-y}",
                  "value": 2,
                  "type": "number",
                  "original": {
                    "value": 2,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.enabled.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-2.float.elevation.containment.card.enabled.blur}",
                  "value": 2,
                  "type": "number",
                  "original": {
                    "value": 2,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.enabled.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-2.float.elevation.containment.card.enabled.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.enabled.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "enabled",
                    "spread"
                  ]
                }
              },
              "hover": {
                "potision-x": {
                  "key": "{theme.theme-2.float.elevation.containment.card.hover.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.hover.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-2.float.elevation.containment.card.hover.potision-y}",
                  "value": 4,
                  "type": "number",
                  "original": {
                    "value": 4,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.hover.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-2.float.elevation.containment.card.hover.blur}",
                  "value": 4,
                  "type": "number",
                  "original": {
                    "value": 4,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.hover.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-2.float.elevation.containment.card.hover.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.hover.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "hover",
                    "spread"
                  ]
                }
              },
              "selected": {
                "potision-x": {
                  "key": "{theme.theme-2.float.elevation.containment.card.selected.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.selected.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-2.float.elevation.containment.card.selected.potision-y}",
                  "value": 12,
                  "type": "number",
                  "original": {
                    "value": 12,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.selected.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-2.float.elevation.containment.card.selected.blur}",
                  "value": 16,
                  "type": "number",
                  "original": {
                    "value": 16,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.selected.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-2.float.elevation.containment.card.selected.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.selected.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "selected",
                    "spread"
                  ]
                }
              },
              "dragged": {
                "potision-x": {
                  "key": "{theme.theme-2.float.elevation.containment.card.dragged.potision-x}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.dragged.potision-x}"
                  },
                  "name": "potision-x",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "potision-x"
                  ]
                },
                "potision-y": {
                  "key": "{theme.theme-2.float.elevation.containment.card.dragged.potision-y}",
                  "value": 12,
                  "type": "number",
                  "original": {
                    "value": 12,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.dragged.potision-y}"
                  },
                  "name": "potision-y",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "potision-y"
                  ]
                },
                "blur": {
                  "key": "{theme.theme-2.float.elevation.containment.card.dragged.blur}",
                  "value": 16,
                  "type": "number",
                  "original": {
                    "value": 16,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.dragged.blur}"
                  },
                  "name": "blur",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "blur"
                  ]
                },
                "spread": {
                  "key": "{theme.theme-2.float.elevation.containment.card.dragged.spread}",
                  "value": 0,
                  "type": "number",
                  "original": {
                    "value": 0,
                    "type": "number",
                    "key": "{theme.theme-2.float.elevation.containment.card.dragged.spread}"
                  },
                  "name": "spread",
                  "attributes": {
                    "category": "theme",
                    "type": "theme-2",
                    "item": "float",
                    "subitem": "elevation",
                    "state": "containment"
                  },
                  "path": [
                    "theme",
                    "theme-2",
                    "float",
                    "elevation",
                    "containment",
                    "card",
                    "dragged",
                    "spread"
                  ]
                }
              }
            },
            "dialog": {
              "potision-x": {
                "key": "{theme.theme-2.float.elevation.containment.dialog.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.dialog.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-2.float.elevation.containment.dialog.potision-y}",
                "value": 12,
                "type": "number",
                "original": {
                  "value": 12,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.dialog.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-2.float.elevation.containment.dialog.blur}",
                "value": 16,
                "type": "number",
                "original": {
                  "value": 16,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.dialog.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-2.float.elevation.containment.dialog.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.containment.dialog.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "containment"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "containment",
                  "dialog",
                  "spread"
                ]
              }
            }
          },
          "communication": {
            "toast": {
              "potision-x": {
                "key": "{theme.theme-2.float.elevation.communication.toast.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.toast.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-2.float.elevation.communication.toast.potision-y}",
                "value": 12,
                "type": "number",
                "original": {
                  "value": 12,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.toast.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-2.float.elevation.communication.toast.blur}",
                "value": 16,
                "type": "number",
                "original": {
                  "value": 16,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.toast.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-2.float.elevation.communication.toast.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.toast.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "toast",
                  "spread"
                ]
              }
            },
            "snack-bar": {
              "potision-x": {
                "key": "{theme.theme-2.float.elevation.communication.snack-bar.potision-x}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.snack-bar.potision-x}"
                },
                "name": "potision-x",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "potision-x"
                ]
              },
              "potision-y": {
                "key": "{theme.theme-2.float.elevation.communication.snack-bar.potision-y}",
                "value": 12,
                "type": "number",
                "original": {
                  "value": 12,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.snack-bar.potision-y}"
                },
                "name": "potision-y",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "potision-y"
                ]
              },
              "blur": {
                "key": "{theme.theme-2.float.elevation.communication.snack-bar.blur}",
                "value": 16,
                "type": "number",
                "original": {
                  "value": 16,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.snack-bar.blur}"
                },
                "name": "blur",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "blur"
                ]
              },
              "spread": {
                "key": "{theme.theme-2.float.elevation.communication.snack-bar.spread}",
                "value": 0,
                "type": "number",
                "original": {
                  "value": 0,
                  "type": "number",
                  "key": "{theme.theme-2.float.elevation.communication.snack-bar.spread}"
                },
                "name": "spread",
                "attributes": {
                  "category": "theme",
                  "type": "theme-2",
                  "item": "float",
                  "subitem": "elevation",
                  "state": "communication"
                },
                "path": [
                  "theme",
                  "theme-2",
                  "float",
                  "elevation",
                  "communication",
                  "snack-bar",
                  "spread"
                ]
              }
            }
          }
        },
        "proportion": {
          "2": {
            "key": "{theme.theme-2.float.proportion.2}",
            "value": 16,
            "type": "number",
            "original": {
              "value": 16,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.2}"
            },
            "name": "2",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "2"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "2"
            ]
          },
          "3": {
            "key": "{theme.theme-2.float.proportion.3}",
            "value": 24,
            "type": "number",
            "original": {
              "value": 24,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.3}"
            },
            "name": "3",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "3"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "3"
            ]
          },
          "4": {
            "key": "{theme.theme-2.float.proportion.4}",
            "value": 32,
            "type": "number",
            "original": {
              "value": 32,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.4}"
            },
            "name": "4",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "4"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "4"
            ]
          },
          "5": {
            "key": "{theme.theme-2.float.proportion.5}",
            "value": 40,
            "type": "number",
            "original": {
              "value": 40,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.5}"
            },
            "name": "5",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "5"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "5"
            ]
          },
          "6": {
            "key": "{theme.theme-2.float.proportion.6}",
            "value": 48,
            "type": "number",
            "original": {
              "value": 48,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.6}"
            },
            "name": "6",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "6"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "6"
            ]
          },
          "25": {
            "key": "{theme.theme-2.float.proportion.25}",
            "value": 2,
            "type": "number",
            "original": {
              "value": 2,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.25}"
            },
            "name": "25",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "25"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "25"
            ]
          },
          "50": {
            "key": "{theme.theme-2.float.proportion.50}",
            "value": 4,
            "type": "number",
            "original": {
              "value": 4,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.50}"
            },
            "name": "50",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "50"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "50"
            ]
          },
          "75": {
            "key": "{theme.theme-2.float.proportion.75}",
            "value": 6,
            "type": "number",
            "original": {
              "value": 6,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.75}"
            },
            "name": "75",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "75"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "75"
            ]
          },
          "125": {
            "key": "{theme.theme-2.float.proportion.125}",
            "value": 1,
            "type": "number",
            "original": {
              "value": 1,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.125}"
            },
            "name": "125",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "125"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "125"
            ]
          },
          "1-default-unit": {
            "key": "{theme.theme-2.float.proportion.1-default-unit}",
            "value": 8,
            "type": "number",
            "original": {
              "value": 8,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.1-default-unit}"
            },
            "name": "1-default-unit",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "1-default-unit"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "1-default-unit"
            ]
          },
          "1-50": {
            "key": "{theme.theme-2.float.proportion.1-50}",
            "value": 12,
            "type": "number",
            "original": {
              "value": 12,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.1-50}"
            },
            "name": "1-50",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "1-50"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "1-50"
            ]
          },
          "2-50": {
            "key": "{theme.theme-2.float.proportion.2-50}",
            "value": 20,
            "type": "number",
            "original": {
              "value": 20,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.2-50}"
            },
            "name": "2-50",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "2-50"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "2-50"
            ]
          },
          "zero": {
            "key": "{theme.theme-2.float.proportion.zero}",
            "value": 0,
            "type": "number",
            "original": {
              "value": 0,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.zero}"
            },
            "name": "zero",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "zero"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "zero"
            ]
          },
          "6-50": {
            "key": "{theme.theme-2.float.proportion.6-50}",
            "value": 52,
            "type": "number",
            "original": {
              "value": 52,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.6-50}"
            },
            "name": "6-50",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "6-50"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "6-50"
            ]
          },
          "4-50": {
            "key": "{theme.theme-2.float.proportion.4-50}",
            "value": 36,
            "type": "number",
            "original": {
              "value": 36,
              "type": "number",
              "key": "{theme.theme-2.float.proportion.4-50}"
            },
            "name": "4-50",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "float",
              "subitem": "proportion",
              "state": "4-50"
            },
            "path": [
              "theme",
              "theme-2",
              "float",
              "proportion",
              "4-50"
            ]
          }
        },
        "opacity": {
          "background": {
            "enabled": {
              "key": "{theme.theme-2.float.opacity.background.enabled}",
              "value": 0,
              "type": "number",
              "original": {
                "value": 0,
                "type": "number",
                "key": "{theme.theme-2.float.opacity.background.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "opacity",
                "background",
                "enabled"
              ]
            },
            "hover": {
              "key": "{theme.theme-2.float.opacity.background.hover}",
              "value": 8,
              "type": "number",
              "original": {
                "value": 8,
                "type": "number",
                "key": "{theme.theme-2.float.opacity.background.hover}"
              },
              "name": "hover",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "opacity",
                "background",
                "hover"
              ]
            },
            "pressed": {
              "key": "{theme.theme-2.float.opacity.background.pressed}",
              "value": 12,
              "type": "number",
              "original": {
                "value": 12,
                "type": "number",
                "key": "{theme.theme-2.float.opacity.background.pressed}"
              },
              "name": "pressed",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "opacity",
                "background",
                "pressed"
              ]
            },
            "selected": {
              "key": "{theme.theme-2.float.opacity.background.selected}",
              "value": 16,
              "type": "number",
              "original": {
                "value": 16,
                "type": "number",
                "key": "{theme.theme-2.float.opacity.background.selected}"
              },
              "name": "selected",
              "attributes": {
                "category": "theme",
                "type": "theme-2",
                "item": "float",
                "subitem": "opacity",
                "state": "background"
              },
              "path": [
                "theme",
                "theme-2",
                "float",
                "opacity",
                "background",
                "selected"
              ]
            }
          }
        }
      },
      "string": {
        "typography": {
          "expressive": {
            "key": "{theme.theme-2.string.typography.expressive}",
            "value": "Helvetica Neue",
            "type": "string",
            "original": {
              "value": "Helvetica Neue",
              "type": "string",
              "key": "{theme.theme-2.string.typography.expressive}"
            },
            "name": "expressive",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "string",
              "subitem": "typography",
              "state": "expressive"
            },
            "path": [
              "theme",
              "theme-2",
              "string",
              "typography",
              "expressive"
            ]
          },
          "productive": {
            "key": "{theme.theme-2.string.typography.productive}",
            "value": "Helvetica Neue",
            "type": "string",
            "original": {
              "value": "Helvetica Neue",
              "type": "string",
              "key": "{theme.theme-2.string.typography.productive}"
            },
            "name": "productive",
            "attributes": {
              "category": "theme",
              "type": "theme-2",
              "item": "string",
              "subitem": "typography",
              "state": "productive"
            },
            "path": [
              "theme",
              "theme-2",
              "string",
              "typography",
              "productive"
            ]
          }
        }
      }
    }
  },
  "styles": {
    "text": {
      "display": {
        "01": {
          "key": "{styles.text.display.01}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "48px",
            "lineHeight": "56px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "48px",
              "lineHeight": "56px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.display.01}"
          },
          "name": "01",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "display",
            "subitem": "01"
          },
          "path": [
            "styles",
            "text",
            "display",
            "01"
          ]
        },
        "02": {
          "key": "{styles.text.display.02}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "40px",
            "lineHeight": "48px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "40px",
              "lineHeight": "48px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.display.02}"
          },
          "name": "02",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "display",
            "subitem": "02"
          },
          "path": [
            "styles",
            "text",
            "display",
            "02"
          ]
        }
      },
      "headline": {
        "01": {
          "key": "{styles.text.headline.01}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "32px",
            "lineHeight": "40px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "32px",
              "lineHeight": "40px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.headline.01}"
          },
          "name": "01",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "headline",
            "subitem": "01"
          },
          "path": [
            "styles",
            "text",
            "headline",
            "01"
          ]
        },
        "02": {
          "key": "{styles.text.headline.02}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "24px",
            "lineHeight": "32px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "24px",
              "lineHeight": "32px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.headline.02}"
          },
          "name": "02",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "headline",
            "subitem": "02"
          },
          "path": [
            "styles",
            "text",
            "headline",
            "02"
          ]
        },
        "03": {
          "key": "{styles.text.headline.03}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "20px",
            "lineHeight": "24px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "20px",
              "lineHeight": "24px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.headline.03}"
          },
          "name": "03",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "headline",
            "subitem": "03"
          },
          "path": [
            "styles",
            "text",
            "headline",
            "03"
          ]
        }
      },
      "subtitle": {
        "01": {
          "key": "{styles.text.subtitle.01}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 600,
            "fontStyle": "normal",
            "fontSize": "14px",
            "lineHeight": "20px",
            "letterSpacing": "0px",
            "textCase": "UPPER",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 600,
              "fontStyle": "normal",
              "fontSize": "14px",
              "lineHeight": "20px",
              "letterSpacing": "0px",
              "textCase": "UPPER",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.subtitle.01}"
          },
          "name": "01",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "subtitle",
            "subitem": "01"
          },
          "path": [
            "styles",
            "text",
            "subtitle",
            "01"
          ]
        }
      },
      "body": {
        "regular": {
          "key": "{styles.text.body.regular}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "14px",
            "lineHeight": "20px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "14px",
              "lineHeight": "20px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.body.regular}"
          },
          "name": "regular",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "body",
            "subitem": "regular"
          },
          "path": [
            "styles",
            "text",
            "body",
            "regular"
          ]
        },
        "strong": {
          "key": "{styles.text.body.strong}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 700,
            "fontStyle": "normal",
            "fontSize": "14px",
            "lineHeight": "20px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 700,
              "fontStyle": "normal",
              "fontSize": "14px",
              "lineHeight": "20px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.body.strong}"
          },
          "name": "strong",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "body",
            "subitem": "strong"
          },
          "path": [
            "styles",
            "text",
            "body",
            "strong"
          ]
        },
        "text-link": {
          "key": "{styles.text.body.text-link}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "14px",
            "lineHeight": "20px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "UNDERLINE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "14px",
              "lineHeight": "20px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "UNDERLINE"
            },
            "type": "typography",
            "key": "{styles.text.body.text-link}"
          },
          "name": "text-link",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "body",
            "subitem": "text-link"
          },
          "path": [
            "styles",
            "text",
            "body",
            "text-link"
          ]
        }
      },
      "interface": {
        "eyebrow": {
          "key": "{styles.text.interface.eyebrow}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 500,
            "fontStyle": "normal",
            "fontSize": "10px",
            "lineHeight": "16px",
            "letterSpacing": "0px",
            "textCase": "UPPER",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 500,
              "fontStyle": "normal",
              "fontSize": "10px",
              "lineHeight": "16px",
              "letterSpacing": "0px",
              "textCase": "UPPER",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.interface.eyebrow}"
          },
          "name": "eyebrow",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "interface",
            "subitem": "eyebrow"
          },
          "path": [
            "styles",
            "text",
            "interface",
            "eyebrow"
          ]
        },
        "button": {
          "key": "{styles.text.interface.button}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 700,
            "fontStyle": "normal",
            "fontSize": "14px",
            "lineHeight": "16px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 700,
              "fontStyle": "normal",
              "fontSize": "14px",
              "lineHeight": "16px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.interface.button}"
          },
          "name": "button",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "interface",
            "subitem": "button"
          },
          "path": [
            "styles",
            "text",
            "interface",
            "button"
          ]
        },
        "button-sm": {
          "key": "{styles.text.interface.button-sm}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 700,
            "fontStyle": "normal",
            "fontSize": "12px",
            "lineHeight": "16px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 700,
              "fontStyle": "normal",
              "fontSize": "12px",
              "lineHeight": "16px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.interface.button-sm}"
          },
          "name": "button-sm",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "interface",
            "subitem": "button-sm"
          },
          "path": [
            "styles",
            "text",
            "interface",
            "button-sm"
          ]
        },
        "legal-regular": {
          "key": "{styles.text.interface.legal-regular}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 400,
            "fontStyle": "normal",
            "fontSize": "12px",
            "lineHeight": "16px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 400,
              "fontStyle": "normal",
              "fontSize": "12px",
              "lineHeight": "16px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.interface.legal-regular}"
          },
          "name": "legal-regular",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "interface",
            "subitem": "legal-regular"
          },
          "path": [
            "styles",
            "text",
            "interface",
            "legal-regular"
          ]
        },
        "legal-bold": {
          "key": "{styles.text.interface.legal-bold}",
          "value": {
            "fontFamily": "Helvetica Neue",
            "fontWeight": 700,
            "fontStyle": "normal",
            "fontSize": "12px",
            "lineHeight": "16px",
            "letterSpacing": "0px",
            "textCase": "ORIGINAL",
            "textDecoration": "NONE"
          },
          "type": "typography",
          "original": {
            "value": {
              "fontFamily": "Helvetica Neue",
              "fontWeight": 700,
              "fontStyle": "normal",
              "fontSize": "12px",
              "lineHeight": "16px",
              "letterSpacing": "0px",
              "textCase": "ORIGINAL",
              "textDecoration": "NONE"
            },
            "type": "typography",
            "key": "{styles.text.interface.legal-bold}"
          },
          "name": "legal-bold",
          "attributes": {
            "category": "styles",
            "type": "text",
            "item": "interface",
            "subitem": "legal-bold"
          },
          "path": [
            "styles",
            "text",
            "interface",
            "legal-bold"
          ]
        }
      }
    },
    "effect": {
      "elevation": {
        "action": {
          "fab": {
            "key": "{styles.effect.elevation.action.fab}",
            "value": [
              {
                "type": "DROP_SHADOW",
                "color": "rgba(0, 0, 0, 0.1)",
                "offsetX": "var(--float-elevation-action-fab-potision-x)",
                "offsetY": "var(--float-elevation-action-fab-potision-y)",
                "radius": "var(--float-elevation-action-fab-blur)",
                "spread": "var(--float-elevation-action-fab-spread)"
              }
            ],
            "type": "shadow",
            "original": {
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "{primitive.color.transparencies.black.10-percent}",
                  "offsetX": "{float.elevation.action.fab.potision-x}",
                  "offsetY": "{float.elevation.action.fab.potision-y}",
                  "radius": "{float.elevation.action.fab.blur}",
                  "spread": "{float.elevation.action.fab.spread}"
                }
              ],
              "type": "shadow",
              "key": "{styles.effect.elevation.action.fab}"
            },
            "name": "fab",
            "attributes": {
              "category": "styles",
              "type": "effect",
              "item": "elevation",
              "subitem": "action",
              "state": "fab"
            },
            "path": [
              "styles",
              "effect",
              "elevation",
              "action",
              "fab"
            ]
          }
        },
        "comunication": {
          "snack-bar": {
            "key": "{styles.effect.elevation.comunication.snack-bar}",
            "value": [
              {
                "type": "DROP_SHADOW",
                "color": "rgba(0, 0, 0, 0.1)",
                "offsetX": "var(--float-elevation-communication-snack-bar-potision-x)",
                "offsetY": "var(--float-elevation-communication-snack-bar-potision-y)",
                "radius": "var(--float-elevation-communication-snack-bar-blur)",
                "spread": "var(--float-elevation-communication-snack-bar-spread)"
              }
            ],
            "type": "shadow",
            "original": {
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "{primitive.color.transparencies.black.10-percent}",
                  "offsetX": "{float.elevation.communication.snack-bar.potision-x}",
                  "offsetY": "{float.elevation.communication.snack-bar.potision-y}",
                  "radius": "{float.elevation.communication.snack-bar.blur}",
                  "spread": "{float.elevation.communication.snack-bar.spread}"
                }
              ],
              "type": "shadow",
              "key": "{styles.effect.elevation.comunication.snack-bar}"
            },
            "name": "snack-bar",
            "attributes": {
              "category": "styles",
              "type": "effect",
              "item": "elevation",
              "subitem": "comunication",
              "state": "snack-bar"
            },
            "path": [
              "styles",
              "effect",
              "elevation",
              "comunication",
              "snack-bar"
            ]
          },
          "toast": {
            "key": "{styles.effect.elevation.comunication.toast}",
            "value": [
              {
                "type": "DROP_SHADOW",
                "color": "rgba(0, 0, 0, 0.1)",
                "offsetX": "var(--float-elevation-communication-toast-potision-x)",
                "offsetY": "var(--float-elevation-communication-toast-potision-y)",
                "radius": "var(--float-elevation-communication-toast-blur)",
                "spread": "var(--float-elevation-communication-toast-spread)"
              }
            ],
            "type": "shadow",
            "original": {
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "{primitive.color.transparencies.black.10-percent}",
                  "offsetX": "{float.elevation.communication.toast.potision-x}",
                  "offsetY": "{float.elevation.communication.toast.potision-y}",
                  "radius": "{float.elevation.communication.toast.blur}",
                  "spread": "{float.elevation.communication.toast.spread}"
                }
              ],
              "type": "shadow",
              "key": "{styles.effect.elevation.comunication.toast}"
            },
            "name": "toast",
            "attributes": {
              "category": "styles",
              "type": "effect",
              "item": "elevation",
              "subitem": "comunication",
              "state": "toast"
            },
            "path": [
              "styles",
              "effect",
              "elevation",
              "comunication",
              "toast"
            ]
          }
        },
        "containment": {
          "dialog": {
            "key": "{styles.effect.elevation.containment.dialog}",
            "value": [
              {
                "type": "DROP_SHADOW",
                "color": "rgba(0, 0, 0, 0.05)",
                "offsetX": "var(--float-elevation-containment-dialog-potision-x)",
                "offsetY": "var(--float-elevation-containment-dialog-potision-y)",
                "radius": "var(--float-elevation-containment-dialog-blur)",
                "spread": "var(--float-elevation-containment-dialog-spread)"
              }
            ],
            "type": "shadow",
            "original": {
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "{primitive.color.transparencies.black.5-percent}",
                  "offsetX": "{float.elevation.containment.dialog.potision-x}",
                  "offsetY": "{float.elevation.containment.dialog.potision-y}",
                  "radius": "{float.elevation.containment.dialog.blur}",
                  "spread": "{float.elevation.containment.dialog.spread}"
                }
              ],
              "type": "shadow",
              "key": "{styles.effect.elevation.containment.dialog}"
            },
            "name": "dialog",
            "attributes": {
              "category": "styles",
              "type": "effect",
              "item": "elevation",
              "subitem": "containment",
              "state": "dialog"
            },
            "path": [
              "styles",
              "effect",
              "elevation",
              "containment",
              "dialog"
            ]
          },
          "menu": {
            "key": "{styles.effect.elevation.containment.menu}",
            "value": [
              {
                "type": "DROP_SHADOW",
                "color": "rgba(0, 0, 0, 0.05)",
                "offsetX": "var(--float-elevation-containment-menu-potision-x)",
                "offsetY": "var(--float-elevation-containment-menu-potision-y)",
                "radius": "var(--float-elevation-containment-menu-blur)",
                "spread": "var(--float-elevation-containment-menu-spread)"
              }
            ],
            "type": "shadow",
            "original": {
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "{primitive.color.transparencies.black.5-percent}",
                  "offsetX": "{float.elevation.containment.menu.potision-x}",
                  "offsetY": "{float.elevation.containment.menu.potision-y}",
                  "radius": "{float.elevation.containment.menu.blur}",
                  "spread": "{float.elevation.containment.menu.spread}"
                }
              ],
              "type": "shadow",
              "key": "{styles.effect.elevation.containment.menu}"
            },
            "name": "menu",
            "attributes": {
              "category": "styles",
              "type": "effect",
              "item": "elevation",
              "subitem": "containment",
              "state": "menu"
            },
            "path": [
              "styles",
              "effect",
              "elevation",
              "containment",
              "menu"
            ]
          },
          "card": {
            "default": {
              "key": "{styles.effect.elevation.containment.card.default}",
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "rgba(0, 0, 0, 0.05)",
                  "offsetX": "var(--float-elevation-containment-card-enabled-potision-x)",
                  "offsetY": "var(--float-elevation-containment-card-enabled-potision-y)",
                  "radius": "var(--float-elevation-containment-card-enabled-blur)",
                  "spread": "var(--float-elevation-containment-card-enabled-spread)"
                }
              ],
              "type": "shadow",
              "original": {
                "value": [
                  {
                    "type": "DROP_SHADOW",
                    "color": "{primitive.color.transparencies.black.5-percent}",
                    "offsetX": "{float.elevation.containment.card.enabled.potision-x}",
                    "offsetY": "{float.elevation.containment.card.enabled.potision-y}",
                    "radius": "{float.elevation.containment.card.enabled.blur}",
                    "spread": "{float.elevation.containment.card.enabled.spread}"
                  }
                ],
                "type": "shadow",
                "key": "{styles.effect.elevation.containment.card.default}"
              },
              "name": "default",
              "attributes": {
                "category": "styles",
                "type": "effect",
                "item": "elevation",
                "subitem": "containment",
                "state": "card"
              },
              "path": [
                "styles",
                "effect",
                "elevation",
                "containment",
                "card",
                "default"
              ]
            },
            "hover": {
              "key": "{styles.effect.elevation.containment.card.hover}",
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "rgba(0, 0, 0, 0.1)",
                  "offsetX": "var(--float-elevation-containment-card-hover-potision-x)",
                  "offsetY": "var(--float-elevation-containment-card-hover-potision-y)",
                  "radius": "var(--float-elevation-containment-card-hover-blur)",
                  "spread": "var(--float-elevation-containment-card-hover-spread)"
                }
              ],
              "type": "shadow",
              "original": {
                "value": [
                  {
                    "type": "DROP_SHADOW",
                    "color": "{primitive.color.transparencies.black.10-percent}",
                    "offsetX": "{float.elevation.containment.card.hover.potision-x}",
                    "offsetY": "{float.elevation.containment.card.hover.potision-y}",
                    "radius": "{float.elevation.containment.card.hover.blur}",
                    "spread": "{float.elevation.containment.card.hover.spread}"
                  }
                ],
                "type": "shadow",
                "key": "{styles.effect.elevation.containment.card.hover}"
              },
              "name": "hover",
              "attributes": {
                "category": "styles",
                "type": "effect",
                "item": "elevation",
                "subitem": "containment",
                "state": "card"
              },
              "path": [
                "styles",
                "effect",
                "elevation",
                "containment",
                "card",
                "hover"
              ]
            },
            "selected": {
              "key": "{styles.effect.elevation.containment.card.selected}",
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "rgba(0, 0, 0, 0.1)",
                  "offsetX": "var(--float-elevation-containment-card-selected-potision-x)",
                  "offsetY": "var(--float-elevation-containment-card-selected-potision-y)",
                  "radius": "var(--float-elevation-containment-card-hover-blur)",
                  "spread": "var(--float-elevation-containment-card-selected-spread)"
                }
              ],
              "type": "shadow",
              "original": {
                "value": [
                  {
                    "type": "DROP_SHADOW",
                    "color": "{primitive.color.transparencies.black.10-percent}",
                    "offsetX": "{float.elevation.containment.card.selected.potision-x}",
                    "offsetY": "{float.elevation.containment.card.selected.potision-y}",
                    "radius": "{float.elevation.containment.card.hover.blur}",
                    "spread": "{float.elevation.containment.card.selected.spread}"
                  }
                ],
                "type": "shadow",
                "key": "{styles.effect.elevation.containment.card.selected}"
              },
              "name": "selected",
              "attributes": {
                "category": "styles",
                "type": "effect",
                "item": "elevation",
                "subitem": "containment",
                "state": "card"
              },
              "path": [
                "styles",
                "effect",
                "elevation",
                "containment",
                "card",
                "selected"
              ]
            },
            "dragged": {
              "key": "{styles.effect.elevation.containment.card.dragged}",
              "value": [
                {
                  "type": "DROP_SHADOW",
                  "color": "rgba(0, 0, 0, 0.1)",
                  "offsetX": "var(--float-elevation-containment-card-dragged-potision-x)",
                  "offsetY": "var(--float-elevation-containment-card-dragged-potision-y)",
                  "radius": "var(--float-elevation-containment-card-dragged-blur)",
                  "spread": "var(--float-elevation-containment-card-dragged-spread)"
                }
              ],
              "type": "shadow",
              "original": {
                "value": [
                  {
                    "type": "DROP_SHADOW",
                    "color": "{primitive.color.transparencies.black.10-percent}",
                    "offsetX": "{float.elevation.containment.card.dragged.potision-x}",
                    "offsetY": "{float.elevation.containment.card.dragged.potision-y}",
                    "radius": "{float.elevation.containment.card.dragged.blur}",
                    "spread": "{float.elevation.containment.card.dragged.spread}"
                  }
                ],
                "type": "shadow",
                "key": "{styles.effect.elevation.containment.card.dragged}"
              },
              "name": "dragged",
              "attributes": {
                "category": "styles",
                "type": "effect",
                "item": "elevation",
                "subitem": "containment",
                "state": "card"
              },
              "path": [
                "styles",
                "effect",
                "elevation",
                "containment",
                "card",
                "dragged"
              ]
            }
          }
        }
      }
    }
  },
  "color": {
    "action": {
      "button": {
        "fill": {
          "primary": {
            "enabled": {
              "key": "{color.action.button.fill.primary.enabled}",
              "value": "var(--color-action-button-fill-primary-enabled)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-fill-primary-enabled)",
                "type": "color",
                "key": "{color.action.button.fill.primary.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "fill",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "fill",
                "primary",
                "enabled"
              ]
            },
            "hover": {
              "key": "{color.action.button.fill.primary.hover}",
              "value": "var(--color-action-button-fill-primary-hover)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-fill-primary-hover)",
                "type": "color",
                "key": "{color.action.button.fill.primary.hover}"
              },
              "name": "hover",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "fill",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "fill",
                "primary",
                "hover"
              ]
            },
            "pressed": {
              "key": "{color.action.button.fill.primary.pressed}",
              "value": "var(--color-action-button-fill-primary-pressed)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-fill-primary-pressed)",
                "type": "color",
                "key": "{color.action.button.fill.primary.pressed}"
              },
              "name": "pressed",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "fill",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "fill",
                "primary",
                "pressed"
              ]
            }
          },
          "critical": {
            "enabled": {
              "key": "{color.action.button.fill.critical.enabled}",
              "value": "var(--color-action-button-fill-critical-enabled)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-fill-critical-enabled)",
                "type": "color",
                "key": "{color.action.button.fill.critical.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "fill",
                "state": "critical"
              },
              "path": [
                "color",
                "action",
                "button",
                "fill",
                "critical",
                "enabled"
              ]
            },
            "hover": {
              "key": "{color.action.button.fill.critical.hover}",
              "value": "var(--color-action-button-fill-critical-hover)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-fill-critical-hover)",
                "type": "color",
                "key": "{color.action.button.fill.critical.hover}"
              },
              "name": "hover",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "fill",
                "state": "critical"
              },
              "path": [
                "color",
                "action",
                "button",
                "fill",
                "critical",
                "hover"
              ]
            },
            "pressed": {
              "key": "{color.action.button.fill.critical.pressed}",
              "value": "var(--color-action-button-fill-critical-pressed)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-fill-critical-pressed)",
                "type": "color",
                "key": "{color.action.button.fill.critical.pressed}"
              },
              "name": "pressed",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "fill",
                "state": "critical"
              },
              "path": [
                "color",
                "action",
                "button",
                "fill",
                "critical",
                "pressed"
              ]
            }
          }
        },
        "border": {
          "primary": {
            "enabled": {
              "key": "{color.action.button.border.primary.enabled}",
              "value": "var(--color-action-button-border-primary-enabled)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-border-primary-enabled)",
                "type": "color",
                "key": "{color.action.button.border.primary.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "border",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "border",
                "primary",
                "enabled"
              ]
            }
          },
          "error": {
            "enabled": {
              "key": "{color.action.button.border.error.enabled}",
              "value": "var(--color-action-button-border-error-enabled)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-border-error-enabled)",
                "type": "color",
                "key": "{color.action.button.border.error.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "border",
                "state": "error"
              },
              "path": [
                "color",
                "action",
                "button",
                "border",
                "error",
                "enabled"
              ]
            }
          }
        },
        "text-icon": {
          "primary": {
            "enabled": {
              "key": "{color.action.button.text-icon.primary.enabled}",
              "value": "var(--color-action-button-text-icon-primary-enabled)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-text-icon-primary-enabled)",
                "type": "color",
                "key": "{color.action.button.text-icon.primary.enabled}"
              },
              "name": "enabled",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "text-icon",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "text-icon",
                "primary",
                "enabled"
              ]
            },
            "hover": {
              "key": "{color.action.button.text-icon.primary.hover}",
              "value": "var(--color-action-button-text-icon-primary-hover)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-text-icon-primary-hover)",
                "type": "color",
                "key": "{color.action.button.text-icon.primary.hover}"
              },
              "name": "hover",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "text-icon",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "text-icon",
                "primary",
                "hover"
              ]
            },
            "pressed": {
              "key": "{color.action.button.text-icon.primary.pressed}",
              "value": "var(--color-action-button-text-icon-primary-pressed)",
              "type": "color",
              "original": {
                "value": "var(--color-action-button-text-icon-primary-pressed)",
                "type": "color",
                "key": "{color.action.button.text-icon.primary.pressed}"
              },
              "name": "pressed",
              "attributes": {
                "category": "color",
                "type": "action",
                "item": "button",
                "subitem": "text-icon",
                "state": "primary"
              },
              "path": [
                "color",
                "action",
                "button",
                "text-icon",
                "primary",
                "pressed"
              ]
            }
          }
        }
      }
    },
    "communication": {
      "notifications": {
        "fill": {
          "success": {
            "key": "{color.communication.notifications.fill.success}",
            "value": "var(--color-communication-notifications-fill-success)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-fill-success)",
              "type": "color",
              "key": "{color.communication.notifications.fill.success}"
            },
            "name": "success",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "fill",
              "state": "success"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "fill",
              "success"
            ]
          },
          "info": {
            "key": "{color.communication.notifications.fill.info}",
            "value": "var(--color-communication-notifications-fill-info)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-fill-info)",
              "type": "color",
              "key": "{color.communication.notifications.fill.info}"
            },
            "name": "info",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "fill",
              "state": "info"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "fill",
              "info"
            ]
          },
          "error": {
            "key": "{color.communication.notifications.fill.error}",
            "value": "var(--color-communication-notifications-fill-error)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-fill-error)",
              "type": "color",
              "key": "{color.communication.notifications.fill.error}"
            },
            "name": "error",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "fill",
              "state": "error"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "fill",
              "error"
            ]
          },
          "alert": {
            "key": "{color.communication.notifications.fill.alert}",
            "value": "var(--color-communication-notifications-fill-alert)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-fill-alert)",
              "type": "color",
              "key": "{color.communication.notifications.fill.alert}"
            },
            "name": "alert",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "fill",
              "state": "alert"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "fill",
              "alert"
            ]
          }
        },
        "border": {
          "success": {
            "key": "{color.communication.notifications.border.success}",
            "value": "var(--color-communication-notifications-border-success)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-border-success)",
              "type": "color",
              "key": "{color.communication.notifications.border.success}"
            },
            "name": "success",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "border",
              "state": "success"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "border",
              "success"
            ]
          },
          "info": {
            "key": "{color.communication.notifications.border.info}",
            "value": "var(--color-communication-notifications-border-info)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-border-info)",
              "type": "color",
              "key": "{color.communication.notifications.border.info}"
            },
            "name": "info",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "border",
              "state": "info"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "border",
              "info"
            ]
          },
          "error": {
            "key": "{color.communication.notifications.border.error}",
            "value": "var(--color-communication-notifications-border-error)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-border-error)",
              "type": "color",
              "key": "{color.communication.notifications.border.error}"
            },
            "name": "error",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "border",
              "state": "error"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "border",
              "error"
            ]
          },
          "alert": {
            "key": "{color.communication.notifications.border.alert}",
            "value": "var(--color-communication-notifications-border-alert)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-border-alert)",
              "type": "color",
              "key": "{color.communication.notifications.border.alert}"
            },
            "name": "alert",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "border",
              "state": "alert"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "border",
              "alert"
            ]
          }
        },
        "text-icon": {
          "success": {
            "key": "{color.communication.notifications.text-icon.success}",
            "value": "var(--color-communication-notifications-text-icon-success)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-text-icon-success)",
              "type": "color",
              "key": "{color.communication.notifications.text-icon.success}"
            },
            "name": "success",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "text-icon",
              "state": "success"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "text-icon",
              "success"
            ]
          },
          "info": {
            "key": "{color.communication.notifications.text-icon.info}",
            "value": "var(--color-communication-notifications-text-icon-info)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-text-icon-info)",
              "type": "color",
              "key": "{color.communication.notifications.text-icon.info}"
            },
            "name": "info",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "text-icon",
              "state": "info"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "text-icon",
              "info"
            ]
          },
          "error": {
            "key": "{color.communication.notifications.text-icon.error}",
            "value": "var(--color-communication-notifications-text-icon-error)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-text-icon-error)",
              "type": "color",
              "key": "{color.communication.notifications.text-icon.error}"
            },
            "name": "error",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "text-icon",
              "state": "error"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "text-icon",
              "error"
            ]
          },
          "alert": {
            "key": "{color.communication.notifications.text-icon.alert}",
            "value": "var(--color-communication-notifications-text-icon-alert)",
            "type": "color",
            "original": {
              "value": "var(--color-communication-notifications-text-icon-alert)",
              "type": "color",
              "key": "{color.communication.notifications.text-icon.alert}"
            },
            "name": "alert",
            "attributes": {
              "category": "color",
              "type": "communication",
              "item": "notifications",
              "subitem": "text-icon",
              "state": "alert"
            },
            "path": [
              "color",
              "communication",
              "notifications",
              "text-icon",
              "alert"
            ]
          }
        }
      },
      "badge": {
        "fill": {
          "key": "{color.communication.badge.fill}",
          "value": "var(--color-communication-badge-fill)",
          "type": "color",
          "original": {
            "value": "var(--color-communication-badge-fill)",
            "type": "color",
            "key": "{color.communication.badge.fill}"
          },
          "name": "fill",
          "attributes": {
            "category": "color",
            "type": "communication",
            "item": "badge",
            "subitem": "fill"
          },
          "path": [
            "color",
            "communication",
            "badge",
            "fill"
          ]
        }
      }
    },
    "containment": {
      "surface": {
        "fill": {
          "default": {
            "key": "{color.containment.surface.fill.default}",
            "value": "var(--color-containment-surface-fill-default)",
            "type": "color",
            "original": {
              "value": "var(--color-containment-surface-fill-default)",
              "type": "color",
              "key": "{color.containment.surface.fill.default}"
            },
            "name": "default",
            "attributes": {
              "category": "color",
              "type": "containment",
              "item": "surface",
              "subitem": "fill",
              "state": "default"
            },
            "path": [
              "color",
              "containment",
              "surface",
              "fill",
              "default"
            ]
          },
          "overlay": {
            "key": "{color.containment.surface.fill.overlay}",
            "value": "var(--color-containment-surface-fill-overlay)",
            "type": "color",
            "original": {
              "value": "var(--color-containment-surface-fill-overlay)",
              "type": "color",
              "key": "{color.containment.surface.fill.overlay}"
            },
            "name": "overlay",
            "attributes": {
              "category": "color",
              "type": "containment",
              "item": "surface",
              "subitem": "fill",
              "state": "overlay"
            },
            "path": [
              "color",
              "containment",
              "surface",
              "fill",
              "overlay"
            ]
          },
          "sunken": {
            "key": "{color.containment.surface.fill.sunken}",
            "value": "var(--color-containment-surface-fill-sunken)",
            "type": "color",
            "original": {
              "value": "var(--color-containment-surface-fill-sunken)",
              "type": "color",
              "key": "{color.containment.surface.fill.sunken}"
            },
            "name": "sunken",
            "attributes": {
              "category": "color",
              "type": "containment",
              "item": "surface",
              "subitem": "fill",
              "state": "sunken"
            },
            "path": [
              "color",
              "containment",
              "surface",
              "fill",
              "sunken"
            ]
          },
          "raised-1": {
            "key": "{color.containment.surface.fill.raised-1}",
            "value": "var(--color-containment-surface-fill-raised-1)",
            "type": "color",
            "original": {
              "value": "var(--color-containment-surface-fill-raised-1)",
              "type": "color",
              "key": "{color.containment.surface.fill.raised-1}"
            },
            "name": "raised-1",
            "attributes": {
              "category": "color",
              "type": "containment",
              "item": "surface",
              "subitem": "fill",
              "state": "raised-1"
            },
            "path": [
              "color",
              "containment",
              "surface",
              "fill",
              "raised-1"
            ]
          },
          "raised-2": {
            "key": "{color.containment.surface.fill.raised-2}",
            "value": "var(--color-containment-surface-fill-raised-2)",
            "type": "color",
            "original": {
              "value": "var(--color-containment-surface-fill-raised-2)",
              "type": "color",
              "key": "{color.containment.surface.fill.raised-2}"
            },
            "name": "raised-2",
            "attributes": {
              "category": "color",
              "type": "containment",
              "item": "surface",
              "subitem": "fill",
              "state": "raised-2"
            },
            "path": [
              "color",
              "containment",
              "surface",
              "fill",
              "raised-2"
            ]
          }
        },
        "border": {
          "divider": {
            "key": "{color.containment.surface.border.divider}",
            "value": "var(--color-containment-surface-border-divider)",
            "type": "color",
            "original": {
              "value": "var(--color-containment-surface-border-divider)",
              "type": "color",
              "key": "{color.containment.surface.border.divider}"
            },
            "name": "divider",
            "attributes": {
              "category": "color",
              "type": "containment",
              "item": "surface",
              "subitem": "border",
              "state": "divider"
            },
            "path": [
              "color",
              "containment",
              "surface",
              "border",
              "divider"
            ]
          }
        }
      }
    },
    "generic": {
      "focused": {
        "key": "{color.generic.focused}",
        "value": "var(--color-generic-focused)",
        "type": "color",
        "original": {
          "value": "var(--color-generic-focused)",
          "type": "color",
          "key": "{color.generic.focused}"
        },
        "name": "focused",
        "attributes": {
          "category": "color",
          "type": "generic",
          "item": "focused"
        },
        "path": [
          "color",
          "generic",
          "focused"
        ]
      },
      "disabled": {
        "text-icon": {
          "key": "{color.generic.disabled.text-icon}",
          "value": "var(--color-generic-disabled-text-icon)",
          "type": "color",
          "original": {
            "value": "var(--color-generic-disabled-text-icon)",
            "type": "color",
            "key": "{color.generic.disabled.text-icon}"
          },
          "name": "text-icon",
          "attributes": {
            "category": "color",
            "type": "generic",
            "item": "disabled",
            "subitem": "text-icon"
          },
          "path": [
            "color",
            "generic",
            "disabled",
            "text-icon"
          ]
        },
        "text-icon-inverse": {
          "key": "{color.generic.disabled.text-icon-inverse}",
          "value": "var(--color-generic-disabled-text-icon-inverse)",
          "type": "color",
          "original": {
            "value": "var(--color-generic-disabled-text-icon-inverse)",
            "type": "color",
            "key": "{color.generic.disabled.text-icon-inverse}"
          },
          "name": "text-icon-inverse",
          "attributes": {
            "category": "color",
            "type": "generic",
            "item": "disabled",
            "subitem": "text-icon-inverse"
          },
          "path": [
            "color",
            "generic",
            "disabled",
            "text-icon-inverse"
          ]
        },
        "fill": {
          "key": "{color.generic.disabled.fill}",
          "value": "var(--color-generic-disabled-fill)",
          "type": "color",
          "original": {
            "value": "var(--color-generic-disabled-fill)",
            "type": "color",
            "key": "{color.generic.disabled.fill}"
          },
          "name": "fill",
          "attributes": {
            "category": "color",
            "type": "generic",
            "item": "disabled",
            "subitem": "fill"
          },
          "path": [
            "color",
            "generic",
            "disabled",
            "fill"
          ]
        },
        "border": {
          "key": "{color.generic.disabled.border}",
          "value": "var(--color-generic-disabled-border)",
          "type": "color",
          "original": {
            "value": "var(--color-generic-disabled-border)",
            "type": "color",
            "key": "{color.generic.disabled.border}"
          },
          "name": "border",
          "attributes": {
            "category": "color",
            "type": "generic",
            "item": "disabled",
            "subitem": "border"
          },
          "path": [
            "color",
            "generic",
            "disabled",
            "border"
          ]
        }
      },
      "brand": {
        "primary": {
          "enabled": {
            "key": "{color.generic.brand.primary.enabled}",
            "value": "var(--color-generic-brand-primary-enabled)",
            "type": "color",
            "original": {
              "value": "var(--color-generic-brand-primary-enabled)",
              "type": "color",
              "key": "{color.generic.brand.primary.enabled}"
            },
            "name": "enabled",
            "attributes": {
              "category": "color",
              "type": "generic",
              "item": "brand",
              "subitem": "primary",
              "state": "enabled"
            },
            "path": [
              "color",
              "generic",
              "brand",
              "primary",
              "enabled"
            ]
          },
          "hover": {
            "key": "{color.generic.brand.primary.hover}",
            "value": "var(--color-generic-brand-primary-hover)",
            "type": "color",
            "original": {
              "value": "var(--color-generic-brand-primary-hover)",
              "type": "color",
              "key": "{color.generic.brand.primary.hover}"
            },
            "name": "hover",
            "attributes": {
              "category": "color",
              "type": "generic",
              "item": "brand",
              "subitem": "primary",
              "state": "hover"
            },
            "path": [
              "color",
              "generic",
              "brand",
              "primary",
              "hover"
            ]
          },
          "pressed": {
            "key": "{color.generic.brand.primary.pressed}",
            "value": "var(--color-generic-brand-primary-pressed)",
            "type": "color",
            "original": {
              "value": "var(--color-generic-brand-primary-pressed)",
              "type": "color",
              "key": "{color.generic.brand.primary.pressed}"
            },
            "name": "pressed",
            "attributes": {
              "category": "color",
              "type": "generic",
              "item": "brand",
              "subitem": "primary",
              "state": "pressed"
            },
            "path": [
              "color",
              "generic",
              "brand",
              "primary",
              "pressed"
            ]
          }
        }
      }
    },
    "text-inputs": {
      "border": {
        "enabled": {
          "key": "{color.text-inputs.border.enabled}",
          "value": "var(--color-text-inputs-border-enabled)",
          "type": "color",
          "original": {
            "value": "var(--color-text-inputs-border-enabled)",
            "type": "color",
            "key": "{color.text-inputs.border.enabled}"
          },
          "name": "enabled",
          "attributes": {
            "category": "color",
            "type": "text-inputs",
            "item": "border",
            "subitem": "enabled"
          },
          "path": [
            "color",
            "text-inputs",
            "border",
            "enabled"
          ]
        },
        "active": {
          "key": "{color.text-inputs.border.active}",
          "value": "var(--color-text-inputs-border-active)",
          "type": "color",
          "original": {
            "value": "var(--color-text-inputs-border-active)",
            "type": "color",
            "key": "{color.text-inputs.border.active}"
          },
          "name": "active",
          "attributes": {
            "category": "color",
            "type": "text-inputs",
            "item": "border",
            "subitem": "active"
          },
          "path": [
            "color",
            "text-inputs",
            "border",
            "active"
          ]
        }
      }
    },
    "text-icon": {
      "common": {
        "high-emphesis": {
          "key": "{color.text-icon.common.high-emphesis}",
          "value": "var(--color-text-icon-common-high-emphesis)",
          "type": "color",
          "original": {
            "value": "var(--color-text-icon-common-high-emphesis)",
            "type": "color",
            "key": "{color.text-icon.common.high-emphesis}"
          },
          "name": "high-emphesis",
          "attributes": {
            "category": "color",
            "type": "text-icon",
            "item": "common",
            "subitem": "high-emphesis"
          },
          "path": [
            "color",
            "text-icon",
            "common",
            "high-emphesis"
          ]
        },
        "medium-emphasis": {
          "key": "{color.text-icon.common.medium-emphasis}",
          "value": "var(--color-text-icon-common-medium-emphasis)",
          "type": "color",
          "original": {
            "value": "var(--color-text-icon-common-medium-emphasis)",
            "type": "color",
            "key": "{color.text-icon.common.medium-emphasis}"
          },
          "name": "medium-emphasis",
          "attributes": {
            "category": "color",
            "type": "text-icon",
            "item": "common",
            "subitem": "medium-emphasis"
          },
          "path": [
            "color",
            "text-icon",
            "common",
            "medium-emphasis"
          ]
        }
      },
      "common-inverse": {
        "high-emphasis": {
          "key": "{color.text-icon.common-inverse.high-emphasis}",
          "value": "var(--color-text-icon-common-inverse-high-emphasis)",
          "type": "color",
          "original": {
            "value": "var(--color-text-icon-common-inverse-high-emphasis)",
            "type": "color",
            "key": "{color.text-icon.common-inverse.high-emphasis}"
          },
          "name": "high-emphasis",
          "attributes": {
            "category": "color",
            "type": "text-icon",
            "item": "common-inverse",
            "subitem": "high-emphasis"
          },
          "path": [
            "color",
            "text-icon",
            "common-inverse",
            "high-emphasis"
          ]
        },
        "medium-emphasis": {
          "key": "{color.text-icon.common-inverse.medium-emphasis}",
          "value": "var(--color-text-icon-common-inverse-medium-emphasis)",
          "type": "color",
          "original": {
            "value": "var(--color-text-icon-common-inverse-medium-emphasis)",
            "type": "color",
            "key": "{color.text-icon.common-inverse.medium-emphasis}"
          },
          "name": "medium-emphasis",
          "attributes": {
            "category": "color",
            "type": "text-icon",
            "item": "common-inverse",
            "subitem": "medium-emphasis"
          },
          "path": [
            "color",
            "text-icon",
            "common-inverse",
            "medium-emphasis"
          ]
        }
      }
    },
    "selection": {
      "checkbox-radio": {
        "fill": {
          "selected": {
            "key": "{color.selection.checkbox-radio.fill.selected}",
            "value": "var(--color-selection-checkbox-radio-fill-selected)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-checkbox-radio-fill-selected)",
              "type": "color",
              "key": "{color.selection.checkbox-radio.fill.selected}"
            },
            "name": "selected",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "checkbox-radio",
              "subitem": "fill",
              "state": "selected"
            },
            "path": [
              "color",
              "selection",
              "checkbox-radio",
              "fill",
              "selected"
            ]
          },
          "selected-critical": {
            "key": "{color.selection.checkbox-radio.fill.selected-critical}",
            "value": "var(--color-selection-checkbox-radio-fill-selected-critical)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-checkbox-radio-fill-selected-critical)",
              "type": "color",
              "key": "{color.selection.checkbox-radio.fill.selected-critical}"
            },
            "name": "selected-critical",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "checkbox-radio",
              "subitem": "fill",
              "state": "selected-critical"
            },
            "path": [
              "color",
              "selection",
              "checkbox-radio",
              "fill",
              "selected-critical"
            ]
          }
        },
        "border": {
          "enabled": {
            "key": "{color.selection.checkbox-radio.border.enabled}",
            "value": "var(--color-selection-checkbox-radio-border-enabled)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-checkbox-radio-border-enabled)",
              "type": "color",
              "key": "{color.selection.checkbox-radio.border.enabled}"
            },
            "name": "enabled",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "checkbox-radio",
              "subitem": "border",
              "state": "enabled"
            },
            "path": [
              "color",
              "selection",
              "checkbox-radio",
              "border",
              "enabled"
            ]
          },
          "enabled-critical": {
            "key": "{color.selection.checkbox-radio.border.enabled-critical}",
            "value": "var(--color-selection-checkbox-radio-border-enabled-critical)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-checkbox-radio-border-enabled-critical)",
              "type": "color",
              "key": "{color.selection.checkbox-radio.border.enabled-critical}"
            },
            "name": "enabled-critical",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "checkbox-radio",
              "subitem": "border",
              "state": "enabled-critical"
            },
            "path": [
              "color",
              "selection",
              "checkbox-radio",
              "border",
              "enabled-critical"
            ]
          }
        }
      },
      "dropdown": {
        "border": {
          "enabled": {
            "key": "{color.selection.dropdown.border.enabled}",
            "value": "var(--color-selection-dropdown-border-enabled)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-dropdown-border-enabled)",
              "type": "color",
              "key": "{color.selection.dropdown.border.enabled}"
            },
            "name": "enabled",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "dropdown",
              "subitem": "border",
              "state": "enabled"
            },
            "path": [
              "color",
              "selection",
              "dropdown",
              "border",
              "enabled"
            ]
          }
        }
      },
      "chips": {
        "border": {
          "primary": {
            "selected": {
              "key": "{color.selection.chips.border.primary.selected}",
              "value": "var(--color-selection-chips-border-primary-selected)",
              "type": "color",
              "original": {
                "value": "var(--color-selection-chips-border-primary-selected)",
                "type": "color",
                "key": "{color.selection.chips.border.primary.selected}"
              },
              "name": "selected",
              "attributes": {
                "category": "color",
                "type": "selection",
                "item": "chips",
                "subitem": "border",
                "state": "primary"
              },
              "path": [
                "color",
                "selection",
                "chips",
                "border",
                "primary",
                "selected"
              ]
            }
          }
        }
      },
      "switch-knob": {
        "fill": {
          "enabled": {
            "key": "{color.selection.switch-knob.fill.enabled}",
            "value": "var(--color-selection-switch-knob-fill-enabled)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-switch-knob-fill-enabled)",
              "type": "color",
              "key": "{color.selection.switch-knob.fill.enabled}"
            },
            "name": "enabled",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "switch-knob",
              "subitem": "fill",
              "state": "enabled"
            },
            "path": [
              "color",
              "selection",
              "switch-knob",
              "fill",
              "enabled"
            ]
          },
          "selected": {
            "key": "{color.selection.switch-knob.fill.selected}",
            "value": "var(--color-selection-switch-knob-fill-selected)",
            "type": "color",
            "original": {
              "value": "var(--color-selection-switch-knob-fill-selected)",
              "type": "color",
              "key": "{color.selection.switch-knob.fill.selected}"
            },
            "name": "selected",
            "attributes": {
              "category": "color",
              "type": "selection",
              "item": "switch-knob",
              "subitem": "fill",
              "state": "selected"
            },
            "path": [
              "color",
              "selection",
              "switch-knob",
              "fill",
              "selected"
            ]
          }
        }
      }
    }
  },
  "float": {
    "type-scale": {
      "size": {
        "xs": {
          "key": "{float.type-scale.size.xs}",
          "value": "var(--float-type-scale-size-xs)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-xs)",
            "type": "number",
            "key": "{float.type-scale.size.xs}"
          },
          "name": "xs",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "xs"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "xs"
          ]
        },
        "sm": {
          "key": "{float.type-scale.size.sm}",
          "value": "var(--float-type-scale-size-sm)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-sm)",
            "type": "number",
            "key": "{float.type-scale.size.sm}"
          },
          "name": "sm",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "sm"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "sm"
          ]
        },
        "md": {
          "key": "{float.type-scale.size.md}",
          "value": "var(--float-type-scale-size-md)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-md)",
            "type": "number",
            "key": "{float.type-scale.size.md}"
          },
          "name": "md",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "md"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "md"
          ]
        },
        "lg": {
          "key": "{float.type-scale.size.lg}",
          "value": "var(--float-type-scale-size-lg)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-lg)",
            "type": "number",
            "key": "{float.type-scale.size.lg}"
          },
          "name": "lg",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "lg"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "lg"
          ]
        },
        "xl": {
          "key": "{float.type-scale.size.xl}",
          "value": "var(--float-type-scale-size-xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-xl)",
            "type": "number",
            "key": "{float.type-scale.size.xl}"
          },
          "name": "xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "xl"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "xl"
          ]
        },
        "2xl": {
          "key": "{float.type-scale.size.2xl}",
          "value": "var(--float-type-scale-size-2xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-2xl)",
            "type": "number",
            "key": "{float.type-scale.size.2xl}"
          },
          "name": "2xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "2xl"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "2xl"
          ]
        },
        "3xl": {
          "key": "{float.type-scale.size.3xl}",
          "value": "var(--float-type-scale-size-3xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-3xl)",
            "type": "number",
            "key": "{float.type-scale.size.3xl}"
          },
          "name": "3xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "3xl"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "3xl"
          ]
        },
        "4xl": {
          "key": "{float.type-scale.size.4xl}",
          "value": "var(--float-type-scale-size-4xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-4xl)",
            "type": "number",
            "key": "{float.type-scale.size.4xl}"
          },
          "name": "4xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "4xl"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "4xl"
          ]
        },
        "2xs": {
          "key": "{float.type-scale.size.2xs}",
          "value": "var(--float-type-scale-size-2xs)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-size-2xs)",
            "type": "number",
            "key": "{float.type-scale.size.2xs}"
          },
          "name": "2xs",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "size",
            "subitem": "2xs"
          },
          "path": [
            "float",
            "type-scale",
            "size",
            "2xs"
          ]
        }
      },
      "line-height": {
        "2xs": {
          "key": "{float.type-scale.line-height.2xs}",
          "value": "var(--float-type-scale-line-height-2xs)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-2xs)",
            "type": "number",
            "key": "{float.type-scale.line-height.2xs}"
          },
          "name": "2xs",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "2xs"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "2xs"
          ]
        },
        "sm": {
          "key": "{float.type-scale.line-height.sm}",
          "value": "var(--float-type-scale-line-height-sm)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-sm)",
            "type": "number",
            "key": "{float.type-scale.line-height.sm}"
          },
          "name": "sm",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "sm"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "sm"
          ]
        },
        "md": {
          "key": "{float.type-scale.line-height.md}",
          "value": "var(--float-type-scale-line-height-md)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-md)",
            "type": "number",
            "key": "{float.type-scale.line-height.md}"
          },
          "name": "md",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "md"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "md"
          ]
        },
        "lg": {
          "key": "{float.type-scale.line-height.lg}",
          "value": "var(--float-type-scale-line-height-lg)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-lg)",
            "type": "number",
            "key": "{float.type-scale.line-height.lg}"
          },
          "name": "lg",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "lg"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "lg"
          ]
        },
        "xl": {
          "key": "{float.type-scale.line-height.xl}",
          "value": "var(--float-type-scale-line-height-xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-xl)",
            "type": "number",
            "key": "{float.type-scale.line-height.xl}"
          },
          "name": "xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "xl"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "xl"
          ]
        },
        "2xl": {
          "key": "{float.type-scale.line-height.2xl}",
          "value": "var(--float-type-scale-line-height-2xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-2xl)",
            "type": "number",
            "key": "{float.type-scale.line-height.2xl}"
          },
          "name": "2xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "2xl"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "2xl"
          ]
        },
        "xs": {
          "key": "{float.type-scale.line-height.xs}",
          "value": "var(--float-type-scale-line-height-xs)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-line-height-xs)",
            "type": "number",
            "key": "{float.type-scale.line-height.xs}"
          },
          "name": "xs",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "line-height",
            "subitem": "xs"
          },
          "path": [
            "float",
            "type-scale",
            "line-height",
            "xs"
          ]
        }
      },
      "paragraph-spacing": {
        "xs": {
          "key": "{float.type-scale.paragraph-spacing.xs}",
          "value": "var(--float-type-scale-paragraph-spacing-xs)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-paragraph-spacing-xs)",
            "type": "number",
            "key": "{float.type-scale.paragraph-spacing.xs}"
          },
          "name": "xs",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "paragraph-spacing",
            "subitem": "xs"
          },
          "path": [
            "float",
            "type-scale",
            "paragraph-spacing",
            "xs"
          ]
        },
        "sm": {
          "key": "{float.type-scale.paragraph-spacing.sm}",
          "value": "var(--float-type-scale-paragraph-spacing-sm)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-paragraph-spacing-sm)",
            "type": "number",
            "key": "{float.type-scale.paragraph-spacing.sm}"
          },
          "name": "sm",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "paragraph-spacing",
            "subitem": "sm"
          },
          "path": [
            "float",
            "type-scale",
            "paragraph-spacing",
            "sm"
          ]
        },
        "md": {
          "key": "{float.type-scale.paragraph-spacing.md}",
          "value": "var(--float-type-scale-paragraph-spacing-md)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-paragraph-spacing-md)",
            "type": "number",
            "key": "{float.type-scale.paragraph-spacing.md}"
          },
          "name": "md",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "paragraph-spacing",
            "subitem": "md"
          },
          "path": [
            "float",
            "type-scale",
            "paragraph-spacing",
            "md"
          ]
        },
        "lg": {
          "key": "{float.type-scale.paragraph-spacing.lg}",
          "value": "var(--float-type-scale-paragraph-spacing-lg)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-paragraph-spacing-lg)",
            "type": "number",
            "key": "{float.type-scale.paragraph-spacing.lg}"
          },
          "name": "lg",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "paragraph-spacing",
            "subitem": "lg"
          },
          "path": [
            "float",
            "type-scale",
            "paragraph-spacing",
            "lg"
          ]
        },
        "xl": {
          "key": "{float.type-scale.paragraph-spacing.xl}",
          "value": "var(--float-type-scale-paragraph-spacing-xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-paragraph-spacing-xl)",
            "type": "number",
            "key": "{float.type-scale.paragraph-spacing.xl}"
          },
          "name": "xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "paragraph-spacing",
            "subitem": "xl"
          },
          "path": [
            "float",
            "type-scale",
            "paragraph-spacing",
            "xl"
          ]
        },
        "2xl": {
          "key": "{float.type-scale.paragraph-spacing.2xl}",
          "value": "var(--float-type-scale-paragraph-spacing-2xl)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-paragraph-spacing-2xl)",
            "type": "number",
            "key": "{float.type-scale.paragraph-spacing.2xl}"
          },
          "name": "2xl",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "paragraph-spacing",
            "subitem": "2xl"
          },
          "path": [
            "float",
            "type-scale",
            "paragraph-spacing",
            "2xl"
          ]
        }
      },
      "letter-spacing": {
        "sm": {
          "key": "{float.type-scale.letter-spacing.sm}",
          "value": "var(--float-type-scale-letter-spacing-sm)",
          "type": "number",
          "original": {
            "value": "var(--float-type-scale-letter-spacing-sm)",
            "type": "number",
            "key": "{float.type-scale.letter-spacing.sm}"
          },
          "name": "sm",
          "attributes": {
            "category": "float",
            "type": "type-scale",
            "item": "letter-spacing",
            "subitem": "sm"
          },
          "path": [
            "float",
            "type-scale",
            "letter-spacing",
            "sm"
          ]
        }
      }
    },
    "radii": {
      "action": {
        "button": {
          "key": "{float.radii.action.button}",
          "value": "var(--float-radii-action-button)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-action-button)",
            "type": "number",
            "key": "{float.radii.action.button}"
          },
          "name": "button",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "action",
            "subitem": "button"
          },
          "path": [
            "float",
            "radii",
            "action",
            "button"
          ]
        },
        "fab": {
          "key": "{float.radii.action.fab}",
          "value": "var(--float-radii-action-fab)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-action-fab)",
            "type": "number",
            "key": "{float.radii.action.fab}"
          },
          "name": "fab",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "action",
            "subitem": "fab"
          },
          "path": [
            "float",
            "radii",
            "action",
            "fab"
          ]
        }
      },
      "selection": {
        "chips": {
          "key": "{float.radii.selection.chips}",
          "value": "var(--float-radii-selection-chips)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-selection-chips)",
            "type": "number",
            "key": "{float.radii.selection.chips}"
          },
          "name": "chips",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "selection",
            "subitem": "chips"
          },
          "path": [
            "float",
            "radii",
            "selection",
            "chips"
          ]
        },
        "switch": {
          "key": "{float.radii.selection.switch}",
          "value": "var(--float-radii-selection-switch)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-selection-switch)",
            "type": "number",
            "key": "{float.radii.selection.switch}"
          },
          "name": "switch",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "selection",
            "subitem": "switch"
          },
          "path": [
            "float",
            "radii",
            "selection",
            "switch"
          ]
        },
        "radio-selector": {
          "key": "{float.radii.selection.radio-selector}",
          "value": "var(--float-radii-selection-radio-selector)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-selection-radio-selector)",
            "type": "number",
            "key": "{float.radii.selection.radio-selector}"
          },
          "name": "radio-selector",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "selection",
            "subitem": "radio-selector"
          },
          "path": [
            "float",
            "radii",
            "selection",
            "radio-selector"
          ]
        },
        "checkbox": {
          "key": "{float.radii.selection.checkbox}",
          "value": "var(--float-radii-selection-checkbox)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-selection-checkbox)",
            "type": "number",
            "key": "{float.radii.selection.checkbox}"
          },
          "name": "checkbox",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "selection",
            "subitem": "checkbox"
          },
          "path": [
            "float",
            "radii",
            "selection",
            "checkbox"
          ]
        }
      },
      "communication": {
        "banner": {
          "key": "{float.radii.communication.banner}",
          "value": "var(--float-radii-communication-banner)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-communication-banner)",
            "type": "number",
            "key": "{float.radii.communication.banner}"
          },
          "name": "banner",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "communication",
            "subitem": "banner"
          },
          "path": [
            "float",
            "radii",
            "communication",
            "banner"
          ]
        },
        "toast": {
          "key": "{float.radii.communication.toast}",
          "value": "var(--float-radii-communication-toast)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-communication-toast)",
            "type": "number",
            "key": "{float.radii.communication.toast}"
          },
          "name": "toast",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "communication",
            "subitem": "toast"
          },
          "path": [
            "float",
            "radii",
            "communication",
            "toast"
          ]
        },
        "tag": {
          "key": "{float.radii.communication.tag}",
          "value": "var(--float-radii-communication-tag)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-communication-tag)",
            "type": "number",
            "key": "{float.radii.communication.tag}"
          },
          "name": "tag",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "communication",
            "subitem": "tag"
          },
          "path": [
            "float",
            "radii",
            "communication",
            "tag"
          ]
        },
        "tool-tip": {
          "key": "{float.radii.communication.tool-tip}",
          "value": "var(--float-radii-communication-tool-tip)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-communication-tool-tip)",
            "type": "number",
            "key": "{float.radii.communication.tool-tip}"
          },
          "name": "tool-tip",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "communication",
            "subitem": "tool-tip"
          },
          "path": [
            "float",
            "radii",
            "communication",
            "tool-tip"
          ]
        },
        "badge": {
          "key": "{float.radii.communication.badge}",
          "value": "var(--float-radii-communication-badge)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-communication-badge)",
            "type": "number",
            "key": "{float.radii.communication.badge}"
          },
          "name": "badge",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "communication",
            "subitem": "badge"
          },
          "path": [
            "float",
            "radii",
            "communication",
            "badge"
          ]
        },
        "dialog": {
          "key": "{float.radii.communication.dialog}",
          "value": "var(--float-radii-communication-dialog)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-communication-dialog)",
            "type": "number",
            "key": "{float.radii.communication.dialog}"
          },
          "name": "dialog",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "communication",
            "subitem": "dialog"
          },
          "path": [
            "float",
            "radii",
            "communication",
            "dialog"
          ]
        }
      },
      "containment": {
        "card": {
          "key": "{float.radii.containment.card}",
          "value": "var(--float-radii-containment-card)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-containment-card)",
            "type": "number",
            "key": "{float.radii.containment.card}"
          },
          "name": "card",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "containment",
            "subitem": "card"
          },
          "path": [
            "float",
            "radii",
            "containment",
            "card"
          ]
        },
        "menu": {
          "key": "{float.radii.containment.menu}",
          "value": "var(--float-radii-containment-menu)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-containment-menu)",
            "type": "number",
            "key": "{float.radii.containment.menu}"
          },
          "name": "menu",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "containment",
            "subitem": "menu"
          },
          "path": [
            "float",
            "radii",
            "containment",
            "menu"
          ]
        }
      },
      "text-input": {
        "field": {
          "key": "{float.radii.text-input.field}",
          "value": "var(--float-radii-text-input-field)",
          "type": "number",
          "original": {
            "value": "var(--float-radii-text-input-field)",
            "type": "number",
            "key": "{float.radii.text-input.field}"
          },
          "name": "field",
          "attributes": {
            "category": "float",
            "type": "radii",
            "item": "text-input",
            "subitem": "field"
          },
          "path": [
            "float",
            "radii",
            "text-input",
            "field"
          ]
        }
      }
    },
    "stroke-width": {
      "action": {
        "button": {
          "outline": {
            "key": "{float.stroke-width.action.button.outline}",
            "value": "var(--float-stroke-width-action-button-outline)",
            "type": "number",
            "original": {
              "value": "var(--float-stroke-width-action-button-outline)",
              "type": "number",
              "key": "{float.stroke-width.action.button.outline}"
            },
            "name": "outline",
            "attributes": {
              "category": "float",
              "type": "stroke-width",
              "item": "action",
              "subitem": "button",
              "state": "outline"
            },
            "path": [
              "float",
              "stroke-width",
              "action",
              "button",
              "outline"
            ]
          }
        }
      },
      "selection": {
        "checkbox": {
          "key": "{float.stroke-width.selection.checkbox}",
          "value": "var(--float-stroke-width-selection-checkbox)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-checkbox)",
            "type": "number",
            "key": "{float.stroke-width.selection.checkbox}"
          },
          "name": "checkbox",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "checkbox"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "checkbox"
          ]
        },
        "radio-selector": {
          "key": "{float.stroke-width.selection.radio-selector}",
          "value": "var(--float-stroke-width-selection-radio-selector)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-radio-selector)",
            "type": "number",
            "key": "{float.stroke-width.selection.radio-selector}"
          },
          "name": "radio-selector",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "radio-selector"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "radio-selector"
          ]
        },
        "focused": {
          "key": "{float.stroke-width.selection.focused}",
          "value": "var(--float-stroke-width-selection-focused)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-focused)",
            "type": "number",
            "key": "{float.stroke-width.selection.focused}"
          },
          "name": "focused",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "focused"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "focused"
          ]
        },
        "dropdown": {
          "key": "{float.stroke-width.selection.dropdown}",
          "value": "var(--float-stroke-width-selection-dropdown)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-dropdown)",
            "type": "number",
            "key": "{float.stroke-width.selection.dropdown}"
          },
          "name": "dropdown",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "dropdown"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "dropdown"
          ]
        },
        "date-picker": {
          "key": "{float.stroke-width.selection.date-picker}",
          "value": "var(--float-stroke-width-selection-date-picker)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-date-picker)",
            "type": "number",
            "key": "{float.stroke-width.selection.date-picker}"
          },
          "name": "date-picker",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "date-picker"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "date-picker"
          ]
        },
        "chips": {
          "key": "{float.stroke-width.selection.chips}",
          "value": "var(--float-stroke-width-selection-chips)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-chips)",
            "type": "number",
            "key": "{float.stroke-width.selection.chips}"
          },
          "name": "chips",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "chips"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "chips"
          ]
        },
        "switch": {
          "key": "{float.stroke-width.selection.switch}",
          "value": "var(--float-stroke-width-selection-switch)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-selection-switch)",
            "type": "number",
            "key": "{float.stroke-width.selection.switch}"
          },
          "name": "switch",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "selection",
            "subitem": "switch"
          },
          "path": [
            "float",
            "stroke-width",
            "selection",
            "switch"
          ]
        }
      },
      "communication": {
        "tag": {
          "key": "{float.stroke-width.communication.tag}",
          "value": "var(--float-stroke-width-communication-tag)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-communication-tag)",
            "type": "number",
            "key": "{float.stroke-width.communication.tag}"
          },
          "name": "tag",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "communication",
            "subitem": "tag"
          },
          "path": [
            "float",
            "stroke-width",
            "communication",
            "tag"
          ]
        },
        "notifications": {
          "key": "{float.stroke-width.communication.notifications}",
          "value": "var(--float-stroke-width-communication-notifications)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-communication-notifications)",
            "type": "number",
            "key": "{float.stroke-width.communication.notifications}"
          },
          "name": "notifications",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "communication",
            "subitem": "notifications"
          },
          "path": [
            "float",
            "stroke-width",
            "communication",
            "notifications"
          ]
        }
      },
      "text-inputs": {
        "field": {
          "key": "{float.stroke-width.text-inputs.field}",
          "value": "var(--float-stroke-width-text-inputs-field)",
          "type": "number",
          "original": {
            "value": "var(--float-stroke-width-text-inputs-field)",
            "type": "number",
            "key": "{float.stroke-width.text-inputs.field}"
          },
          "name": "field",
          "attributes": {
            "category": "float",
            "type": "stroke-width",
            "item": "text-inputs",
            "subitem": "field"
          },
          "path": [
            "float",
            "stroke-width",
            "text-inputs",
            "field"
          ]
        }
      }
    },
    "elevation": {
      "action": {
        "fab": {
          "potision-x": {
            "key": "{float.elevation.action.fab.potision-x}",
            "value": "var(--float-elevation-action-fab-potision-x)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-action-fab-potision-x)",
              "type": "number",
              "key": "{float.elevation.action.fab.potision-x}"
            },
            "name": "potision-x",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "action",
              "subitem": "fab",
              "state": "potision-x"
            },
            "path": [
              "float",
              "elevation",
              "action",
              "fab",
              "potision-x"
            ]
          },
          "blur": {
            "key": "{float.elevation.action.fab.blur}",
            "value": "var(--float-elevation-action-fab-blur)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-action-fab-blur)",
              "type": "number",
              "key": "{float.elevation.action.fab.blur}"
            },
            "name": "blur",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "action",
              "subitem": "fab",
              "state": "blur"
            },
            "path": [
              "float",
              "elevation",
              "action",
              "fab",
              "blur"
            ]
          },
          "spread": {
            "key": "{float.elevation.action.fab.spread}",
            "value": "var(--float-elevation-action-fab-spread)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-action-fab-spread)",
              "type": "number",
              "key": "{float.elevation.action.fab.spread}"
            },
            "name": "spread",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "action",
              "subitem": "fab",
              "state": "spread"
            },
            "path": [
              "float",
              "elevation",
              "action",
              "fab",
              "spread"
            ]
          },
          "potision-y": {
            "key": "{float.elevation.action.fab.potision-y}",
            "value": "var(--float-elevation-action-fab-potision-y)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-action-fab-potision-y)",
              "type": "number",
              "key": "{float.elevation.action.fab.potision-y}"
            },
            "name": "potision-y",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "action",
              "subitem": "fab",
              "state": "potision-y"
            },
            "path": [
              "float",
              "elevation",
              "action",
              "fab",
              "potision-y"
            ]
          }
        }
      },
      "containment": {
        "menu": {
          "potision-x": {
            "key": "{float.elevation.containment.menu.potision-x}",
            "value": "var(--float-elevation-containment-menu-potision-x)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-menu-potision-x)",
              "type": "number",
              "key": "{float.elevation.containment.menu.potision-x}"
            },
            "name": "potision-x",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "menu",
              "state": "potision-x"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "menu",
              "potision-x"
            ]
          },
          "potision-y": {
            "key": "{float.elevation.containment.menu.potision-y}",
            "value": "var(--float-elevation-containment-menu-potision-y)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-menu-potision-y)",
              "type": "number",
              "key": "{float.elevation.containment.menu.potision-y}"
            },
            "name": "potision-y",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "menu",
              "state": "potision-y"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "menu",
              "potision-y"
            ]
          },
          "blur": {
            "key": "{float.elevation.containment.menu.blur}",
            "value": "var(--float-elevation-containment-menu-blur)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-menu-blur)",
              "type": "number",
              "key": "{float.elevation.containment.menu.blur}"
            },
            "name": "blur",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "menu",
              "state": "blur"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "menu",
              "blur"
            ]
          },
          "spread": {
            "key": "{float.elevation.containment.menu.spread}",
            "value": "var(--float-elevation-containment-menu-spread)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-menu-spread)",
              "type": "number",
              "key": "{float.elevation.containment.menu.spread}"
            },
            "name": "spread",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "menu",
              "state": "spread"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "menu",
              "spread"
            ]
          }
        },
        "card": {
          "enabled": {
            "potision-x": {
              "key": "{float.elevation.containment.card.enabled.potision-x}",
              "value": "var(--float-elevation-containment-card-enabled-potision-x)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-enabled-potision-x)",
                "type": "number",
                "key": "{float.elevation.containment.card.enabled.potision-x}"
              },
              "name": "potision-x",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "enabled"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "enabled",
                "potision-x"
              ]
            },
            "potision-y": {
              "key": "{float.elevation.containment.card.enabled.potision-y}",
              "value": "var(--float-elevation-containment-card-enabled-potision-y)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-enabled-potision-y)",
                "type": "number",
                "key": "{float.elevation.containment.card.enabled.potision-y}"
              },
              "name": "potision-y",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "enabled"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "enabled",
                "potision-y"
              ]
            },
            "blur": {
              "key": "{float.elevation.containment.card.enabled.blur}",
              "value": "var(--float-elevation-containment-card-enabled-blur)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-enabled-blur)",
                "type": "number",
                "key": "{float.elevation.containment.card.enabled.blur}"
              },
              "name": "blur",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "enabled"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "enabled",
                "blur"
              ]
            },
            "spread": {
              "key": "{float.elevation.containment.card.enabled.spread}",
              "value": "var(--float-elevation-containment-card-enabled-spread)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-enabled-spread)",
                "type": "number",
                "key": "{float.elevation.containment.card.enabled.spread}"
              },
              "name": "spread",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "enabled"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "enabled",
                "spread"
              ]
            }
          },
          "hover": {
            "potision-x": {
              "key": "{float.elevation.containment.card.hover.potision-x}",
              "value": "var(--float-elevation-containment-card-hover-potision-x)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-hover-potision-x)",
                "type": "number",
                "key": "{float.elevation.containment.card.hover.potision-x}"
              },
              "name": "potision-x",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "hover"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "hover",
                "potision-x"
              ]
            },
            "potision-y": {
              "key": "{float.elevation.containment.card.hover.potision-y}",
              "value": "var(--float-elevation-containment-card-hover-potision-y)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-hover-potision-y)",
                "type": "number",
                "key": "{float.elevation.containment.card.hover.potision-y}"
              },
              "name": "potision-y",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "hover"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "hover",
                "potision-y"
              ]
            },
            "blur": {
              "key": "{float.elevation.containment.card.hover.blur}",
              "value": "var(--float-elevation-containment-card-hover-blur)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-hover-blur)",
                "type": "number",
                "key": "{float.elevation.containment.card.hover.blur}"
              },
              "name": "blur",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "hover"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "hover",
                "blur"
              ]
            },
            "spread": {
              "key": "{float.elevation.containment.card.hover.spread}",
              "value": "var(--float-elevation-containment-card-hover-spread)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-hover-spread)",
                "type": "number",
                "key": "{float.elevation.containment.card.hover.spread}"
              },
              "name": "spread",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "hover"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "hover",
                "spread"
              ]
            }
          },
          "selected": {
            "potision-x": {
              "key": "{float.elevation.containment.card.selected.potision-x}",
              "value": "var(--float-elevation-containment-card-selected-potision-x)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-selected-potision-x)",
                "type": "number",
                "key": "{float.elevation.containment.card.selected.potision-x}"
              },
              "name": "potision-x",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "selected"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "selected",
                "potision-x"
              ]
            },
            "potision-y": {
              "key": "{float.elevation.containment.card.selected.potision-y}",
              "value": "var(--float-elevation-containment-card-selected-potision-y)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-selected-potision-y)",
                "type": "number",
                "key": "{float.elevation.containment.card.selected.potision-y}"
              },
              "name": "potision-y",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "selected"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "selected",
                "potision-y"
              ]
            },
            "blur": {
              "key": "{float.elevation.containment.card.selected.blur}",
              "value": "var(--float-elevation-containment-card-selected-blur)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-selected-blur)",
                "type": "number",
                "key": "{float.elevation.containment.card.selected.blur}"
              },
              "name": "blur",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "selected"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "selected",
                "blur"
              ]
            },
            "spread": {
              "key": "{float.elevation.containment.card.selected.spread}",
              "value": "var(--float-elevation-containment-card-selected-spread)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-selected-spread)",
                "type": "number",
                "key": "{float.elevation.containment.card.selected.spread}"
              },
              "name": "spread",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "selected"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "selected",
                "spread"
              ]
            }
          },
          "dragged": {
            "potision-x": {
              "key": "{float.elevation.containment.card.dragged.potision-x}",
              "value": "var(--float-elevation-containment-card-dragged-potision-x)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-dragged-potision-x)",
                "type": "number",
                "key": "{float.elevation.containment.card.dragged.potision-x}"
              },
              "name": "potision-x",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "dragged"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "dragged",
                "potision-x"
              ]
            },
            "potision-y": {
              "key": "{float.elevation.containment.card.dragged.potision-y}",
              "value": "var(--float-elevation-containment-card-dragged-potision-y)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-dragged-potision-y)",
                "type": "number",
                "key": "{float.elevation.containment.card.dragged.potision-y}"
              },
              "name": "potision-y",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "dragged"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "dragged",
                "potision-y"
              ]
            },
            "blur": {
              "key": "{float.elevation.containment.card.dragged.blur}",
              "value": "var(--float-elevation-containment-card-dragged-blur)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-dragged-blur)",
                "type": "number",
                "key": "{float.elevation.containment.card.dragged.blur}"
              },
              "name": "blur",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "dragged"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "dragged",
                "blur"
              ]
            },
            "spread": {
              "key": "{float.elevation.containment.card.dragged.spread}",
              "value": "var(--float-elevation-containment-card-dragged-spread)",
              "type": "number",
              "original": {
                "value": "var(--float-elevation-containment-card-dragged-spread)",
                "type": "number",
                "key": "{float.elevation.containment.card.dragged.spread}"
              },
              "name": "spread",
              "attributes": {
                "category": "float",
                "type": "elevation",
                "item": "containment",
                "subitem": "card",
                "state": "dragged"
              },
              "path": [
                "float",
                "elevation",
                "containment",
                "card",
                "dragged",
                "spread"
              ]
            }
          }
        },
        "dialog": {
          "potision-x": {
            "key": "{float.elevation.containment.dialog.potision-x}",
            "value": "var(--float-elevation-containment-dialog-potision-x)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-dialog-potision-x)",
              "type": "number",
              "key": "{float.elevation.containment.dialog.potision-x}"
            },
            "name": "potision-x",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "dialog",
              "state": "potision-x"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "dialog",
              "potision-x"
            ]
          },
          "potision-y": {
            "key": "{float.elevation.containment.dialog.potision-y}",
            "value": "var(--float-elevation-containment-dialog-potision-y)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-dialog-potision-y)",
              "type": "number",
              "key": "{float.elevation.containment.dialog.potision-y}"
            },
            "name": "potision-y",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "dialog",
              "state": "potision-y"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "dialog",
              "potision-y"
            ]
          },
          "blur": {
            "key": "{float.elevation.containment.dialog.blur}",
            "value": "var(--float-elevation-containment-dialog-blur)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-dialog-blur)",
              "type": "number",
              "key": "{float.elevation.containment.dialog.blur}"
            },
            "name": "blur",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "dialog",
              "state": "blur"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "dialog",
              "blur"
            ]
          },
          "spread": {
            "key": "{float.elevation.containment.dialog.spread}",
            "value": "var(--float-elevation-containment-dialog-spread)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-containment-dialog-spread)",
              "type": "number",
              "key": "{float.elevation.containment.dialog.spread}"
            },
            "name": "spread",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "containment",
              "subitem": "dialog",
              "state": "spread"
            },
            "path": [
              "float",
              "elevation",
              "containment",
              "dialog",
              "spread"
            ]
          }
        }
      },
      "communication": {
        "toast": {
          "potision-x": {
            "key": "{float.elevation.communication.toast.potision-x}",
            "value": "var(--float-elevation-communication-toast-potision-x)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-toast-potision-x)",
              "type": "number",
              "key": "{float.elevation.communication.toast.potision-x}"
            },
            "name": "potision-x",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "toast",
              "state": "potision-x"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "toast",
              "potision-x"
            ]
          },
          "potision-y": {
            "key": "{float.elevation.communication.toast.potision-y}",
            "value": "var(--float-elevation-communication-toast-potision-y)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-toast-potision-y)",
              "type": "number",
              "key": "{float.elevation.communication.toast.potision-y}"
            },
            "name": "potision-y",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "toast",
              "state": "potision-y"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "toast",
              "potision-y"
            ]
          },
          "blur": {
            "key": "{float.elevation.communication.toast.blur}",
            "value": "var(--float-elevation-communication-toast-blur)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-toast-blur)",
              "type": "number",
              "key": "{float.elevation.communication.toast.blur}"
            },
            "name": "blur",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "toast",
              "state": "blur"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "toast",
              "blur"
            ]
          },
          "spread": {
            "key": "{float.elevation.communication.toast.spread}",
            "value": "var(--float-elevation-communication-toast-spread)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-toast-spread)",
              "type": "number",
              "key": "{float.elevation.communication.toast.spread}"
            },
            "name": "spread",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "toast",
              "state": "spread"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "toast",
              "spread"
            ]
          }
        },
        "snack-bar": {
          "potision-x": {
            "key": "{float.elevation.communication.snack-bar.potision-x}",
            "value": "var(--float-elevation-communication-snack-bar-potision-x)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-snack-bar-potision-x)",
              "type": "number",
              "key": "{float.elevation.communication.snack-bar.potision-x}"
            },
            "name": "potision-x",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "snack-bar",
              "state": "potision-x"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "snack-bar",
              "potision-x"
            ]
          },
          "potision-y": {
            "key": "{float.elevation.communication.snack-bar.potision-y}",
            "value": "var(--float-elevation-communication-snack-bar-potision-y)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-snack-bar-potision-y)",
              "type": "number",
              "key": "{float.elevation.communication.snack-bar.potision-y}"
            },
            "name": "potision-y",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "snack-bar",
              "state": "potision-y"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "snack-bar",
              "potision-y"
            ]
          },
          "blur": {
            "key": "{float.elevation.communication.snack-bar.blur}",
            "value": "var(--float-elevation-communication-snack-bar-blur)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-snack-bar-blur)",
              "type": "number",
              "key": "{float.elevation.communication.snack-bar.blur}"
            },
            "name": "blur",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "snack-bar",
              "state": "blur"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "snack-bar",
              "blur"
            ]
          },
          "spread": {
            "key": "{float.elevation.communication.snack-bar.spread}",
            "value": "var(--float-elevation-communication-snack-bar-spread)",
            "type": "number",
            "original": {
              "value": "var(--float-elevation-communication-snack-bar-spread)",
              "type": "number",
              "key": "{float.elevation.communication.snack-bar.spread}"
            },
            "name": "spread",
            "attributes": {
              "category": "float",
              "type": "elevation",
              "item": "communication",
              "subitem": "snack-bar",
              "state": "spread"
            },
            "path": [
              "float",
              "elevation",
              "communication",
              "snack-bar",
              "spread"
            ]
          }
        }
      }
    },
    "proportion": {
      "2": {
        "key": "{float.proportion.2}",
        "value": "var(--float-proportion-2)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-2)",
          "type": "number",
          "key": "{float.proportion.2}"
        },
        "name": "2",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "2"
        },
        "path": [
          "float",
          "proportion",
          "2"
        ]
      },
      "3": {
        "key": "{float.proportion.3}",
        "value": "var(--float-proportion-3)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-3)",
          "type": "number",
          "key": "{float.proportion.3}"
        },
        "name": "3",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "3"
        },
        "path": [
          "float",
          "proportion",
          "3"
        ]
      },
      "4": {
        "key": "{float.proportion.4}",
        "value": "var(--float-proportion-4)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-4)",
          "type": "number",
          "key": "{float.proportion.4}"
        },
        "name": "4",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "4"
        },
        "path": [
          "float",
          "proportion",
          "4"
        ]
      },
      "5": {
        "key": "{float.proportion.5}",
        "value": "var(--float-proportion-5)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-5)",
          "type": "number",
          "key": "{float.proportion.5}"
        },
        "name": "5",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "5"
        },
        "path": [
          "float",
          "proportion",
          "5"
        ]
      },
      "6": {
        "key": "{float.proportion.6}",
        "value": "var(--float-proportion-6)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-6)",
          "type": "number",
          "key": "{float.proportion.6}"
        },
        "name": "6",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "6"
        },
        "path": [
          "float",
          "proportion",
          "6"
        ]
      },
      "25": {
        "key": "{float.proportion.25}",
        "value": "var(--float-proportion-25)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-25)",
          "type": "number",
          "key": "{float.proportion.25}"
        },
        "name": "25",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "25"
        },
        "path": [
          "float",
          "proportion",
          "25"
        ]
      },
      "50": {
        "key": "{float.proportion.50}",
        "value": "var(--float-proportion-50)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-50)",
          "type": "number",
          "key": "{float.proportion.50}"
        },
        "name": "50",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "50"
        },
        "path": [
          "float",
          "proportion",
          "50"
        ]
      },
      "75": {
        "key": "{float.proportion.75}",
        "value": "var(--float-proportion-75)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-75)",
          "type": "number",
          "key": "{float.proportion.75}"
        },
        "name": "75",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "75"
        },
        "path": [
          "float",
          "proportion",
          "75"
        ]
      },
      "125": {
        "key": "{float.proportion.125}",
        "value": "var(--float-proportion-125)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-125)",
          "type": "number",
          "key": "{float.proportion.125}"
        },
        "name": "125",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "125"
        },
        "path": [
          "float",
          "proportion",
          "125"
        ]
      },
      "1-default-unit": {
        "key": "{float.proportion.1-default-unit}",
        "value": "var(--float-proportion-1-default-unit)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-1-default-unit)",
          "type": "number",
          "key": "{float.proportion.1-default-unit}"
        },
        "name": "1-default-unit",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "1-default-unit"
        },
        "path": [
          "float",
          "proportion",
          "1-default-unit"
        ]
      },
      "1-50": {
        "key": "{float.proportion.1-50}",
        "value": "var(--float-proportion-1-50)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-1-50)",
          "type": "number",
          "key": "{float.proportion.1-50}"
        },
        "name": "1-50",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "1-50"
        },
        "path": [
          "float",
          "proportion",
          "1-50"
        ]
      },
      "2-50": {
        "key": "{float.proportion.2-50}",
        "value": "var(--float-proportion-2-50)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-2-50)",
          "type": "number",
          "key": "{float.proportion.2-50}"
        },
        "name": "2-50",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "2-50"
        },
        "path": [
          "float",
          "proportion",
          "2-50"
        ]
      },
      "zero": {
        "key": "{float.proportion.zero}",
        "value": "var(--float-proportion-zero)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-zero)",
          "type": "number",
          "key": "{float.proportion.zero}"
        },
        "name": "zero",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "zero"
        },
        "path": [
          "float",
          "proportion",
          "zero"
        ]
      },
      "6-50": {
        "key": "{float.proportion.6-50}",
        "value": "var(--float-proportion-6-50)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-6-50)",
          "type": "number",
          "key": "{float.proportion.6-50}"
        },
        "name": "6-50",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "6-50"
        },
        "path": [
          "float",
          "proportion",
          "6-50"
        ]
      },
      "4-50": {
        "key": "{float.proportion.4-50}",
        "value": "var(--float-proportion-4-50)",
        "type": "number",
        "original": {
          "value": "var(--float-proportion-4-50)",
          "type": "number",
          "key": "{float.proportion.4-50}"
        },
        "name": "4-50",
        "attributes": {
          "category": "float",
          "type": "proportion",
          "item": "4-50"
        },
        "path": [
          "float",
          "proportion",
          "4-50"
        ]
      }
    },
    "opacity": {
      "background": {
        "enabled": {
          "key": "{float.opacity.background.enabled}",
          "value": "var(--float-opacity-background-enabled)",
          "type": "number",
          "original": {
            "value": "var(--float-opacity-background-enabled)",
            "type": "number",
            "key": "{float.opacity.background.enabled}"
          },
          "name": "enabled",
          "attributes": {
            "category": "float",
            "type": "opacity",
            "item": "background",
            "subitem": "enabled"
          },
          "path": [
            "float",
            "opacity",
            "background",
            "enabled"
          ]
        },
        "hover": {
          "key": "{float.opacity.background.hover}",
          "value": "var(--float-opacity-background-hover)",
          "type": "number",
          "original": {
            "value": "var(--float-opacity-background-hover)",
            "type": "number",
            "key": "{float.opacity.background.hover}"
          },
          "name": "hover",
          "attributes": {
            "category": "float",
            "type": "opacity",
            "item": "background",
            "subitem": "hover"
          },
          "path": [
            "float",
            "opacity",
            "background",
            "hover"
          ]
        },
        "pressed": {
          "key": "{float.opacity.background.pressed}",
          "value": "var(--float-opacity-background-pressed)",
          "type": "number",
          "original": {
            "value": "var(--float-opacity-background-pressed)",
            "type": "number",
            "key": "{float.opacity.background.pressed}"
          },
          "name": "pressed",
          "attributes": {
            "category": "float",
            "type": "opacity",
            "item": "background",
            "subitem": "pressed"
          },
          "path": [
            "float",
            "opacity",
            "background",
            "pressed"
          ]
        },
        "selected": {
          "key": "{float.opacity.background.selected}",
          "value": "var(--float-opacity-background-selected)",
          "type": "number",
          "original": {
            "value": "var(--float-opacity-background-selected)",
            "type": "number",
            "key": "{float.opacity.background.selected}"
          },
          "name": "selected",
          "attributes": {
            "category": "float",
            "type": "opacity",
            "item": "background",
            "subitem": "selected"
          },
          "path": [
            "float",
            "opacity",
            "background",
            "selected"
          ]
        }
      }
    }
  },
  "string": {
    "typography": {
      "expressive": {
        "key": "{string.typography.expressive}",
        "value": "var(--string-typography-expressive)",
        "type": "string",
        "original": {
          "value": "var(--string-typography-expressive)",
          "type": "string",
          "key": "{string.typography.expressive}"
        },
        "name": "expressive",
        "attributes": {
          "category": "string",
          "type": "typography",
          "item": "expressive"
        },
        "path": [
          "string",
          "typography",
          "expressive"
        ]
      },
      "productive": {
        "key": "{string.typography.productive}",
        "value": "var(--string-typography-productive)",
        "type": "string",
        "original": {
          "value": "var(--string-typography-productive)",
          "type": "string",
          "key": "{string.typography.productive}"
        },
        "name": "productive",
        "attributes": {
          "category": "string",
          "type": "typography",
          "item": "productive"
        },
        "path": [
          "string",
          "typography",
          "productive"
        ]
      }
    }
  }
} as const;

export const getTokens = () => tokens;

export default tokens;
